window.theme = window.theme || {};
window.slate = window.slate || {};
this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};

if (window.theme.settings.devMode) {
	console.log("Dev Mode");
}

theme.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	document.addEventListener(
		"shopify:section:load",
		this._onSectionLoad.bind(this)
	);
	document.addEventListener(
		"shopify:section:unload",
		this._onSectionUnload.bind(this)
	);
	document.addEventListener(
		"shopify:section:select",
		this._onSelect.bind(this)
	);
	document.addEventListener(
		"shopify:section:deselect",
		this._onDeselect.bind(this)
	);
	document.addEventListener(
		"shopify:block:select",
		this._onBlockSelect.bind(this)
	);
	document.addEventListener(
		"shopify:block:deselect",
		this._onBlockDeselect.bind(this)
	);
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
	_createInstance: function (container, constructor) {
		var id = container.getAttribute("data-section-id");
		var type = container.getAttribute("data-section-type");

		constructor = constructor || this.constructors[type];

		if (typeof constructor === "undefined") {
			return;
		}

		var instance = Object.assign(new constructor(container), {
			id: id,
			type: type,
			container: container,
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function (evt) {
		var container = document.querySelector(
			'[data-section-id="' + evt.detail.sectionId + '"]'
		);

		if (container) {
			this._createInstance(container);
		}
		resetLozad();
		resetScrollReveal();
	},

	_onSectionUnload: function (evt) {
		this.instances = this.instances.filter(function (instance) {
			var isEventInstance = instance.id === evt.detail.sectionId;

			if (isEventInstance) {
				if (typeof instance.onUnload === "function") {
					instance.onUnload(evt);
				}
			}

			return !isEventInstance;
		});
	},

	_onSelect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = this.instances.find(function (instance) {
			return instance.id === evt.detail.sectionId;
		});

		if (
			typeof instance !== "undefined" &&
			typeof instance.onSelect === "function"
		) {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = this.instances.find(function (instance) {
			return instance.id === evt.detail.sectionId;
		});

		if (
			typeof instance !== "undefined" &&
			typeof instance.onDeselect === "function"
		) {
			instance.onDeselect(evt);
		}
	},

	_onBlockSelect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = this.instances.find(function (instance) {
			return instance.id === evt.detail.sectionId;
		});

		if (
			typeof instance !== "undefined" &&
			typeof instance.onBlockSelect === "function"
		) {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = this.instances.find(function (instance) {
			return instance.id === evt.detail.sectionId;
		});

		if (
			typeof instance !== "undefined" &&
			typeof instance.onBlockDeselect === "function"
		) {
			instance.onBlockDeselect(evt);
		}
	},

	register: function (type, constructor) {
		this.constructors[type] = constructor;

		document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
			function (container) {
				this._createInstance(container, constructor);
			}.bind(this)
		);
	},
});

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
	/**
	 * Get the query params in a Url
	 * Ex
	 * https://mysite.com/search?q=noodles&b
	 * getParameterByName('q') = "noodles"
	 * getParameterByName('b') = "" (empty value)
	 * getParameterByName('test') = null (absent)
	 */
	getParameterByName: function (name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	},

	resizeSelects: function (selects) {
		selects.forEach(function (select) {
			var arrowWidth = 55;

			var test = document.createElement("span");
			test.innerHTML = select.selectedOptions[0].label;

			document.querySelector("footer").appendChild(test);

			var width = test.offsetWidth + arrowWidth;
			test.remove();

			select.style.width = width + "px";
		});
	},

	keyboardKeys: {
		TAB: 9,
		ENTER: 13,
		ESCAPE: 27,
		LEFTARROW: 37,
		RIGHTARROW: 39,
	},
};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {NodeList} options.tables - Elements of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTable: function (options) {
		options.tables.forEach(function (table) {
			var wrapper = document.createElement("div");
			wrapper.classList.add(options.tableWrapperClass);

			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		});
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function (options) {
		options.iframes.forEach(function (iframe) {
			var wrapper = document.createElement("div");
			wrapper.classList.add(options.iframeWrapperClass);

			iframe.parentNode.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);

			iframe.src = iframe.src;
		});
	},
};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
	state: {
		firstFocusable: null,
		lastFocusable: null,
	},
	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects
	 *
	 * @param {HTMLElement} element - The element to be acted upon
	 */
	pageLinkFocus: function (element) {
		if (!element) return;
		var focusClass = "js-focus-hidden";

		element.setAttribute("tabIndex", "-1");
		element.focus();
		element.classList.add(focusClass);
		element.addEventListener("blur", callback, { once: true });

		function callback() {
			element.classList.remove(focusClass);
			element.removeAttribute("tabindex");
		}
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {HTMLElement} options.container - Container to trap focus within
	 * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
	 */
	trapFocus: function (options) {
		var focusableElements = Array.from(
			options.container.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
			)
		).filter(function (element) {
			var width = element.offsetWidth;
			var height = element.offsetHeight;

			return (
				width !== 0 &&
				height !== 0 &&
				getComputedStyle(element).getPropertyValue("display") !== "none"
			);
		});

		this.state.firstFocusable = focusableElements[0];
		this.state.lastFocusable = focusableElements[focusableElements.length - 1];

		if (!options.elementToFocus) {
			options.elementToFocus = options.container;
		}

		options.container.setAttribute("tabindex", "-1");
		options.elementToFocus.focus();

		this._setupHandlers();

		document.addEventListener("focusin", this._onFocusInHandler);
		document.addEventListener("focusout", this._onFocusOutHandler);
	},

	_setupHandlers: function () {
		if (!this._onFocusInHandler) {
			this._onFocusInHandler = this._onFocusIn.bind(this);
		}

		if (!this._onFocusOutHandler) {
			this._onFocusOutHandler = this._onFocusIn.bind(this);
		}

		if (!this._manageFocusHandler) {
			this._manageFocusHandler = this._manageFocus.bind(this);
		}
	},

	_onFocusOut: function () {
		document.removeEventListener("keydown", this._manageFocusHandler);
	},

	_onFocusIn: function (evt) {
		if (
			evt.target !== this.state.lastFocusable &&
			evt.target !== this.state.firstFocusable
		)
			return;

		document.addEventListener("keydown", this._manageFocusHandler);
	},

	_manageFocus: function (evt) {
		if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

		/**
		 * On the last focusable element and tab forward,
		 * focus the first element.
		 */
		if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
			evt.preventDefault();
			this.state.firstFocusable.focus();
		}
		/**
		 * On the first focusable element and tab backward,
		 * focus the last element.
		 */
		if (evt.target === this.state.firstFocusable && evt.shiftKey) {
			evt.preventDefault();
			this.state.lastFocusable.focus();
		}
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {HTMLElement} options.container - Container to trap focus within
	 */
	removeTrapFocus: function (options) {
		if (options.container) {
			options.container.removeAttribute("tabindex");
		}
		document.removeEventListener("focusin", this._onFocusInHandler);
	},

	/**
	 * Add aria-describedby attribute to external and new window links
	 *
	 * @param {object} options - Options to be used
	 * @param {object} options.messages - Custom messages to be used
	 * @param {HTMLElement} options.links - Specific links to be targeted
	 */
	accessibleLinks: function (options) {
		var body = document.querySelector("body");

		var idSelectors = {
			newWindow: "a11y-new-window-message",
			external: "a11y-external-message",
			newWindowExternal: "a11y-new-window-external-message",
		};

		if (options.links === undefined || !options.links.length) {
			options.links = document.querySelectorAll(
				"a[href]:not([aria-describedby])"
			);
		}

		function generateHTML(customMessages) {
			if (typeof customMessages !== "object") {
				customMessages = {};
			}

			var messages = Object.assign(
				{
					newWindow: "Opens in a new window.",
					external: "Opens external website.",
					newWindowExternal: "Opens external website in a new window.",
				},
				customMessages
			);

			var container = document.createElement("ul");
			var htmlMessages = "";

			for (var message in messages) {
				htmlMessages +=
					"<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
			}

			container.setAttribute("hidden", true);
			container.innerHTML = htmlMessages;

			body.appendChild(container);
		}

		function _externalSite(link) {
			var hostname = window.location.hostname;

			return link.hostname !== hostname;
		}

		options.links.forEach(function (link) {
			var target = link.getAttribute("target");
			var rel = link.getAttribute("rel");
			var isExternal = _externalSite(link);
			var isTargetBlank = target === "_blank";

			if (isExternal) {
				link.setAttribute("aria-describedby", idSelectors.external);
			}

			if (isTargetBlank) {
				if (!rel || rel.indexOf("noopener") === -1) {
					var relValue = rel === undefined ? "" : rel + " ";
					relValue = relValue + "noopener";
					link.setAttribute("rel", relValue);
				}

				link.setAttribute("aria-describedby", idSelectors.newWindow);
			}

			if (isExternal && isTargetBlank) {
				link.setAttribute("aria-describedby", idSelectors.newWindowExternal);
			}
		});

		generateHTML(options.messages);
	},
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === "string") {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Swaps the src of an image for another OR returns the imageURL to the callback function
	 * @param image
	 * @param element
	 * @param callback
	 */
	function switchImage(image, element, callback) {
		var size = this.imageSize(element.src);
		var imageUrl = this.getSizedImageUrl(image.src, size);

		if (callback) {
			callback(imageUrl, image, element); // eslint-disable-line callback-return
		} else {
			element.src = imageUrl;
		}
	}

	/**
	 * +++ Useful
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(
			/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
		);

		if (match !== null) {
			if (match[2] !== undefined) {
				return match[1] + match[2];
			} else {
				return match[1];
			}
		} else {
			return null;
		}
	}

	/**
	 * +++ Useful
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === "master") {
			return this.removeProtocol(src);
		}

		var match = src.match(
			/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
		);

		if (match !== null) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + "_" + size + suffix);
		}

		return null;
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, "");
	}

	return {
		preload: preload,
		loadImage: loadImage,
		switchImage: switchImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol,
	};
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
	var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

	function formatMoney(cents, format) {
		if (typeof cents === "string") {
			cents = cents.replace(".", "");
		}
		var value = "";
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ",";
			decimal = decimal || ".";

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split(".");
			var dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				"$1" + thousands
			);
			var centsAmount = parts[1] ? decimal + parts[1] : "";

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case "amount":
				value = formatWithDelimiters(cents, 2);
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ");
				break;
			case "amount_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney,
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.container = options.container;
		this.product = options.product;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.singleOptions = this.container.querySelectorAll(
			options.singleOptionSelector
		);
		this.currentVariant = this._getVariantFromOptions();

		this.singleOptions.forEach(
			function (option) {
				option.addEventListener("change", this._onSelectChange.bind(this));
			}.bind(this)
		);
	}

	Variants.prototype = Object.assign({}, Variants.prototype, {
		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function () {
			var result = [];

			this.singleOptions.forEach(function (option) {
				var type = option.getAttribute("type");
				var isRadioOrCheckbox = type === "radio" || type === "checkbox";

				if (!isRadioOrCheckbox || option.checked) {
					result.push({
						value: option.value,
						index: option.getAttribute("data-index"),
					});
				}
			});

			return result;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function () {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;

			var found = variants.find(function (variant) {
				return selectedValues.every(function (values) {
					return variant[values.index] === values.value;
				});
			});

			return found;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function () {
			var variant = this._getVariantFromOptions();

			this.container.dispatchEvent(
				new CustomEvent("variantChange", {
					detail: {
						variant: variant,
					},
					bubbles: true,
					cancelable: true,
				})
			);

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this._updateSKU(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function (variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (
				!variant.featured_image ||
				variantImage.src === currentVariantImage.src
			) {
				return;
			}

			this.container.dispatchEvent(
				new CustomEvent("variantImageChange", {
					detail: {
						variant: variant,
					},
					bubbles: true,
					cancelable: true,
				})
			);
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function (variant) {
			if (
				variant.price === this.currentVariant.price &&
				variant.compare_at_price === this.currentVariant.compare_at_price
			) {
				return;
			}

			this.container.dispatchEvent(
				new CustomEvent("variantPriceChange", {
					detail: {
						variant: variant,
					},
					bubbles: true,
					cancelable: true,
				})
			);
		},

		/**
		 * Trigger event when variant sku changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantSKUChange
		 */
		_updateSKU: function (variant) {
			if (variant.sku === this.currentVariant.sku) {
				return;
			}

			this.container.dispatchEvent(
				new CustomEvent("variantSKUChange", {
					detail: {
						variant: variant,
					},
					bubbles: true,
					cancelable: true,
				})
			);
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param  {variant} variant - Currently selected variant
		 * @return {k}         [description]
		 */
		_updateHistoryState: function (variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl =
				window.location.protocol +
				"//" +
				window.location.host +
				window.location.pathname +
				"?variant=" +
				variant.id;
			window.history.replaceState({ path: newurl }, "", newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param  {variant} variant - Currently selected variant
		 */
		_updateMasterSelect: function (variant) {
			var masterSelect = this.container.querySelector(this.originalSelectorId);

			if (!masterSelect) return;
			masterSelect.value = variant.id;
		},
	});

	return Variants;
})();

this.Shopify.theme.PredictiveSearch = (function () {
	"use strict";

	function validateQuery(query) {
		var error;

		if (query === null || query === undefined) {
			error = new TypeError("'query' is missing");
			error.type = "argument";
			throw error;
		}

		if (typeof query !== "string") {
			error = new TypeError("'query' is not a string");
			error.type = "argument";
			throw error;
		}
	}

	function GenericError() {
		var error = Error.call(this);

		error.name = "Server error";
		error.message = "Something went wrong on the server";
		error.status = 500;

		return error;
	}

	function NotFoundError(status) {
		var error = Error.call(this);

		error.name = "Not found";
		error.message = "Not found";
		error.status = status;

		return error;
	}

	function ServerError() {
		var error = Error.call(this);

		error.name = "Server error";
		error.message = "Something went wrong on the server";
		error.status = 500;

		return error;
	}

	function ContentTypeError(status) {
		var error = Error.call(this);

		error.name = "Content-Type error";
		error.message = "Content-Type was not provided or is of wrong type";
		error.status = status;

		return error;
	}

	function JsonParseError(status) {
		var error = Error.call(this);

		error.name = "JSON parse error";
		error.message = "JSON syntax error";
		error.status = status;

		return error;
	}

	function ThrottledError(status, name, message, retryAfter) {
		var error = Error.call(this);

		error.name = name;
		error.message = message;
		error.status = status;
		error.retryAfter = retryAfter;

		return error;
	}

	function InvalidParameterError(status, name, message) {
		var error = Error.call(this);

		error.name = name;
		error.message = message;
		error.status = status;

		return error;
	}

	function ExpectationFailedError(status, name, message) {
		var error = Error.call(this);

		error.name = name;
		error.message = message;
		error.status = status;

		return error;
	}

	function request(configParams, query, onSuccess, onError) {
		var xhr = new XMLHttpRequest();

		xhr.onreadystatechange = function () {
			if (xhr.readyState !== XMLHttpRequest.DONE) {
				return;
			}

			var contentType = xhr.getResponseHeader("Content-Type");

			if (xhr.status >= 500) {
				onError(new ServerError());

				return;
			}

			if (xhr.status === 404) {
				onError(new NotFoundError(xhr.status));

				return;
			}

			if (
				typeof contentType !== "string" ||
				contentType.toLowerCase().match("application/json") === null
			) {
				onError(new ContentTypeError(xhr.status));

				return;
			}

			if (xhr.status === 417) {
				try {
					var invalidParameterJson = JSON.parse(xhr.responseText);

					onError(
						new InvalidParameterError(
							xhr.status,
							invalidParameterJson.message,
							invalidParameterJson.description
						)
					);
				} catch (error) {
					onError(new JsonParseError(xhr.status));
				}

				return;
			}

			if (xhr.status === 422) {
				try {
					var expectationFailedJson = JSON.parse(xhr.responseText);

					onError(
						new ExpectationFailedError(
							xhr.status,
							expectationFailedJson.message,
							expectationFailedJson.description
						)
					);
				} catch (error) {
					onError(new JsonParseError(xhr.status));
				}

				return;
			}

			if (xhr.status === 429) {
				try {
					var throttledJson = JSON.parse(xhr.responseText);

					onError(
						new ThrottledError(
							xhr.status,
							throttledJson.message,
							throttledJson.description,
							xhr.getResponseHeader("Retry-After")
						)
					);
				} catch (error) {
					onError(new JsonParseError(xhr.status));
				}

				return;
			}

			if (xhr.status === 200) {
				try {
					var res = JSON.parse(xhr.responseText);
					res.query = query;
					onSuccess(res);
				} catch (error) {
					onError(new JsonParseError(xhr.status));
				}

				return;
			}

			try {
				var genericErrorJson = JSON.parse(xhr.responseText);
				onError(
					new GenericError(
						xhr.status,
						genericErrorJson.message,
						genericErrorJson.description
					)
				);
			} catch (error) {
				onError(new JsonParseError(xhr.status));
			}

			return;
		};

		xhr.open(
			"get",
			"/search/suggest.json?q=" + encodeURIComponent(query) + "&" + configParams
		);

		xhr.setRequestHeader("Content-Type", "application/json");

		xhr.send();
	}

	function Cache(config) {
		this._store = {};
		this._keys = [];
		if (config && config.bucketSize) {
			this.bucketSize = config.bucketSize;
		} else {
			this.bucketSize = 20;
		}
	}

	Cache.prototype.set = function (key, value) {
		if (this.count() >= this.bucketSize) {
			var deleteKey = this._keys.splice(0, 1);
			this.delete(deleteKey);
		}

		this._keys.push(key);
		this._store[key] = value;

		return this._store;
	};

	Cache.prototype.get = function (key) {
		return this._store[key];
	};

	Cache.prototype.has = function (key) {
		return Boolean(this._store[key]);
	};

	Cache.prototype.count = function () {
		return Object.keys(this._store).length;
	};

	Cache.prototype.delete = function (key) {
		var exists = Boolean(this._store[key]);
		delete this._store[key];
		return exists && !this._store[key];
	};

	function Dispatcher() {
		this.events = {};
	}

	Dispatcher.prototype.on = function (eventName, callback) {
		var event = this.events[eventName];
		if (!event) {
			event = new DispatcherEvent(eventName);
			this.events[eventName] = event;
		}
		event.registerCallback(callback);
	};

	Dispatcher.prototype.off = function (eventName, callback) {
		var event = this.events[eventName];
		if (event && event.callbacks.indexOf(callback) > -1) {
			event.unregisterCallback(callback);
			if (event.callbacks.length === 0) {
				delete this.events[eventName];
			}
		}
	};

	Dispatcher.prototype.dispatch = function (eventName, payload) {
		var event = this.events[eventName];
		if (event) {
			event.fire(payload);
		}
	};

	function DispatcherEvent(eventName) {
		this.eventName = eventName;
		this.callbacks = [];
	}

	DispatcherEvent.prototype.registerCallback = function (callback) {
		this.callbacks.push(callback);
	};

	DispatcherEvent.prototype.unregisterCallback = function (callback) {
		var index = this.callbacks.indexOf(callback);
		if (index > -1) {
			this.callbacks.splice(index, 1);
		}
	};

	DispatcherEvent.prototype.fire = function (payload) {
		var callbacks = this.callbacks.slice(0);
		callbacks.forEach(function (callback) {
			callback(payload);
		});
	};

	function debounce(func, wait) {
		var timeout = null;
		return function () {
			var context = this;
			var args = arguments;
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				timeout = null;
				func.apply(context, args);
			}, wait || 0);
		};
	}

	function objectToQueryParams(obj, parentKey) {
		var output = "";
		parentKey = parentKey || null;

		Object.keys(obj).forEach(function (key) {
			var outputKey = key + "=";
			if (parentKey) {
				outputKey = parentKey + "[" + key + "]";
			}

			switch (trueTypeOf(obj[key])) {
				case "object":
					output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
					break;
				case "array":
					output += outputKey + "=" + obj[key].join(",") + "&";
					break;
				default:
					if (parentKey) {
						outputKey += "=";
					}
					output += outputKey + encodeURIComponent(obj[key]) + "&";
					break;
			}
		});

		return output;
	}

	function trueTypeOf(obj) {
		return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
	}

	var DEBOUNCE_RATE = 10;
	var requestDebounced = debounce(request, DEBOUNCE_RATE);

	function PredictiveSearch(config) {
		if (!config) {
			throw new TypeError("No config object was specified");
		}

		this._retryAfter = null;
		this._currentQuery = null;

		this.dispatcher = new Dispatcher();
		this.cache = new Cache({ bucketSize: 40 });
		this.configParams = objectToQueryParams(config);
	}

	PredictiveSearch.TYPES = {
		PRODUCT: "product",
		PAGE: "page",
		ARTICLE: "article",
	};

	PredictiveSearch.FIELDS = {
		AUTHOR: "author",
		BODY: "body",
		PRODUCT_TYPE: "product_type",
		TAG: "tag",
		TITLE: "title",
		VARIANTS_BARCODE: "variants.barcode",
		VARIANTS_SKU: "variants.sku",
		VARIANTS_TITLE: "variants.title",
		VENDOR: "vendor",
	};

	PredictiveSearch.UNAVAILABLE_PRODUCTS = {
		SHOW: "show",
		HIDE: "hide",
		LAST: "last",
	};

	PredictiveSearch.prototype.query = function query(query) {
		try {
			validateQuery(query);
		} catch (error) {
			this.dispatcher.dispatch("error", error);
			return;
		}

		if (query === "") {
			return this;
		}

		this._currentQuery = normalizeQuery(query);
		var cacheResult = this.cache.get(this._currentQuery);
		if (cacheResult) {
			this.dispatcher.dispatch("success", cacheResult);
			return this;
		}

		requestDebounced(
			this.configParams,
			query,
			function (result) {
				this.cache.set(normalizeQuery(result.query), result);
				if (normalizeQuery(result.query) === this._currentQuery) {
					this._retryAfter = null;
					this.dispatcher.dispatch("success", result);
				}
			}.bind(this),
			function (error) {
				if (error.retryAfter) {
					this._retryAfter = error.retryAfter;
				}
				this.dispatcher.dispatch("error", error);
			}.bind(this)
		);

		return this;
	};

	PredictiveSearch.prototype.on = function on(eventName, callback) {
		this.dispatcher.on(eventName, callback);

		return this;
	};

	PredictiveSearch.prototype.off = function on(eventName, callback) {
		this.dispatcher.off(eventName, callback);

		return this;
	};

	function normalizeQuery(query) {
		if (typeof query !== "string") {
			return null;
		}

		return query.trim().replace(" ", "-").toLowerCase();
	}

	return PredictiveSearch;
})();

this.Shopify.theme.PredictiveSearchComponent = (function (PredictiveSearch) {
	"use strict";

	PredictiveSearch =
		PredictiveSearch && PredictiveSearch.hasOwnProperty("default")
			? PredictiveSearch["default"]
			: PredictiveSearch;

	var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
		resources: {
			type: [PredictiveSearch.TYPES.PRODUCT],
			options: {
				unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
				fields: [
					PredictiveSearch.FIELDS.TITLE,
					PredictiveSearch.FIELDS.VENDOR,
					PredictiveSearch.FIELDS.PRODUCT_TYPE,
					PredictiveSearch.FIELDS.VARIANTS_TITLE,
				],
			},
		},
	};

	function PredictiveSearchComponent(config) {
		// validate config
		if (
			!config ||
			!config.selectors ||
			!config.selectors.input ||
			!isString(config.selectors.input) ||
			!config.selectors.result ||
			!isString(config.selectors.result) ||
			!config.resultTemplateFct ||
			!isFunction(config.resultTemplateFct) ||
			!config.numberOfResultsTemplateFct ||
			!isFunction(config.numberOfResultsTemplateFct) ||
			!config.loadingResultsMessageTemplateFct ||
			!isFunction(config.loadingResultsMessageTemplateFct)
		) {
			var error = new TypeError(
				"PredictiveSearchComponent config is not valid"
			);
			error.type = "argument";
			throw error;
		}

		// Find nodes
		this.nodes = findNodes(config.selectors);

		// Validate nodes
		if (!isValidNodes(this.nodes)) {
			// eslint-disable-next-line no-console
			console.warn("Could not find valid nodes");
			return;
		}

		// Store the keyword that was used for the search
		this._searchKeyword = "";

		// Assign result template
		this.resultTemplateFct = config.resultTemplateFct;

		// Assign number of results template
		this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

		// Assign loading state template function
		this.loadingResultsMessageTemplateFct =
			config.loadingResultsMessageTemplateFct;

		// Assign number of search results
		this.numberOfResults = config.numberOfResults || 4;

		// Set classes
		this.classes = {
			visibleVariant: config.visibleVariant
				? config.visibleVariant
				: "predictive-search-wrapper--visible",
			itemSelected: config.itemSelectedClass
				? config.itemSelectedClass
				: "predictive-search-item--selected",
		};

		this.selectors = {
			searchResult: config.searchResult
				? config.searchResult
				: "[data-search-result]",
		};

		// Assign callbacks
		this.callbacks = assignCallbacks(config);

		// Add input attributes
		addInputAttributes(this.nodes.input);

		// Add input event listeners
		this._addInputEventListeners();

		// Add body listener
		this._addBodyEventListener();

		// Add accessibility announcer
		this._addAccessibilityAnnouncer();

		// Display the reset button if the input is not empty
		this._toggleClearButtonVisibility();

		// Instantiate Predictive Search API
		this.predictiveSearch = new PredictiveSearch(
			config.PredictiveSearchAPIConfig
				? config.PredictiveSearchAPIConfig
				: DEFAULT_PREDICTIVE_SEARCH_API_CONFIG
		);

		// Add predictive search success event listener
		this.predictiveSearch.on(
			"success",
			this._handlePredictiveSearchSuccess.bind(this)
		);

		// Add predictive search error event listener
		this.predictiveSearch.on(
			"error",
			this._handlePredictiveSearchError.bind(this)
		);
	}

	/**
	 * Private methods
	 */
	function findNodes(selectors) {
		return {
			input: document.querySelector(selectors.input),
			reset: document.querySelector(selectors.reset),
			result: document.querySelector(selectors.result),
		};
	}

	function isValidNodes(nodes) {
		if (
			!nodes ||
			!nodes.input ||
			!nodes.result ||
			nodes.input.tagName !== "INPUT"
		) {
			return false;
		}

		return true;
	}

	function assignCallbacks(config) {
		return {
			onBodyMousedown: config.onBodyMousedown,
			onBeforeOpen: config.onBeforeOpen,
			onOpen: config.onOpen,
			onBeforeClose: config.onBeforeClose,
			onClose: config.onClose,
			onInputFocus: config.onInputFocus,
			onInputKeyup: config.onInputKeyup,
			onInputBlur: config.onInputBlur,
			onInputReset: config.onInputReset,
			onBeforeDestroy: config.onBeforeDestroy,
			onDestroy: config.onDestroy,
		};
	}

	function addInputAttributes(input) {
		input.setAttribute("autocorrect", "off");
		input.setAttribute("autocomplete", "off");
		input.setAttribute("autocapitalize", "off");
		input.setAttribute("spellcheck", "false");
	}

	function removeInputAttributes(input) {
		input.removeAttribute("autocorrect", "off");
		input.removeAttribute("autocomplete", "off");
		input.removeAttribute("autocapitalize", "off");
		input.removeAttribute("spellcheck", "false");
	}

	/**
	 * Public variables
	 */
	PredictiveSearchComponent.prototype.isResultVisible = false;
	PredictiveSearchComponent.prototype.results = {};

	/**
	 * "Private" variables
	 */
	PredictiveSearchComponent.prototype._latencyTimer = null;
	PredictiveSearchComponent.prototype._resultNodeClicked = false;

	/**
	 * "Private" instance methods
	 */
	PredictiveSearchComponent.prototype._addInputEventListeners = function () {
		var input = this.nodes.input;
		var reset = this.nodes.reset;

		if (!input) {
			return;
		}

		this._handleInputFocus = this._handleInputFocus.bind(this);
		this._handleInputBlur = this._handleInputBlur.bind(this);
		this._handleInputKeyup = this._handleInputKeyup.bind(this);
		this._handleInputKeydown = this._handleInputKeydown.bind(this);

		input.addEventListener("focus", this._handleInputFocus);
		input.addEventListener("blur", this._handleInputBlur);
		input.addEventListener("keyup", this._handleInputKeyup);
		input.addEventListener("keydown", this._handleInputKeydown);

		if (reset) {
			this._handleInputReset = this._handleInputReset.bind(this);
			reset.addEventListener("click", this._handleInputReset);
		}
	};

	PredictiveSearchComponent.prototype._removeInputEventListeners = function () {
		var input = this.nodes.input;

		input.removeEventListener("focus", this._handleInputFocus);
		input.removeEventListener("blur", this._handleInputBlur);
		input.removeEventListener("keyup", this._handleInputKeyup);
		input.removeEventListener("keydown", this._handleInputKeydown);
	};

	PredictiveSearchComponent.prototype._addBodyEventListener = function () {
		this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

		document
			.querySelector("body")
			.addEventListener("mousedown", this._handleBodyMousedown);
	};

	PredictiveSearchComponent.prototype._removeBodyEventListener = function () {
		document
			.querySelector("body")
			.removeEventListener("mousedown", this._handleBodyMousedown);
	};

	PredictiveSearchComponent.prototype._removeClearButtonEventListener = function () {
		var reset = this.nodes.reset;

		if (!reset) {
			return;
		}

		reset.removeEventListener("click", this._handleInputReset);
	};

	/**
	 * Event handlers
	 */
	PredictiveSearchComponent.prototype._handleBodyMousedown = function (evt) {
		if (this.isResultVisible && this.nodes !== null) {
			if (
				evt.target.isEqualNode(this.nodes.input) ||
				this.nodes.input.contains(evt.target) ||
				evt.target.isEqualNode(this.nodes.result) ||
				this.nodes.result.contains(evt.target)
			) {
				this._resultNodeClicked = true;
			} else {
				if (isFunction(this.callbacks.onBodyMousedown)) {
					var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
					if (isBoolean(returnedValue) && returnedValue) {
						this.close();
					}
				} else {
					this.close();
				}
			}
		}
	};

	PredictiveSearchComponent.prototype._handleInputFocus = function (evt) {
		if (isFunction(this.callbacks.onInputFocus)) {
			var returnedValue = this.callbacks.onInputFocus(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		if (evt.target.value.length > 0) {
			this._search();
		}

		return true;
	};

	PredictiveSearchComponent.prototype._handleInputBlur = function () {
		// This has to be done async, to wait for the focus to be on the next
		// element and avoid closing the results.
		// Example: Going from the input to the reset button.
		setTimeout(
			function () {
				if (isFunction(this.callbacks.onInputBlur)) {
					var returnedValue = this.callbacks.onInputBlur(this.nodes);
					if (isBoolean(returnedValue) && !returnedValue) {
						return false;
					}
				}

				if (document.activeElement.isEqualNode(this.nodes.reset)) {
					return false;
				}

				if (this._resultNodeClicked) {
					this._resultNodeClicked = false;
					return false;
				}

				this.close();
			}.bind(this)
		);

		return true;
	};

	PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function () {
		this._accessibilityAnnouncerDiv = window.document.createElement("div");

		this._accessibilityAnnouncerDiv.setAttribute(
			"style",
			"position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"
		);

		this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer", "");
		this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite");
		this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true");

		this.nodes.result.parentElement.appendChild(
			this._accessibilityAnnouncerDiv
		);
	};

	PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function () {
		this.nodes.result.parentElement.removeChild(
			this._accessibilityAnnouncerDiv
		);
	};

	PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function (
		previousSelectedElement,
		currentSelectedElement
	) {
		// Update the active descendant on the search input
		this.nodes.input.setAttribute(
			"aria-activedescendant",
			currentSelectedElement.id
		);

		// Unmark the previousSelected elemented as selected
		if (previousSelectedElement) {
			previousSelectedElement.removeAttribute("aria-selected");
		}

		// Mark the element as selected
		currentSelectedElement.setAttribute("aria-selected", true);
	};

	PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function () {
		this.nodes.input.setAttribute("aria-activedescendant", "");
	};

	PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function (
		results
	) {
		var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
		var newMessage = this.numberOfResultsTemplateFct(results);

		// If the messages are the same, they won't get announced
		// add white space so it gets announced
		if (currentAnnouncedMessage === newMessage) {
			newMessage = newMessage + "&nbsp;";
		}

		this._accessibilityAnnouncerDiv.innerHTML = newMessage;
	};

	PredictiveSearchComponent.prototype._announceLoadingState = function () {
		this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
	};

	PredictiveSearchComponent.prototype._handleInputKeyup = function (evt) {
		var UP_ARROW_KEY_CODE = 38;
		var DOWN_ARROW_KEY_CODE = 40;
		var RETURN_KEY_CODE = 13;
		var ESCAPE_KEY_CODE = 27;

		if (isFunction(this.callbacks.onInputKeyup)) {
			var returnedValue = this.callbacks.onInputKeyup(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		this._toggleClearButtonVisibility();

		if (this.isResultVisible && this.nodes !== null) {
			if (evt.keyCode === UP_ARROW_KEY_CODE) {
				this._navigateOption(evt, "UP");
				return true;
			}

			if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
				this._navigateOption(evt, "DOWN");
				return true;
			}

			if (evt.keyCode === RETURN_KEY_CODE) {
				this._selectOption();
				return true;
			}

			if (evt.keyCode === ESCAPE_KEY_CODE) {
				this.close();
			}
		}

		if (evt.target.value.length <= 0) {
			this.close();
			this._setKeyword("");
		} else if (evt.target.value.length > 0) {
			this._search();
		}

		return true;
	};

	PredictiveSearchComponent.prototype._handleInputKeydown = function (evt) {
		var RETURN_KEY_CODE = 13;
		var UP_ARROW_KEY_CODE = 38;
		var DOWN_ARROW_KEY_CODE = 40;

		// Prevent the form default submission if there is a selected option
		if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
			evt.preventDefault();
		}

		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (
			evt.keyCode === UP_ARROW_KEY_CODE ||
			evt.keyCode === DOWN_ARROW_KEY_CODE
		) {
			evt.preventDefault();
		}
	};

	PredictiveSearchComponent.prototype._handleInputReset = function (evt) {
		evt.preventDefault();

		if (isFunction(this.callbacks.onInputReset)) {
			var returnedValue = this.callbacks.onInputReset(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		this.nodes.input.value = "";
		this.nodes.input.focus();
		this._toggleClearButtonVisibility();
		this.close();

		return true;
	};

	PredictiveSearchComponent.prototype._navigateOption = function (
		evt,
		direction
	) {
		var currentOption = this._getSelectedOption();

		if (!currentOption) {
			var firstOption = this.nodes.result.querySelector(
				this.selectors.searchResult
			);
			firstOption.classList.add(this.classes.itemSelected);
			this._updateAccessibilityAttributesAfterSelectingElement(
				null,
				firstOption
			);
		} else {
			if (direction === "DOWN") {
				var nextOption = currentOption.nextElementSibling;
				if (nextOption) {
					currentOption.classList.remove(this.classes.itemSelected);
					nextOption.classList.add(this.classes.itemSelected);
					this._updateAccessibilityAttributesAfterSelectingElement(
						currentOption,
						nextOption
					);
				}
			} else {
				var previousOption = currentOption.previousElementSibling;
				if (previousOption) {
					currentOption.classList.remove(this.classes.itemSelected);
					previousOption.classList.add(this.classes.itemSelected);
					this._updateAccessibilityAttributesAfterSelectingElement(
						currentOption,
						previousOption
					);
				}
			}
		}
	};

	PredictiveSearchComponent.prototype._getSelectedOption = function () {
		return this.nodes.result.querySelector("." + this.classes.itemSelected);
	};

	PredictiveSearchComponent.prototype._selectOption = function () {
		var selectedOption = this._getSelectedOption();

		if (selectedOption) {
			selectedOption.querySelector("a, button").click();
		}
	};

	PredictiveSearchComponent.prototype._search = function () {
		var newSearchKeyword = this.nodes.input.value;

		if (this._searchKeyword === newSearchKeyword) {
			return;
		}

		clearTimeout(this._latencyTimer);
		this._latencyTimer = setTimeout(
			function () {
				this.results.isLoading = true;

				// Annonuce that we're loading the results
				this._announceLoadingState();

				this.nodes.result.classList.add(this.classes.visibleVariant);
				// NOTE: We could benifit in using DOMPurify.
				// https://github.com/cure53/DOMPurify
				this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
			}.bind(this),
			500
		);

		this.predictiveSearch.query(newSearchKeyword);
		this._setKeyword(newSearchKeyword);
	};

	PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function (
		json
	) {
		clearTimeout(this._latencyTimer);
		this.results = json.resources.results;

		this.results.isLoading = false;
		this.results.products = this.results.products.slice(
			0,
			this.numberOfResults
		);
		this.results.canLoadMore =
			this.numberOfResults <= this.results.products.length;
		this.results.searchQuery = this.nodes.input.value;

		if (this.results.products.length > 0 || this.results.searchQuery) {
			this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
			this._announceNumberOfResultsFound(this.results);
			this.open();
		} else {
			this.nodes.result.innerHTML = "";

			this._closeOnNoResults();
		}
	};

	PredictiveSearchComponent.prototype._handlePredictiveSearchError = function () {
		clearTimeout(this._latencyTimer);
		this.nodes.result.innerHTML = "";

		this._closeOnNoResults();
	};

	PredictiveSearchComponent.prototype._closeOnNoResults = function () {
		if (this.nodes) {
			this.nodes.result.classList.remove(this.classes.visibleVariant);
		}

		this.isResultVisible = false;
	};

	PredictiveSearchComponent.prototype._setKeyword = function (keyword) {
		this._searchKeyword = keyword;
	};

	PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function () {
		if (!this.nodes.reset) {
			return;
		}

		if (this.nodes.input.value.length > 0) {
			this.nodes.reset.classList.remove("invisible");
		} else {
			this.nodes.reset.classList.add("invisible");
		}
	};

	/**
	 * Public methods
	 */
	PredictiveSearchComponent.prototype.open = function () {
		if (this.isResultVisible) {
			return;
		}

		if (isFunction(this.callbacks.onBeforeOpen)) {
			var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		this.nodes.result.classList.add(this.classes.visibleVariant);
		this.nodes.input.setAttribute("aria-expanded", true);
		this.isResultVisible = true;

		if (isFunction(this.callbacks.onOpen)) {
			return this.callbacks.onOpen(this.nodes) || true;
		}

		return true;
	};

	PredictiveSearchComponent.prototype.close = function () {
		if (!this.isResultVisible) {
			return true;
		}

		if (isFunction(this.callbacks.onBeforeClose)) {
			var returnedValue = this.callbacks.onBeforeClose(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		if (this.nodes) {
			this.nodes.result.classList.remove(this.classes.visibleVariant);
		}

		this.nodes.input.setAttribute("aria-expanded", false);
		this._clearAriaActiveDescendant();
		this._setKeyword("");

		if (isFunction(this.callbacks.onClose)) {
			this.callbacks.onClose(this.nodes);
		}

		this.isResultVisible = false;
		this.results = {};

		return true;
	};

	PredictiveSearchComponent.prototype.destroy = function () {
		this.close();

		if (isFunction(this.callbacks.onBeforeDestroy)) {
			var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
			if (isBoolean(returnedValue) && !returnedValue) {
				return false;
			}
		}

		this.nodes.result.classList.remove(this.classes.visibleVariant);
		removeInputAttributes(this.nodes.input);
		this._removeInputEventListeners();
		this._removeBodyEventListener();
		this._removeAccessibilityAnnouncer();
		this._removeClearButtonEventListener();

		if (isFunction(this.callbacks.onDestroy)) {
			this.callbacks.onDestroy(this.nodes);
		}

		return true;
	};

	PredictiveSearchComponent.prototype.clearAndClose = function () {
		this.nodes.input.value = "";
		this.close();
	};

	/**
	 * Utilities
	 */
	function getTypeOf(value) {
		return Object.prototype.toString.call(value);
	}

	function isString(value) {
		return getTypeOf(value) === "[object String]";
	}

	function isBoolean(value) {
		return getTypeOf(value) === "[object Boolean]";
	}

	function isFunction(value) {
		return getTypeOf(value) === "[object Function]";
	}

	return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

(function () {
	// (a11y) This function will be used by the Predictive Search Component
	// to announce the number of search results
	function numberOfResultsTemplateFct(data) {
		if (data.products.length === 1) {
			return theme.strings.one_result_found;
		} else {
			return theme.strings.number_of_results_found.replace(
				"[results_count]",
				data.products.length
			);
		}
	}

	// (a11y) This function will be used by the Predictive Search Component
	// to announce that it's loading results
	function loadingResultsMessageTemplateFct() {
		return theme.strings.loading;
	}

	function isPredictiveSearchSupported() {
		var shopifyFeatures = JSON.parse(
			document.getElementById("shopify-features").textContent
		);

		return shopifyFeatures.predictiveSearch;
	}

	function isPredictiveSearchEnabled() {
		return window.theme.settings.predictiveSearchEnabled;
	}

	function canInitializePredictiveSearch() {
		return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
	}

	// listen for search submits and validate query
	function validateSearchHandler(searchEl, submitEl) {
		submitEl.addEventListener(
			"click",
			validateSearchInput.bind(this, searchEl)
		);
	}

	// if there is nothing in the search field, prevent submit
	function validateSearchInput(searchEl, evt) {
		var isInputValueEmpty = searchEl.value.trim().length === 0;
		if (!isInputValueEmpty) {
			return;
		}

		if (typeof evt !== "undefined") {
			evt.preventDefault();
		}

		searchEl.focus();
	}

	window.theme.SearchPage = (function () {
		var selectors = {
			searchReset: "[data-search-page-predictive-search-clear]",
			searchInput: "[data-search-page-predictive-search-input]",
			searchSubmit: "[data-search-page-predictive-search-submit]",
			searchResults: '[data-predictive-search-mount="default"]',
		};

		var componentInstance;
		var searchInput = document.querySelector(selectors.searchInput);
		var searchSubmit = document.querySelector(selectors.searchSubmit);

		function init(config) {
			componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
				selectors: {
					input: selectors.searchInput,
					reset: selectors.searchReset,
					result: selectors.searchResults,
				},
				resultTemplateFct: window.theme.SearchResultsTemplate,
				numberOfResultsTemplateFct: numberOfResultsTemplateFct,
				loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
				onOpen: function (nodes) {
					if (config.isTabletAndUp) {
						return;
					}

					var searchInputBoundingRect = searchInput.getBoundingClientRect();
					var bodyHeight = document.body.offsetHeight;
					var offset = 50;
					var resultsMaxHeight =
						bodyHeight - searchInputBoundingRect.bottom - offset;

					nodes.result.style.maxHeight = resultsMaxHeight + "px";
				},
				onBeforeDestroy: function (nodes) {
					// If the viewport width changes from mobile to tablet
					// reset the top position of the results
					nodes.result.style.maxHeight = "";
				},
			});

			validateSearchHandler(searchInput, searchSubmit);
		}

		function unload() {
			if (!componentInstance) {
				return;
			}
			componentInstance.destroy();
			componentInstance = null;
		}

		return {
			init: init,
			unload: unload,
		};
	})();

	window.theme.SearchHeader = (function () {
		var selectors = {
			searchInput: "[data-predictive-search-drawer-input]",
			searchResults: '[data-predictive-search-mount="drawer"]',
			searchFormContainer: "[data-search-form-container]",
			searchSubmit: "[data-search-form-submit]",
		};

		var componentInstance;
		var searchInput = document.querySelector(selectors.searchInput);
		var searchSubmit = document.querySelector(selectors.searchSubmit);

		function init(config) {
			componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
				selectors: {
					input: selectors.searchInput,
					result: selectors.searchResults,
				},
				resultTemplateFct: window.theme.SearchResultsTemplate,
				numberOfResultsTemplateFct: numberOfResultsTemplateFct,
				numberOfResults: config.numberOfResults,
				loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
				onInputBlur: function () {
					return false;
				},
				onOpen: function (nodes) {
					var searchInputBoundingRect = searchInput.getBoundingClientRect();

					// For tablet screens and up, stop the scroll area from extending past
					// the bottom of the screen because we're locking the body scroll
					var maxHeight =
						window.innerHeight -
						searchInputBoundingRect.bottom -
						(config.isTabletAndUp ? 20 : 0);

					nodes.result.style.top = config.isTabletAndUp
						? ""
						: searchInputBoundingRect.bottom + "px";
					nodes.result.style.maxHeight = maxHeight + "px";
				},
				onClose: function (nodes) {
					nodes.result.style.maxHeight = "";
				},
				onBeforeDestroy: function (nodes) {
					// If the viewport width changes from mobile to tablet
					// reset the top position of the results
					nodes.result.style.top = "";
				},
			});

			validateSearchHandler(searchInput, searchSubmit);
		}

		function unload() {
			if (!componentInstance) {
				return;
			}

			componentInstance.destroy();
			componentInstance = null;
		}

		function clearAndClose() {
			if (!componentInstance) {
				return;
			}

			componentInstance.clearAndClose();
		}

		return {
			init: init,
			unload: unload,
			clearAndClose: clearAndClose,
		};
	})();

	window.theme.Search = (function () {
		var classes = {
			searchTemplate: "template-search",
		};
		var selectors = {
			siteHeader: "[data-header]",
		};
		var mediaQueryList = {
			mobile: window.matchMedia("(max-width: 749px)"),
			tabletAndUp: window.matchMedia("(min-width: 750px)"),
		};

		function init() {
			if (!document.querySelector(selectors.siteHeader)) {
				return;
			}

			if (!canInitializePredictiveSearch()) {
				return;
			}

			Object.keys(mediaQueryList).forEach(function (device) {
				mediaQueryList[device].addListener(initSearchAccordingToViewport);
			});

			initSearchAccordingToViewport();
		}

		function initSearchAccordingToViewport() {
			theme.SearchDrawer.close();
			theme.SearchHeader.unload();
			theme.SearchPage.unload();

			if (mediaQueryList.mobile.matches) {
				theme.SearchHeader.init({
					numberOfResults: 4,
					isTabletAndUp: false,
				});

				if (isSearchPage()) {
					theme.SearchPage.init({ isTabletAndUp: false });
				}
			} else {
				// Tablet and up
				theme.SearchHeader.init({
					numberOfResults: 4,
					isTabletAndUp: true,
				});

				if (isSearchPage()) {
					theme.SearchPage.init({ isTabletAndUp: true });
				}
			}
		}

		function isSearchPage() {
			return document.body.classList.contains(classes.searchTemplate);
		}

		function unload() {
			theme.SearchHeader.unload();
			theme.SearchPage.unload();
		}

		return {
			init: init,
			unload: unload,
		};
	})();
})();

theme.SearchDrawer = (function () {
	var selectors = {
		headerSection: "[data-header-section]",
		drawer: "[data-predictive-search-drawer]",
		drawerOpenButton: "[data-predictive-search-open-drawer]",
		headerSearchInput: "[data-predictive-search-drawer-input]",
		predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]',
	};

	var drawerInstance;

	function init() {
		setAccessibilityProps();

		drawerInstance = new theme.Drawers("SearchDrawer", "top", {
			onDrawerOpen: function () {
				setHeight();
				theme.MobileNav.closeMobileNav();
				lockBodyScroll();
			},
			onDrawerClose: function () {
				theme.SearchHeader.clearAndClose();
				var drawerOpenButton = document.querySelector(
					selectors.drawerOpenButton
				);

				if (drawerOpenButton) drawerOpenButton.focus();

				unlockBodyScroll();
			},
			withPredictiveSearch: true,
			elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput),
		});
	}

	function setAccessibilityProps() {
		var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

		if (drawerOpenButton) {
			drawerOpenButton.setAttribute("aria-controls", "SearchDrawer");
			drawerOpenButton.setAttribute("aria-expanded", "false");
			drawerOpenButton.setAttribute("aria-controls", "dialog");
		}
	}

	function setHeight() {
		var searchDrawer = document.querySelector(selectors.drawer);
		var headerHeight = document.querySelector(selectors.headerSection)
			.offsetHeight;

		// searchDrawer.style.height = headerHeight + "px";
	}

	function close() {
		drawerInstance.close();
	}

	function lockBodyScroll() {
		theme.Helpers.enableScrollLock();
	}

	function unlockBodyScroll() {
		theme.Helpers.disableScrollLock();
	}

	return {
		init: init,
		close: close,
	};
})();

theme.TouchEvents = function TouchEvents(element, options) {
	this.axis;
	this.checkEvents = [];
	this.eventHandlers = {};
	this.eventModel = {};
	this.events = [
		["touchstart", "touchmove", "touchend", "touchcancel"],
		["pointerdown", "pointermove", "pointerup", "pointercancel"],
		["mousedown", "mousemove", "mouseup"],
	];
	this.eventType;
	this.difference = {};
	this.direction;
	this.start = {};

	this.element = element;
	this.options = Object.assign(
		{},
		{
			dragThreshold: 10,
			start: function () {}, // eslint-disable-line
			move: function () {}, // eslint-disable-line
			end: function () {}, // eslint-disable-line
		},
		options
	);

	this.checkEvents = this._getCheckEvents();
	this.eventModel = this._getEventModel();

	this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
	destroy: function () {
		this.element.removeEventListener(
			"dragstart",
			this.eventHandlers.preventDefault
		);

		this.element.removeEventListener(
			this.events[this.eventModel][0],
			this.eventHandlers.touchStart
		);

		if (!this.eventModel) {
			this.element.removeEventListener(
				this.events[2][0],
				this.eventHandlers.touchStart
			);
		}

		this.element.removeEventListener("click", this.eventHandlers.preventClick);
	},

	_setupEventHandlers: function () {
		this.eventHandlers.preventDefault = this._preventDefault.bind(this);
		this.eventHandlers.preventClick = this._preventClick.bind(this);
		this.eventHandlers.touchStart = this._touchStart.bind(this);
		this.eventHandlers.touchMove = this._touchMove.bind(this);
		this.eventHandlers.touchEnd = this._touchEnd.bind(this);

		// Prevent element from dragging when using mouse
		this.element.addEventListener(
			"dragstart",
			this.eventHandlers.preventDefault
		);

		// Bind the touchstart/pointerdown event
		this.element.addEventListener(
			this.events[this.eventModel][0],
			this.eventHandlers.touchStart,
			{ passive: true }
		);

		// Bind mousedown if necessary
		if (!this.eventModel) {
			this.element.addEventListener(
				this.events[2][0],
				this.eventHandlers.touchStart
			);
		}

		// No clicking during touch
		this.element.addEventListener("click", this.eventHandlers.preventClick);
	},

	_touchStart: function (event) {
		this.eventType = this.eventModel;

		if (event.type === "mousedown" && !this.eventModel) {
			this.eventType = 2;
		}

		if (this.checkEvents[this.eventType](event)) return;
		if (this.eventType) this._preventDefault(event);

		document.addEventListener(
			this.events[this.eventType][1],
			this.eventHandlers.touchMove
		);

		document.addEventListener(
			this.events[this.eventType][2],
			this.eventHandlers.touchEnd
		);

		if (this.eventType < 2) {
			document.addEventListener(
				this.events[this.eventType][3],
				this.eventHandlers.touchEnd
			);
		}

		this.start = {
			xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
			yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
			time: new Date().getTime(),
		};

		// Ensure we empty out the this.difference object
		Object.keys(this.difference).forEach(
			function (key) {
				delete this.difference[key];
			}.bind(this)
		);

		this.options.start(event);
	},

	_touchMove: function (event) {
		this.difference = this._getDifference(event);

		// Prevent document from scrolling during swipe gesture
		document["on" + this.events[this.eventType][1]] = function (event) {
			this._preventDefault(event);
		}.bind(this);

		// Get the direction user is dragging
		if (!this.axis) {
			if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
				this.axis = "xPosition";
			} else if (
				this.options.dragThreshold < Math.abs(this.difference.yPosition)
			) {
				this.axis = "yPosition";
			} else {
				this.axis = false;
			}
		} else if (this.axis === "xPosition") {
			this.direction = this.difference.xPosition < 0 ? "left" : "right";
		} else if (this.axis === "yPosition") {
			this.direction = this.difference.yPosition < 0 ? "up" : "down";
		}

		this.options.move(event, this.direction, this.difference);
	},

	_touchEnd: function (event) {
		document.removeEventListener(
			this.events[this.eventType][1],
			this.eventHandlers.touchMove
		);

		document.removeEventListener(
			this.events[this.eventType][2],
			this.eventHandlers.touchEnd
		);

		if (this.eventType < 2) {
			document.removeEventListener(
				this.events[this.eventType][3],
				this.eventHandlers.touchEnd
			);
		}

		// Re-enable document scrolling
		document["on" + this.events[this.eventType][1]] = function () {
			return true;
		};

		this.options.end(event, this.direction, this.difference);
		this.axis = false;
	},

	_getDifference: function (event) {
		return {
			xPosition:
				(this.eventType ? event.clientX : event.touches[0].clientX) -
				this.start.xPosition,
			yPosition:
				(this.eventType ? event.clientY : event.touches[0].clientY) -
				this.start.yPosition,
			time: new Date().getTime() - this.start.time,
		};
	},

	_getCheckEvents: function () {
		return [
			// Touch events
			function (event) {
				// Skip the event if it's a multi-touch or pinch move
				return (
					(event.touches && event.touches.length > 1) ||
					(event.scale && event.scale !== 1)
				);
			},
			// Pointer events
			function (event) {
				// Skip it, if:
				// 1. The event is not primary (other pointers during multi-touch),
				// 2. Left mouse button is not pressed,
				// 3. Event is not a touch event
				return (
					!event.isPrimary ||
					(event.buttons && event.buttons !== 1) ||
					(event.pointerType !== "touch" && event.pointerType !== "pen")
				);
			},
			// Mouse events
			function (event) {
				// Skip the event if left mouse button is not pressed
				return event.buttons && event.buttons !== 1;
			},
		];
	},

	_getEventModel: function () {
		return window.navigator.pointerEnabled ? 1 : 0;
	},

	_preventDefault: function (event) {
		event.preventDefault ? event.preventDefault() : (event.returnValue = false);
	},

	_preventClick: function (event) {
		if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
			this._preventDefault(event);
		}
	},
});

theme.Drawers = (function () {
	function Drawer(id, position, options) {
		var DEFAULT_OPEN_CLASS = "js-drawer-open";
		var DEFAULT_CLOSE_CLASS = "js-drawer-close";

		var defaults = {
			selectors: {
				openVariant: "." + DEFAULT_OPEN_CLASS + "-" + position,
				close: "." + DEFAULT_CLOSE_CLASS,
			},
			classes: {
				open: DEFAULT_OPEN_CLASS,
				openVariant: DEFAULT_OPEN_CLASS + "-" + position,
			},
			withPredictiveSearch: false,
		};

		this.nodes = {
			parents: [document.documentElement, document.body],
			page: document.getElementById("PageContainer"),
		};

		this.eventHandlers = {};

		this.config = Object.assign({}, defaults, options);
		this.position = position;
		this.drawer = document.getElementById(id);

		if (!this.drawer) {
			return false;
		}

		this.drawerIsOpen = false;
		this.init();
	}

	Drawer.prototype.init = function () {
		document
			.querySelector(this.config.selectors.openVariant)
			.addEventListener("click", this.open.bind(this));
		this.drawer
			.querySelector(this.config.selectors.close)
			.addEventListener("click", this.close.bind(this));
	};

	Drawer.prototype.open = function (evt) {
		// Keep track if drawer was opened from a click, or called by another function
		var externalCall = false;

		// Prevent following href if link is clicked
		if (evt) {
			evt.preventDefault();
		} else {
			externalCall = true;
		}

		// Without this, the drawer opens, the click event bubbles up to nodes.page
		// which closes the drawer.
		if (evt && evt.stopPropagation) {
			evt.stopPropagation();
			// save the source of the click, we'll focus to this on close
			this.activeSource = evt.currentTarget;
		}

		if (this.drawerIsOpen && !externalCall) {
			return this.close();
		}

		// Add is-transitioning class to moved elements on open so drawer can have
		// transition for close animation
		if (!this.config.withPredictiveSearch) {
			theme.Helpers.prepareTransition(this.drawer);
		}

		this.nodes.parents.forEach(
			function (parent) {
				parent.classList.add(
					this.config.classes.open,
					this.config.classes.openVariant
				);
			}.bind(this)
		);

		this.drawerIsOpen = true;

		// Run function when draw opens if set
		if (
			this.config.onDrawerOpen &&
			typeof this.config.onDrawerOpen === "function"
		) {
			if (!externalCall) {
				this.config.onDrawerOpen();
			}
		}

		if (this.activeSource && this.activeSource.hasAttribute("aria-expanded")) {
			this.activeSource.setAttribute("aria-expanded", "true");
		}

		// Set focus on drawer
		var trapFocusConfig = {
			container: this.drawer,
		};

		if (this.config.elementToFocusOnOpen) {
			trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
		}

		slate.a11y.trapFocus(trapFocusConfig);

		this.bindEvents();

		return this;
	};

	Drawer.prototype.close = function () {
		if (!this.drawerIsOpen) {
			// don't close a closed drawer
			return;
		}

		// deselect any focused form elements
		document.activeElement.dispatchEvent(
			new CustomEvent("blur", { bubbles: true, cancelable: true })
		);

		// Ensure closing transition is applied to moved elements, like the nav
		if (!this.config.withPredictiveSearch) {
			theme.Helpers.prepareTransition(this.drawer);
		}

		this.nodes.parents.forEach(
			function (parent) {
				parent.classList.remove(
					this.config.classes.open,
					this.config.classes.openVariant
				);
			}.bind(this)
		);

		if (this.activeSource && this.activeSource.hasAttribute("aria-expanded")) {
			this.activeSource.setAttribute("aria-expanded", "false");
		}

		this.drawerIsOpen = false;

		// Remove focus on drawer
		slate.a11y.removeTrapFocus({
			container: this.drawer,
		});

		this.unbindEvents();

		// Run function when draw closes if set
		if (
			this.config.onDrawerClose &&
			typeof this.config.onDrawerClose === "function"
		) {
			this.config.onDrawerClose();
		}
	};

	Drawer.prototype.bindEvents = function () {
		this.eventHandlers.drawerKeyupHandler = function (evt) {
			// close on 'esc' keypress
			if (evt.keyCode === 27) {
				this.close();
				return false;
			} else {
				return true;
			}
		}.bind(this);

		this.eventHandlers.drawerTouchmoveHandler = function () {
			return false;
		};

		this.eventHandlers.drawerClickHandler = function () {
			this.close();
			return false;
		}.bind(this);

		// Add event listener to document body
		document.body.addEventListener(
			"keyup",
			this.eventHandlers.drawerKeyupHandler
		);

		// Lock scrolling on mobile
		this.nodes.page.addEventListener(
			"touchmove",
			this.eventHandlers.drawerTouchmoveHandler
		);

		this.nodes.page.addEventListener(
			"click",
			this.eventHandlers.drawerClickHandler
		);
	};

	Drawer.prototype.unbindEvents = function () {
		this.nodes.page.removeEventListener(
			"touchmove",
			this.eventHandlers.drawerTouchmoveHandler
		);
		this.nodes.page.removeEventListener(
			"click",
			this.eventHandlers.drawerClickHandler
		);
		document.body.removeEventListener(
			"keyup",
			this.eventHandlers.drawerKeyupHandler
		);
	};

	return Drawer;
})();

theme.Helpers = (function () {
	var touchDevice = false;

	var classes = {
		preventScrolling: "prevent-scrolling",
	};

	var scrollPosition = window.pageYOffset;

	function setTouch() {
		touchDevice = true;
	}

	function isTouch() {
		return touchDevice;
	}

	function enableScrollLock() {
		scrollPosition = window.pageYOffset;
		document.body.style.top = "-" + scrollPosition + "px";
		document.body.classList.add(classes.preventScrolling);
	}

	function disableScrollLock() {
		document.body.classList.remove(classes.preventScrolling);
		document.body.style.removeProperty("top");
		window.scrollTo(0, scrollPosition);
	}

	function debounce(func, wait, immediate) {
		var timeout;

		return function () {
			var context = this,
				args = arguments;

			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function getScript(source, beforeEl) {
		return new Promise(function (resolve, reject) {
			var script = document.createElement("script");
			var prior = beforeEl || document.getElementsByTagName("script")[0];

			script.async = true;
			script.defer = true;

			// eslint-disable-next-line shopify/prefer-early-return
			function onloadHander(_, isAbort) {
				if (
					isAbort ||
					!script.readyState ||
					/loaded|complete/.test(script.readyState)
				) {
					script.onload = null;
					script.onreadystatechange = null;
					script = undefined;

					if (isAbort) {
						reject();
					} else {
						resolve();
					}
				}
			}

			script.onload = onloadHander;
			script.onreadystatechange = onloadHander;

			script.src = source;
			prior.parentNode.insertBefore(script, prior);
		});
	}

	/* Based on the prepareTransition by Jonathan Snook */
	/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
	function prepareTransition(element) {
		element.addEventListener(
			"transitionend",
			function (event) {
				event.currentTarget.classList.remove("is-transitioning");
			},
			{ once: true }
		);

		var properties = [
			"transition-duration",
			"-moz-transition-duration",
			"-webkit-transition-duration",
			"-o-transition-duration",
		];

		var duration = 0;

		// properties.forEach(function(property) {
		//   var computedValue = getComputedStyle(element)[property];

		//   if (computedValue) {
		//     computedValue.replace(/\D/g, '');
		//     duration || (duration = parseFloat(computedValue));
		//   }
		// });

		// if (duration !== 0) {
		//   element.classList.add('is-transitioning');
		//   element.offsetWidth;
		// }
	}

	/*!
	 * Serialize all form data into a SearchParams string
	 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
	 * @param  {Node}   form The form to serialize
	 * @return {String}      The serialized form data
	 */
	function serialize(form) {
		var arr = [];
		Array.prototype.slice.call(form.elements).forEach(function (field) {
			if (
				!field.name ||
				field.disabled ||
				["file", "reset", "submit", "button"].indexOf(field.type) > -1
			)
				return;
			if (field.type === "select-multiple") {
				Array.prototype.slice.call(field.options).forEach(function (option) {
					if (!option.selected) return;
					arr.push(
						encodeURIComponent(field.name) +
							"=" +
							encodeURIComponent(option.value)
					);
				});
				return;
			}
			if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
				return;
			arr.push(
				encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
			);
		});
		return arr.join("&");
	}
	function cookiesEnabled() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled) {
			document.cookie = "testcookie";
			cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
		}

		return cookieEnabled;
	}

	function promiseStylesheet(stylesheet) {
		var stylesheetUrl = stylesheet || theme.stylesheet;

		if (typeof this.stylesheetPromise === "undefined") {
			this.stylesheetPromise = new Promise(function (resolve) {
				var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

				if (link.loaded) resolve();

				link.addEventListener("load", function () {
					setTimeout(resolve, 0);
				});
			});
		}

		return this.stylesheetPromise;
	}

	return {
		setTouch: setTouch,
		isTouch: isTouch,
		enableScrollLock: enableScrollLock,
		disableScrollLock: disableScrollLock,
		debounce: debounce,
		getScript: getScript,
		prepareTransition: prepareTransition,
		serialize: serialize,
		cookiesEnabled: cookiesEnabled,
		promiseStylesheet: promiseStylesheet,
	};
})();

theme.LibraryLoader = (function () {
	var types = {
		link: "link",
		script: "script",
	};

	var status = {
		requested: "requested",
		loaded: "loaded",
	};

	var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

	var libraries = {
		youtubeSdk: {
			tagId: "youtube-sdk",
			src: "https://www.youtube.com/iframe_api",
			type: types.script,
		},
		plyrShopifyStyles: {
			tagId: "plyr-shopify-styles",
			src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
			type: types.link,
		},
		modelViewerUiStyles: {
			tagId: "shopify-model-viewer-ui-styles",
			src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
			type: types.link,
		},
	};

	function load(libraryName, callback) {
		var library = libraries[libraryName];

		if (!library) return;
		if (library.status === status.requested) return;

		callback = callback || function () {};
		if (library.status === status.loaded) {
			callback();
			return;
		}

		library.status = status.requested;

		var tag;

		switch (library.type) {
			case types.script:
				tag = createScriptTag(library, callback);
				break;
			case types.link:
				tag = createLinkTag(library, callback);
				break;
		}

		tag.id = library.tagId;
		library.element = tag;

		var firstScriptTag = document.getElementsByTagName(library.type)[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function createScriptTag(library, callback) {
		var tag = document.createElement("script");
		tag.src = library.src;
		tag.addEventListener("load", function () {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	function createLinkTag(library, callback) {
		var tag = document.createElement("link");
		tag.href = library.src;
		tag.rel = "stylesheet";
		tag.type = "text/css";
		tag.addEventListener("load", function () {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	return {
		load: load,
	};
})();

theme.Header = (function () {
	var selectors = {
		body: "body",
		navigation: "#AccessibleNav",
		siteNavHasDropdown: "[data-has-dropdowns]",
		siteNavChildLinks: "[data-nav-child-link]",
		siteNavActiveDropdown: "[data-has-dropdowns='active']",
		siteNavLinkMain: "[data-nav-link-main]",
		siteNavChildLink: ".site-nav__link--last",
		siteNavDropdown: "[data-dropdown]",
		siteHeader: "[data-header]",
	};

	var config = {
		activeClass: "[data-has-dropdowns='active']",
		childLinkClass: "site-nav__child-link",
	};

	var cache = {};

	function init() {
		cacheSelectors();

		cache.parents.forEach(function (element) {
			element.addEventListener("mouseenter", submenuParentMouseEnterHandler);
		});

		cache.parents.forEach(function (element) {
			element.addEventListener("mouseleave", submenuParentMouseLeaveHandler);
		});

		// check when we're leaving a dropdown and close the active dropdown
		cache.siteNavChildLink.forEach(function (element) {
			element.addEventListener("focusout", submenuFocusoutHandler);
		});

		cache.topLevel.forEach(function (element) {
			element.addEventListener("focus", hideDropdown);
		});

		cache.subMenuLinks.forEach(function (element) {
			element.addEventListener("click", stopImmediatePropagation);
		});
	}

	function stopImmediatePropagation(event) {
		event.stopImmediatePropagation();
	}

	function cacheSelectors() {
		var navigation = document.querySelector(selectors.navigation);

		cache = {
			nav: navigation,
			topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
			parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
			subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
			activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
			siteHeader: document.querySelector(selectors.siteHeader),
			siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink),
		};
	}

	function showDropdown(element) {
		element.setAttribute("data-has-dropdowns", "active");

		if (cache.activeDropdown) hideDropdown();

		cache.activeDropdown = element;

		element
			.querySelector(selectors.siteNavLinkMain)
			.setAttribute("aria-expanded", "true");

		setTimeout(function () {
			window.addEventListener("keyup", keyUpHandler);
			document.body.addEventListener("click", hideDropdown);
		}, 250);
	}

	function hideDropdown() {
		if (!cache.activeDropdown) return;

		cache.activeDropdown
			.querySelector(selectors.siteNavLinkMain)
			.setAttribute("aria-expanded", "false");
		cache.activeDropdown.setAttribute("data-has-dropdowns", "");

		cache.activeDropdown = document.querySelector(
			selectors.siteNavActiveDropdown
		);

		window.removeEventListener("keyup", keyUpHandler);
		document.body.removeEventListener("click", hideDropdown);
	}

	function keyUpHandler(event) {
		if (event.keyCode === 27) hideDropdown();
	}

	function submenuParentMouseEnterHandler(event) {
		var element = event.currentTarget;
		showDropdown(element);
	}
	function submenuParentMouseLeaveHandler() {
		hideDropdown();
	}

	function submenuFocusoutHandler() {
		setTimeout(function () {
			if (
				document.activeElement.classList.contains(config.childLinkClass) ||
				!cache.activeDropdown
			) {
				return;
			}

			hideDropdown();
		});
	}

	function unload() {
		cache.topLevel.forEach(function (element) {
			element.removeEventListener("focus", hideDropdown);
		});

		cache.subMenuLinks.forEach(function (element) {
			element.removeEventListener("click", stopImmediatePropagation);
		});

		cache.parents.forEach(function (element) {
			element.removeEventListener("mouseenter", submenuParentMouseEnterHandler);
		});

		cache.parents.forEach(function (element) {
			element.removeEventListener("mouseleave", submenuParentMouseLeaveHandler);
		});

		cache.siteNavChildLink.forEach(function (element) {
			element.removeEventListener("focusout", submenuFocusoutHandler);
		});

		window.removeEventListener("keyup", keyUpHandler);
		document.body.removeEventListener("click", hideDropdown);
	}

	return {
		init: init,
		unload: unload,
	};
})();

theme.MobileNav = (function () {
	var classes = {
		mobileNavOpenIcon: "mobile-nav--open",
		mobileNavCloseIcon: "mobile-nav--close",
		navLinkWrapper: "mobile-nav__item",
		navLink: "mobile-nav__link",
		subNavLink: "mobile-nav__sublist-link",
		return: "js-return",
		subNavActive: "is-active",
		subNavClosing: "is-closing",
		navOpen: "js-menu--is-open",
		subNavShowing: "sub-nav--is-open",
		thirdNavShowing: "third-nav--is-open",
		subNavToggleBtn: "js-toggle-submenu",
	};

	var cache = {};
	var isTransitioning;
	var activeSubNav;
	var activeTrigger;
	var menuLevel = 1;
	var mediumUpQuery = "(min-width: " + theme.breakpoints.medium + "px)";
	var mql = window.matchMedia(mediumUpQuery);

	function init() {
		cacheSelectors();

		if (cache.mobileNavToggle) {
			cache.mobileNavToggle.addEventListener("click", toggleMobileNav);
		}

		cache.subNavToggleBtns.forEach(function (element) {
			element.addEventListener("click", toggleSubNav);
		});

		mql.addListener(initBreakpoints);
	}

	function initBreakpoints() {
		if (
			mql.matches &&
			cache.mobileNavContainer.classList.contains(classes.navOpen)
		) {
			closeMobileNav();
		}
	}

	function toggleMobileNav() {
		var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
			classes.mobileNavCloseIcon
		);

		if (mobileNavIsOpen) {
			closeMobileNav();
		} else {
			openMobileNav();
		}
	}

	function cacheSelectors() {
		cache = {
			pageContainer: document.querySelector("#PageContainer"),
			siteHeader: document.querySelector("[data-header]"),
			mobileNavToggle: document.querySelector("[data-mobile-menu-trigger]"),
			mobileNavContainer: document.querySelector("[data-mobile-nav-wrapper]"),
			mobileNav: document.querySelector("#MobileNav"),
			sectionHeader: document.querySelector("#shopify-section-header"),
			subNavToggleBtns: document.querySelectorAll(
				"." + classes.subNavToggleBtn
			),
		};
	}

	function openMobileNav() {
		cache.mobileNavContainer.classList.add(classes.navOpen);
		document.querySelector("html").classList.add("overflow-hidden");
		window.scrollTo(0, 0);

		slate.a11y.trapFocus({
			container: cache.sectionHeader,
			elementToFocus: cache.mobileNavToggle,
		});

		cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
		cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
		cache.mobileNavToggle.setAttribute("aria-expanded", true);

		window.addEventListener("keyup", keyUpHandler);
	}

	function keyUpHandler(event) {
		if (event.which === 27) {
			closeMobileNav();
		}
	}

	function closeMobileNav() {
		cache.mobileNavContainer.classList.remove(classes.navOpen);
		document.querySelector("html").classList.remove("overflow-hidden");
		window.scrollTo(0, 0);

		slate.a11y.trapFocus({
			container: document.querySelector("html"),
			elementToFocus: document.body,
		});

		cache.mobileNavContainer.addEventListener(
			"transitionend",
			mobileNavRemoveTrapFocus,
			{ once: true }
		);

		cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
		cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
		cache.mobileNavToggle.setAttribute("aria-expanded", false);
		cache.mobileNavToggle.focus();

		window.removeEventListener("keyup", keyUpHandler);
	}

	function mobileNavRemoveTrapFocus() {
		slate.a11y.removeTrapFocus({
			container: cache.mobileNav,
		});
	}

	function toggleSubNav(event) {
		if (isTransitioning) return;

		var toggleBtn = event.currentTarget;
		var isReturn = toggleBtn.classList.contains(classes.return);

		isTransitioning = true;

		if (isReturn) {
			var subNavToggleBtn = document.querySelectorAll(
				"." + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
			);

			subNavToggleBtn.forEach(function (element) {
				element.classList.remove(classes.subNavActive);
			});

			if (activeTrigger) {
				activeTrigger.classList.remove(classes.subNavActive);
			}
		} else {
			toggleBtn.classList.add(classes.subNavActive);
		}

		activeTrigger = toggleBtn;

		goToSubnav(toggleBtn.getAttribute("data-target"));
	}

	function goToSubnav(target) {
		var targetMenu = target
			? document.querySelector(
					'[data-mobile-subnav][data-parent="' + target + '"]'
			  )
			: cache.mobileNav;

		menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

		// if (activeSubNav) {
		// 	theme.Helpers.prepareTransition(activeSubNav);
		// 	activeSubNav.classList.add(classes.subNavClosing);
		// }

		activeSubNav = targetMenu;

		// var translateMenuHeight = targetMenu.offsetHeight;

		var openNavClass =
			menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

		// cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
		cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
		cache.mobileNavContainer.classList.add(openNavClass);

		if (!target) {
			cache.mobileNavContainer.classList.remove(
				classes.thirdNavShowing,
				classes.subNavShowing
			);
		}

		/* if going back to first subnav, focus is on whole header */
		var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

		cache.mobileNavContainer.addEventListener(
			"transitionend",
			trapMobileNavFocus,
			{ once: true }
		);

		function trapMobileNavFocus() {
			slate.a11y.trapFocus({
				container: container,
			});

			cache.mobileNavContainer.removeEventListener(
				"transitionend",
				trapMobileNavFocus
			);

			isTransitioning = false;
		}

		// Match height of subnav
		// cache.pageContainer.style.transform =
		//   'translateY(' + translateMenuHeight + 'px)';

		activeSubNav.classList.remove(classes.subNavClosing);
	}

	function unload() {
		mql.removeListener(initBreakpoints);
	}

	return {
		init: init,
		unload: unload,
		closeMobileNav: closeMobileNav,
	};
})();

window.Modals = (function () {
	function Modal(id, name, options) {
		var defaults = {
			close: ".js-modal-close",
			open: ".js-modal-open-" + name,
			openClass: "modal--is-active",
			closeModalOnClick: false,
		};

		this.modal = document.getElementById(id);

		if (!this.modal) return false;

		this.nodes = {
			parents: [document.querySelector("html"), document.body],
		};

		this.config = Object.assign(defaults, options);

		this.modalIsOpen = false;

		this.focusOnOpen = this.config.focusOnOpen
			? document.getElementById(this.config.focusOnOpen)
			: this.modal;

		this.openElement = document.querySelector(this.config.open);
		this.init();
	}

	Modal.prototype.init = function () {
		this.openElement.addEventListener("click", this.open.bind(this));

		this.modal
			.querySelector(this.config.close)
			.addEventListener("click", this.closeModal.bind(this));
	};

	Modal.prototype.open = function (evt) {
		var self = this;
		// Keep track if modal was opened from a click, or called by another function
		var externalCall = false;

		if (this.modalIsOpen) return;

		// Prevent following href if link is clicked
		if (evt) {
			evt.preventDefault();
		} else {
			externalCall = true;
		}

		// Without this, the modal opens, the click event bubbles up
		// which closes the modal.
		if (evt && evt.stopPropagation) {
			evt.stopPropagation();
		}

		if (this.modalIsOpen && !externalCall) {
			this.closeModal();
		}

		this.modal.classList.add(this.config.openClass);

		this.nodes.parents.forEach(function (node) {
			node.classList.add(self.config.openClass);
		});

		this.modalIsOpen = true;

		slate.a11y.trapFocus({
			container: this.modal,
			elementToFocus: this.focusOnOpen,
		});

		this.bindEvents();
	};

	Modal.prototype.closeModal = function () {
		if (!this.modalIsOpen) return;

		document.activeElement.blur();

		this.modal.classList.remove(this.config.openClass);

		var self = this;

		this.nodes.parents.forEach(function (node) {
			node.classList.remove(self.config.openClass);
		});

		this.modalIsOpen = false;

		slate.a11y.removeTrapFocus({
			container: this.modal,
		});

		this.openElement.focus();

		this.unbindEvents();
	};

	Modal.prototype.bindEvents = function () {
		this.keyupHandler = this.keyupHandler.bind(this);
		this.clickHandler = this.clickHandler.bind(this);
		document.body.addEventListener("keyup", this.keyupHandler);
		document.body.addEventListener("click", this.clickHandler);
	};

	Modal.prototype.unbindEvents = function () {
		document.body.removeEventListener("keyup", this.keyupHandler);
		document.body.removeEventListener("click", this.clickHandler);
	};

	Modal.prototype.keyupHandler = function (event) {
		if (event.keyCode === 27) {
			this.closeModal();
		}
	};

	Modal.prototype.clickHandler = function (event) {
		if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
			this.closeModal();
		}
	};

	return Modal;
})();

theme.Video = (function () {
	var autoplayCheckComplete = false;
	var playOnClickChecked = false;
	var playOnClick = false;
	var youtubeLoaded = false;
	var videos = {};
	var videoPlayers = [];
	var videoOptions = {
		ratio: 16 / 9,
		scrollAnimationDuration: 400,
		playerVars: {
			// eslint-disable-next-line camelcase
			iv_load_policy: 3,
			modestbranding: 1,
			autoplay: 0,
			controls: 0,
			wmode: "opaque",
			branding: 0,
			autohide: 0,
			rel: 0,
		},
		events: {
			onReady: onPlayerReady,
			onStateChange: onPlayerChange,
		},
	};
	var classes = {
		playing: "video-is-playing",
		paused: "video-is-paused",
		loading: "video-is-loading",
		loaded: "video-is-loaded",
		backgroundVideoWrapper: "video-background-wrapper",
		videoWithImage: "video--image_with_play",
		backgroundVideo: "video--background",
		userPaused: "is-paused",
		supportsAutoplay: "autoplay",
		supportsNoAutoplay: "no-autoplay",
		wrapperMinHeight: "video-section-wrapper--min-height",
	};

	var selectors = {
		section: ".video-section",
		videoWrapper: ".video-section-wrapper",
		playVideoBtn: ".video-control__play",
		closeVideoBtn: ".video-control__close-wrapper",
		pauseVideoBtn: ".video__pause",
		pauseVideoStop: ".video__pause-stop",
		pauseVideoResume: ".video__pause-resume",
		fallbackText: "[data-fallback]",
	};

	/**
	 * Public functions
	 */
	function init(video) {
		if (!video) return;

		videos[video.id] = {
			id: video.id,
			videoId: video.dataset.id,
			type: video.dataset.type,
			status:
				video.dataset.type === "image_with_play" ? "closed" : "background", // closed, open, background
			video: video,
			videoWrapper: video.closest(selectors.videoWrapper),
			section: video.closest(selectors.section),
			controls: video.dataset.type === "background" ? 0 : 1,
		};

		if (!youtubeLoaded) {
			// This code loads the IFrame Player API code asynchronously.
			var tag = document.createElement("script");
			tag.src = "https://www.youtube.com/iframe_api";
			var firstScriptTag = document.getElementsByTagName("script")[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}

		playOnClickCheck();
	}

	function customPlayVideo(playerId) {
		// Make sure we have carried out the playOnClick check first
		if (!playOnClickChecked && !playOnClick) {
			return;
		}

		if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
			privatePlayVideo(playerId);
		}
	}

	function pauseVideo(playerId) {
		if (
			videoPlayers[playerId] &&
			typeof videoPlayers[playerId].pauseVideo === "function"
		) {
			videoPlayers[playerId].pauseVideo();
		}
	}

	function loadVideos() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				createPlayer(key);
			}
		}

		initEvents();
		youtubeLoaded = true;
	}

	function editorLoadVideo(key) {
		if (!youtubeLoaded) {
			return;
		}
		createPlayer(key);

		initEvents();
	}

	/**
	 * Private functions
	 */

	function privatePlayVideo(id, clicked) {
		var videoData = videos[id];
		var player = videoPlayers[id];
		var videoWrapper = videoData.videoWrapper;

		if (playOnClick) {
			// playOnClick means we are probably on mobile (no autoplay).
			// setAsPlaying will show the iframe, requiring another click
			// to play the video.
			setAsPlaying(videoData);
		} else if (clicked || autoplayCheckComplete) {
			// Play if autoplay is available or clicked to play
			videoWrapper.classList.remove(classes.loading);
			setAsPlaying(videoData);
			player.playVideo();
			return;
		} else {
			player.playVideo();
		}
	}

	function setAutoplaySupport(supported) {
		var supportClass = supported
			? classes.supportsAutoplay
			: classes.supportsNoAutoplay;
		document.documentElement.classList.remove(
			classes.supportsAutoplay,
			classes.supportsNoAutoplay
		);
		document.documentElement.classList.add(supportClass);

		if (!supported) {
			playOnClick = true;
		}

		autoplayCheckComplete = true;
	}

	function playOnClickCheck() {
		if (playOnClickChecked) {
			return;
		}

		if (isMobile()) {
			playOnClick = true;
		}

		if (playOnClick) {
			// No need to also do the autoplay check
			setAutoplaySupport(false);
		}

		playOnClickChecked = true;
	}

	// The API will call this function when each video player is ready
	function onPlayerReady(evt) {
		evt.target.setPlaybackQuality("hd1080");
		var videoData = getVideoOptions(evt);
		var videoTitle = evt.target.getVideoData().title;
		playOnClickCheck();

		// Prevent tabbing through YouTube player controls until visible
		document.getElementById(videoData.id).setAttribute("tabindex", "-1");

		sizeBackgroundVideos();
		setButtonLabels(videoData.videoWrapper, videoTitle);

		// Customize based on options from the video ID
		if (videoData.type === "background") {
			evt.target.mute();
			privatePlayVideo(videoData.id);
		}

		videoData.videoWrapper.classList.add(classes.loaded);
	}

	function onPlayerChange(evt) {
		var videoData = getVideoOptions(evt);
		if (
			videoData.status === "background" &&
			!isMobile() &&
			!autoplayCheckComplete &&
			(evt.data === YT.PlayerState.PLAYING ||
				evt.data === YT.PlayerState.BUFFERING)
		) {
			setAutoplaySupport(true);
			autoplayCheckComplete = true;
			videoData.videoWrapper.classList.remove(classes.loading);
		}
		switch (evt.data) {
			case YT.PlayerState.ENDED:
				setAsFinished(videoData);
				break;
			case YT.PlayerState.PAUSED:
				// Seeking on a YouTube video also fires a PAUSED state change,
				// checking the state after a delay prevents us pausing the video when
				// the user is seeking instead of pausing
				setTimeout(function () {
					if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
						setAsPaused(videoData);
					}
				}, 200);
				break;
		}
	}

	function setAsFinished(videoData) {
		switch (videoData.type) {
			case "background":
				videoPlayers[videoData.id].seekTo(0);
				break;
			case "image_with_play":
				closeVideo(videoData.id);
				toggleExpandVideo(videoData.id, false);
				break;
		}
	}

	function setAsPlaying(videoData) {
		var videoWrapper = videoData.videoWrapper;
		var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

		videoWrapper.classList.remove(classes.loading);

		if (pauseButton.classList.contains(classes.userPaused)) {
			pauseButton.classList.remove(classes.userPaused);
		}

		// Do not change element visibility if it is a background video
		if (videoData.status === "background") {
			return;
		}

		document.getElementById(videoData.id).setAttribute("tabindex", "0");

		if (videoData.type === "image_with_play") {
			videoWrapper.classList.remove(classes.paused);
			videoWrapper.classList.add(classes.playing);
		}

		// Update focus to the close button so we stay within the video wrapper,
		// allowing time for the scroll animation
		setTimeout(function () {
			videoWrapper.querySelector(selectors.closeVideoBtn).focus();
		}, videoOptions.scrollAnimationDuration);
	}

	function setAsPaused(videoData) {
		var videoWrapper = videoData.videoWrapper;

		// YT's events fire after our click event. This status flag ensures
		// we don't interact with a closed or background video.
		if (videoData.type === "image_with_play") {
			if (videoData.status === "closed") {
				videoWrapper.classList.remove(classes.paused);
			} else {
				videoWrapper.classList.add(classes.paused);
			}
		}

		videoWrapper.classList.remove(classes.playing);
	}

	function closeVideo(playerId) {
		var videoData = videos[playerId];
		var videoWrapper = videoData.videoWrapper;

		document.getElementById(videoData.id).setAttribute("tabindex", "-1");

		videoData.status = "closed";

		switch (videoData.type) {
			case "image_with_play":
				videoPlayers[playerId].stopVideo();
				setAsPaused(videoData); // in case the video is already paused
				break;
			case "background":
				videoPlayers[playerId].mute();
				setBackgroundVideo(playerId);
				break;
		}

		videoWrapper.classList.remove(classes.paused, classes.playing);
	}

	function getVideoOptions(evt) {
		var id = evt.target.getIframe().id;
		return videos[id];
	}

	function toggleExpandVideo(playerId, expand) {
		var video = videos[playerId];
		var elementTop =
			video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
		var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
		var offset = 0;
		var newHeight = 0;

		if (isMobile()) {
			video.videoWrapper.parentElement.classList.toggle("page-width", !expand);
		}

		if (expand) {
			if (isMobile()) {
				newHeight = window.innerWidth / videoOptions.ratio;
			} else {
				newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
			}
			offset = (window.innerHeight - newHeight) / 2;

			video.videoWrapper.style.height =
				video.videoWrapper.getBoundingClientRect().height + "px";
			video.videoWrapper.classList.remove(classes.wrapperMinHeight);
			video.videoWrapper.style.height = newHeight + "px";

			// Animate doesn't work in mobile editor, so we don't use it
			if (!(isMobile() && Shopify.designMode)) {
				var scrollBehavior = document.documentElement.style.scrollBehavior;
				document.documentElement.style.scrollBehavior = "smooth";
				window.scrollTo({ top: elementTop - offset });
				document.documentElement.style.scrollBehavior = scrollBehavior;
			}
		} else {
			if (isMobile()) {
				newHeight = video.videoWrapper.dataset.mobileHeight;
			} else {
				newHeight = video.videoWrapper.dataset.desktopHeight;
			}

			video.videoWrapper.style.height = newHeight + "px";

			setTimeout(function () {
				video.videoWrapper.classList.add(classes.wrapperMinHeight);
			}, 600);
			// Set focus on play button, but don't scroll page
			var x = window.scrollX;
			var y = window.scrollY;
			playButton.focus();
			window.scrollTo(x, y);
		}
	}

	function togglePause(playerId) {
		var pauseButton = videos[playerId].videoWrapper.querySelector(
			selectors.pauseVideoBtn
		);
		var paused = pauseButton.classList.contains(classes.userPaused);
		if (paused) {
			pauseButton.classList.remove(classes.userPaused);
			customPlayVideo(playerId);
		} else {
			pauseButton.classList.add(classes.userPaused);
			pauseVideo(playerId);
		}
		pauseButton.setAttribute("aria-pressed", !paused);
	}

	function startVideoOnClick(playerId) {
		var video = videos[playerId];

		// add loading class to wrapper
		video.videoWrapper.classList.add(classes.loading);

		// Explicity set the video wrapper height (needed for height transition)
		video.videoWrapper.style.height = video.videoWrapper.offsetHeight + "px";

		video.status = "open";

		switch (video.type) {
			case "image_with_play":
				privatePlayVideo(playerId, true);
				break;
			case "background":
				unsetBackgroundVideo(playerId, video);
				videoPlayers[playerId].unMute();
				privatePlayVideo(playerId, true);
				break;
		}

		toggleExpandVideo(playerId, true);

		// esc to close video player
		document.addEventListener("keydown", handleVideoPlayerKeydown);
	}

	var handleVideoPlayerKeydown = function (evt) {
		var playerId = document.activeElement.dataset.controls;
		if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
			return;
		}

		closeVideo(playerId);
		toggleExpandVideo(playerId, false);
	};

	function sizeBackgroundVideos() {
		var backgroundVideos = document.querySelectorAll(
			"." + classes.backgroundVideo
		);
		backgroundVideos.forEach(function (el) {
			sizeBackgroundVideo(el);
		});
	}

	function sizeBackgroundVideo(videoPlayer) {
		if (!youtubeLoaded) {
			return;
		}

		if (isMobile()) {
			videoPlayer.style.cssText = null;
		} else {
			var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
			var videoWidth = videoWrapper.clientWidth;
			var playerWidth = videoPlayer.clientWidth;
			var desktopHeight = videoWrapper.dataset.desktopHeight;

			// when screen aspect ratio differs from video, video must center and underlay one dimension
			if (videoWidth / videoOptions.ratio < desktopHeight) {
				playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
				var styles =
					"width: " +
					playerWidth +
					"px; height: " +
					desktopHeight +
					"px; left: " +
					(videoWidth - playerWidth) / 2 +
					"px; top: 0;";
				videoPlayer.style.cssText = styles;
			} else {
				// new video width < window width (gap to right)
				desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
				var styles2 =
					"width: " +
					videoWidth +
					"px; height: " +
					desktopHeight +
					"px; top: " +
					(desktopHeight - desktopHeight) / 2 +
					"px; left: 0;"; // player height is greater, offset top; reset left
				videoPlayer.style.cssText = styles2;
			}

			theme.Helpers.prepareTransition(videoPlayer);
			videoWrapper.classList.add(classes.loaded);
		}
	}

	function unsetBackgroundVideo(playerId) {
		// Switch the background video to a chrome-only player once played
		var player = document.getElementById(playerId);
		player.classList.remove(classes.backgroundVideo);
		player.classList.add(classes.videoWithImage);

		setTimeout(function () {
			document.getElementById(playerId).style.cssText = null;
		}, 600);

		videos[playerId].videoWrapper.classList.remove(
			classes.backgroundVideoWrapper
		);
		videos[playerId].videoWrapper.classList.add(classes.playing);

		videos[playerId].status = "open";
	}

	function setBackgroundVideo(playerId) {
		var player = document.getElementById(playerId);
		player.classList.remove(classes.videoWithImage);
		player.classList.add(classes.backgroundVideo);

		videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

		videos[playerId].status = "background";
		sizeBackgroundVideo(player);
	}

	function isMobile() {
		return window.innerWidth < theme.breakpoints.medium;
	}

	var handleWindowResize = theme.Helpers.debounce(function () {
		if (!youtubeLoaded) return;
		var key;
		var fullscreen = window.innerHeight === screen.height;
		sizeBackgroundVideos();

		if (isMobile()) {
			for (key in videos) {
				if (videos.hasOwnProperty(key)) {
					if (videos[key].videoWrapper.classList.contains(classes.playing)) {
						if (!fullscreen) {
							pauseVideo(key);
							setAsPaused(videos[key]);
						}
					}
					videos[key].videoWrapper.style.height =
						document.documentElement.clientWidth / videoOptions.ratio + "px";
				}
			}
			setAutoplaySupport(false);
		} else {
			setAutoplaySupport(true);
			for (key in videos) {
				var videosWithImage = videos[key].videoWrapper.querySelectorAll(
					"." + classes.videoWithImage
				);
				if (videosWithImage.length) {
					continue;
				}
				videoPlayers[key].playVideo();
				setAsPlaying(videos[key]);
			}
		}
	}, 200);

	var handleWindowScroll = theme.Helpers.debounce(function () {
		if (!youtubeLoaded) return;

		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var videoWrapper = videos[key].videoWrapper;
				var condition =
					videoWrapper.getBoundingClientRect().top +
						window.pageYOffset +
						videoWrapper.offsetHeight * 0.75 <
						window.pageYOffset ||
					videoWrapper.getBoundingClientRect().top +
						window.pageYOffset +
						videoWrapper.offsetHeight * 0.25 >
						window.pageYOffset + window.innerHeight;

				// Close the video if more than 75% of it is scrolled out of view
				if (videoWrapper.classList.contains(classes.playing)) {
					if (!condition) return;
					closeVideo(key);
					toggleExpandVideo(key, false);
				}
			}
		}
	}, 50);

	function initEvents() {
		var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
		var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
		var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

		playVideoBtns.forEach(function (btn) {
			btn.addEventListener("click", function (evt) {
				var playerId = evt.currentTarget.dataset.controls;
				startVideoOnClick(playerId);
			});
		});

		closeVideoBtns.forEach(function (btn) {
			btn.addEventListener("click", function (evt) {
				var playerId = evt.currentTarget.dataset.controls;

				evt.currentTarget.blur();
				closeVideo(playerId);
				toggleExpandVideo(playerId, false);
			});
		});

		pauseVideoBtns.forEach(function (btn) {
			btn.addEventListener("click", function (evt) {
				var playerId = evt.currentTarget.dataset.controls;
				togglePause(playerId);
			});
		});

		// Listen to resize to keep a background-size:cover-like layout
		window.addEventListener("resize", handleWindowResize);

		window.addEventListener("scroll", handleWindowScroll);
	}

	function createPlayer(key) {
		var args = Object.assign(videoOptions, videos[key]);

		args.playerVars.controls = args.controls;
		videoPlayers[key] = new YT.Player(key, args);
	}

	function removeEvents() {
		document.removeEventListener("keydown", handleVideoPlayerKeydown);
		window.removeEventListener("resize", handleWindowResize);
		window.removeEventListener("scroll", handleWindowScroll);
	}

	function setButtonLabels(videoWrapper, title) {
		var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
		var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
		var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
		var closeButtonText = closeButton.querySelector(selectors.fallbackText);

		var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
		var pauseButtonStopText = pauseButtonStop.querySelector(
			selectors.fallbackText
		);

		var pauseButtonResume = pauseButton.querySelector(
			selectors.pauseVideoResume
		);
		var pauseButtonResumeText = pauseButtonResume.querySelector(
			selectors.fallbackText
		);

		// Insert the video title retrieved from YouTube into the instructional text
		// for each button
		playButtons.forEach(function (playButton) {
			var playButtonText = playButton.querySelector(selectors.fallbackText);

			playButtonText.textContent = playButtonText.textContent.replace(
				"[video_title]",
				title
			);
		});
		closeButtonText.textContent = closeButtonText.textContent.replace(
			"[video_title]",
			title
		);
		pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
			"[video_title]",
			title
		);
		pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
			"[video_title]",
			title
		);
	}

	return {
		init: init,
		editorLoadVideo: editorLoadVideo,
		loadVideos: loadVideos,
		playVideo: customPlayVideo,
		pauseVideo: pauseVideo,
		removeEvents: removeEvents,
	};
})();

theme.ProductVideo = (function () {
	var videos = {};

	var hosts = {
		html5: "html5",
		youtube: "youtube",
	};

	var selectors = {
		productMediaWrapper: "[data-product-single-media-wrapper]",
	};

	var attributes = {
		enableVideoLooping: "enable-video-looping",
		videoId: "video-id",
	};

	function init(videoContainer, sectionId) {
		if (!videoContainer) {
			return;
		}

		var videoElement = videoContainer.querySelector("iframe, video");

		if (!videoElement) {
			return;
		}

		var mediaId = videoContainer.getAttribute("data-media-id");

		videos[mediaId] = {
			mediaId: mediaId,
			sectionId: sectionId,
			host: hostFromVideoElement(videoElement),
			container: videoContainer,
			element: videoElement,
			ready: function () {
				createPlayer(this);
			},
		};

		var video = videos[mediaId];

		switch (video.host) {
			case hosts.html5:
				window.Shopify.loadFeatures([
					{
						name: "video-ui",
						version: "1.0",
						onLoad: setupPlyrVideos,
					},
				]);
				theme.LibraryLoader.load("plyrShopifyStyles");
				break;
			case hosts.youtube:
				theme.LibraryLoader.load("youtubeSdk", setupYouTubeVideos);
				break;
		}
	}

	function setupPlyrVideos(errors) {
		if (errors) {
			fallbackToNativeVideo();
			return;
		}

		loadVideos(hosts.html5);
	}

	function setupYouTubeVideos() {
		if (!window.YT.Player) return;

		loadVideos(hosts.youtube);
	}

	function createPlayer(video) {
		if (video.player) {
			return;
		}

		var productMediaWrapper = video.container.closest(
			selectors.productMediaWrapper
		);

		var enableLooping = productMediaWrapper.getAttribute(
			"data-" + attributes.enableVideoLooping
		);

		switch (video.host) {
			case hosts.html5:
				// eslint-disable-next-line no-undef
				video.player = new Shopify.Plyr(video.element, {
					loop: { active: enableLooping },
				});
				break;
			case hosts.youtube:
				var videoId = productMediaWrapper.getAttribute(
					"data-" + attributes.videoId
				);

				video.player = new YT.Player(video.element, {
					videoId: videoId,
					events: {
						onStateChange: function (event) {
							if (event.data === 0 && enableLooping) event.target.seekTo(0);
						},
					},
				});
				break;
		}

		var pauseVideo = function () {
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.pause();
			}

			if (video.host === hosts.youtube && video.player.pauseVideo) {
				video.player.pauseVideo();
			}
		};

		productMediaWrapper.addEventListener("mediaHidden", pauseVideo);
		productMediaWrapper.addEventListener("xrLaunch", pauseVideo);

		productMediaWrapper.addEventListener("mediaVisible", function () {
			if (theme.Helpers.isTouch()) return;
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.play();
			}

			if (video.host === hosts.youtube && video.player.playVideo) {
				video.player.playVideo();
			}
		});
	}

	function hostFromVideoElement(video) {
		if (video.tagName === "VIDEO") {
			return hosts.html5;
		}

		if (video.tagName === "IFRAME") {
			if (
				/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
					video.src
				)
			) {
				return hosts.youtube;
			}
		}
		return null;
	}

	function loadVideos(host) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];
				if (video.host === host) {
					video.ready();
				}
			}
		}
	}

	function fallbackToNativeVideo() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.nativeVideo) continue;

				if (video.host === hosts.html5) {
					video.element.setAttribute("controls", "controls");
					video.nativeVideo = true;
				}
			}
		}
	}

	function removeSectionVideos(sectionId) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.sectionId === sectionId) {
					if (video.player) video.player.destroy();
					delete videos[key];
				}
			}
		}
	}

	return {
		init: init,
		hosts: hosts,
		loadVideos: loadVideos,
		removeSectionVideos: removeSectionVideos,
	};
})();

theme.Cart = (function () {
	function Cart(container) {
		this.container = container;

		if (!theme.Helpers.cookiesEnabled()) {
			document
				.querySelector("[data-cookies-enabled]")
				.removeAttribute("hidden");
		}
	}

	Cart.prototype = Object.assign({}, Cart.prototype, {});

	return Cart;
})();

theme.CycleSection = (function () {
	function CycleSection(container) {
        const theShow = container.querySelector(".swiper-container")
        const bullets = container.querySelectorAll("[data-swiper-bullet-index]")
        const delay = theShow.dataset.autoPlay ? parseInt(theShow.dataset.autoPlay, 10) : 0
        const loop = theShow.dataset.loop == "false" ? false : true
        const arrows = theShow.dataset.arrows == "false" ? false : true
        const options = {
            loop: loop,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
        }

        if (delay > 0) {
            options.autoplay = { delay: delay }
        }
        if (arrows) {
            const nextEl = container.querySelector(".swiper-button-next")
            const prevEl = container.querySelector(".swiper-button-prev")
            options.navigation = {
                nextEl: nextEl,
                prevEl: prevEl,
            }
        }

        const swiper = new Swiper(theShow, options);

        bullets.forEach(element => {
            const id = parseInt(element.dataset.swiperBulletIndex, 10)
            element.addEventListener('click', function() {
                // console.log(id)
                swiper.slideToLoop(id, 300, true)
            })
        });

        swiper.on('slideChange', function () {
            // console.log('slide changed');
            container.querySelectorAll("[data-swiper-bullet-index]").forEach((slideButton) => {
                slideButton.classList.remove("text-accent");
            });
            container.querySelector(`[data-swiper-bullet-index='${swiper.realIndex}']`).classList.add("text-accent");
        });
        
	}
	return CycleSection;
})();

theme.Filters = (function () {

	return;
})();

var selectors = {
	disclosureLocale: "[data-disclosure-locale]",
	disclosureCurrency: "[data-disclosure-currency]",
};
theme.FooterSection = (function () {
	function Footer(container) {
		this.container = container;
		this.cache = {};
		this.cacheSelectors();

		if (this.cache.localeDisclosure) {
			this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
		}

		if (this.cache.currencyDisclosure) {
			this.currencyDisclosure = new theme.Disclosure(
				this.cache.currencyDisclosure
			);
		}
	}

	Footer.prototype = Object.assign({}, Footer.prototype, {
		cacheSelectors: function () {
			this.cache = {
				localeDisclosure: this.container.querySelector(
					selectors.disclosureLocale
				),
				currencyDisclosure: this.container.querySelector(
					selectors.disclosureCurrency
				),
			};
		},

		onUnload: function () {
			if (this.cache.localeDisclosure) {
				this.localeDisclosure.destroy();
			}

			if (this.cache.currencyDisclosure) {
				this.currencyDisclosure.destroy();
			}
		},
	});

	return Footer;
})();

theme.HeaderSection = (function () {
	function Header() {
		theme.Header.init();
		theme.MobileNav.init();
		theme.SearchDrawer.init();
		theme.Search.init();
		theme.CartDrawer.init();
	}

	Header.prototype = Object.assign({}, Header.prototype, {
		onUnload: function () {
			theme.Header.unload();
			theme.Search.unload();
			theme.MobileNav.unload();
		},
	});

	return Header;
})();

theme.Maps = (function () {
	var config = {
		zoom: 14,
	};
	var apiStatus = null;
	var mapsToLoad = [];

	var errors = {
		addressNoResults: theme.strings.addressNoResults,
		addressQueryLimit: theme.strings.addressQueryLimit,
		addressError: theme.strings.addressError,
		authError: theme.strings.authError,
	};

	var selectors = {
		section: '[data-section-type="map"]',
		map: "[data-map]",
		mapOverlay: "[data-map-overlay]",
	};

	var classes = {
		mapError: "map-section--load-error",
		errorMsg: "map-section__error errors text-center",
	};

	// Global function called by Google on auth errors.
	// Show an auto error message on all map instances.
	// eslint-disable-next-line camelcase, no-unused-vars
	window.gm_authFailure = function () {
		if (!Shopify.designMode) {
			return;
		}

		document.querySelector(selectors.section).classList.add(classes.mapError);
		document.querySelector(selectors.map).remove();
		document
			.querySelector(selectors.mapOverlay)
			.insertAdjacentHTML(
				"afterend",
				'<div class="' +
					classes.errorMsg +
					'">' +
					theme.strings.authError +
					"</div>"
			);
	};

	function Map(container) {
		this.map = container.querySelector(selectors.map);
		if (!this.map) return;
		this.key = this.map.dataset.apiKey;

		if (typeof this.key === "undefined") {
			return;
		}

		if (apiStatus === "loaded") {
			this.createMap();
		} else {
			mapsToLoad.push(this);

			if (apiStatus !== "loading") {
				apiStatus = "loading";
				if (typeof window.google === "undefined") {
					theme.Helpers.getScript(
						"https://maps.googleapis.com/maps/api/js?key=" + this.key
					).then(function () {
						apiStatus = "loaded";
						initAllMaps();
					});
				}
			}
		}
	}

	function initAllMaps() {
		// API has loaded, load all Map instances in queue
		mapsToLoad.forEach(function (map) {
			map.createMap();
		});
	}

	function geolocate(map) {
		return new Promise(function (resolve, reject) {
			var geocoder = new google.maps.Geocoder();
			var address = map.dataset.addressSetting;

			geocoder.geocode({ address: address }, function (results, status) {
				if (status !== google.maps.GeocoderStatus.OK) {
					reject(status);
				}

				resolve(results);
			});
		});
	}

	Map.prototype = Object.assign({}, Map.prototype, {
		createMap: function () {
			return geolocate(this.map)
				.then(
					function (results) {
						var mapOptions = {
							zoom: config.zoom,
							center: results[0].geometry.location,
							draggable: false,
							clickableIcons: false,
							scrollwheel: false,
							disableDoubleClickZoom: true,
							disableDefaultUI: true,
						};

						var map = (this.map = new google.maps.Map(this.map, mapOptions));
						var center = (this.center = map.getCenter());

						//eslint-disable-next-line no-unused-vars
						var marker = new google.maps.Marker({
							map: map,
							position: map.getCenter(),
						});

						google.maps.event.addDomListener(
							window,
							"resize",
							theme.Helpers.debounce(
								function () {
									google.maps.event.trigger(map, "resize");
									map.setCenter(center);
									this.map.removeAttribute("style");
								}.bind(this),
								250
							)
						);
					}.bind(this)
				)
				.catch(
					function () {
						var errorMessage;

						switch (status) {
							case "ZERO_RESULTS":
								errorMessage = errors.addressNoResults;
								break;
							case "OVER_QUERY_LIMIT":
								errorMessage = errors.addressQueryLimit;
								break;
							case "REQUEST_DENIED":
								errorMessage = errors.authError;
								break;
							default:
								errorMessage = errors.addressError;
								break;
						}

						// Show errors only to merchant in the editor.
						if (Shopify.designMode) {
							this.map.parentNode.classList.add(classes.mapError);
							this.map.parentNode.innerHTML =
								'<div class="' +
								classes.errorMsg +
								'">' +
								errorMessage +
								"</div>";
						}
					}.bind(this)
				);
		},

		onUnload: function () {
			if (this.map) {
				google.maps.event.clearListeners(this.map, "resize");
			}
		},
	});

	return Map;
})();

theme.ProductRecommendations = (function () {
	function ProductRecommendations(container) {
		var baseUrl = container.dataset.baseUrl;
		var productId = container.dataset.productId;
		var recommendationsSectionUrl =
			baseUrl +
			"?section_id=product-recommendations&product_id=" +
			productId +
			"&limit=4";

		window.performance.mark(
			"debut:product:fetch_product_recommendations.start"
		);

		fetch(recommendationsSectionUrl)
			.then(function (response) {
				return response.text();
			})
			.then(function (productHtml) {
				if (productHtml.trim() === "") return;

				container.innerHTML = productHtml;
				container.innerHTML = container.firstElementChild.innerHTML;

				window.performance.mark(
					"debut:product:fetch_product_recommendations.end"
				);

				performance.measure(
					"debut:product:fetch_product_recommendations",
					"debut:product:fetch_product_recommendations.start",
					"debut:product:fetch_product_recommendations.end"
				);

                htmx.process(document.body)
                quickShop()
			});
	}

	return ProductRecommendations;
})();

theme.Product = (function () {
	function Product(container) {
		this.container = container;
		var sectionId = container.getAttribute("data-section-id");
		this.ajaxEnabled = container.getAttribute("data-ajax-enabled") === "true";

		this.settings = {
			enableHistoryState:
				container.getAttribute("data-enable-history-state") || false,
			namespace: ".slideshow-" + sectionId,
			sectionId: sectionId,
			sliderActive: false,
			enableSticky: container.getAttribute("data-sticky-enabled") || false
		};

		this.selectors = {
			addToCart: "[data-add-to-cart]",
			stickyAddToCart: "[data-sticky-add-to-cart]",
			stickyContainer: "[data-sticky-add-to-cart-container]",
			addToCartText: "[data-add-to-cart-text]",
			loader: "[data-loader]",
			loaderStatus: "[data-loader-status]",
			quantity: "[data-quantity-input]",
			quantityPlus: "[data-quantity-plus]",
			quantityMinus: "[data-quantity-minus]",
			SKU: ".variant-sku",
			productStatus: "[data-product-status]",
			originalSelectorId: "#ProductSelect-" + sectionId,
			productForm: "[data-product-form]",
			errorMessage: "[data-error-message]",
			errorMessageWrapper: "[data-error-message-wrapper]",
			productMediaWrapper: "[data-product-single-media-wrapper]",
			productThumbImages: "[data-thumbnail-id]",
			productThumbs: ".product-single__thumbnails-" + sectionId,
			productThumbListItem: "[data-thumb-swiper-item]",
			productThumbsWrapper: ".thumbnails-wrapper",
			saleLabel: ".product-price__sale-label-" + sectionId,
			singleOptionSelector: ".single-option-selector-" + sectionId,
			shopifyPaymentButton: ".shopify-payment-button",
			productMediaTypeVideo: "[data-product-media-type-video]",
			productMediaTypeModel: "[data-product-media-type-model]",
			priceContainer: "[data-price]",
			regularPrice: "[data-regular-price]",
			salePrice: "[data-sale-price]",
			unitPrice: "[data-unit-price]",
			unitPriceBaseUnit: "[data-unit-price-base-unit]",
			productPolicies: "[data-product-policies]",
		};

		this.classes = {
			hidden: "hidden",
			mdHidden: "js-md-hidden",
			visibilityHidden: "visibility-hidden",
			inputError: "input--error",
			productOnSale: "price--on-sale",
			productUnitAvailable: "price--unit-available",
			productUnavailable: "price--unavailable",
			productSoldOut: "price--sold-out",
			productFormErrorMessageWrapperHidden: "hidden",
			activeClass: "border-gray-500",
			variantSoldOut: "product-form--variant-sold-out",
		};

		this.eventHandlers = {};

		this.quantityInput = container.querySelector(this.selectors.quantity);
		this.quantityPlusButton = container.querySelector(
			this.selectors.quantityPlus
		);
		this.quantityMinusButton = container.querySelector(
			this.selectors.quantityMinus
		);
		this.errorMessageWrapper = container.querySelector(
			this.selectors.errorMessageWrapper
		);
		this.addToCart = container.querySelector(this.selectors.addToCart);
		this.addToCartText = this.addToCart.querySelector(
			this.selectors.addToCartText
		);
		if (this.settings.enableSticky) {
			this.stickyContainer = document.querySelector(
				this.selectors.stickyContainer
			);
			this.stickyAddToCart = document.querySelector(
				this.selectors.stickyAddToCart
			);
			this.stickyAddToCartText = this.stickyAddToCart.querySelector(
				this.selectors.addToCartText
			);
		}
		this.shopifyPaymentButton = container.querySelector(
			this.selectors.shopifyPaymentButton
		);
		this.productPolicies = container.querySelector(
			this.selectors.productPolicies
		);

		this.loader = this.addToCart.querySelector(this.selectors.loader);
		this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		var productJson = document.getElementById("ProductJson-" + sectionId);
		if (!productJson || !productJson.innerHTML.length) {
			return;
		}

		this.productSingleObject = JSON.parse(productJson.innerHTML);

		this.initProductSlider = this._initProductSlider.bind(this);

		this._initProductSlider();
		this._stringOverrides();
		this._initVariants();
		this._initMediaSwitch();
		this._initAddToCart();
		this._setActiveThumbnail();
		this._initProductVideo();
		this._initModelViewerLibraries();
		this._initShopifyXrLaunch();
		this._quantityInputs();
	}

	Product.prototype = Object.assign({}, Product.prototype, {
		_stringOverrides: function () {
			theme.productStrings = theme.productStrings || {};
			theme.strings = Object.assign({}, theme.strings, theme.productStrings);
		},

		_initProductSlider: function () {
            if (this.container.querySelectorAll(this.selectors.productThumbImages).length > 4) {
                this._initThumbnailSlider();
            }
		},

		_initVariants: function () {
			var options = {
				container: this.container,
				enableHistoryState:
					this.container.getAttribute("data-enable-history-state") || false,
				singleOptionSelector: this.selectors.singleOptionSelector,
				originalSelectorId: this.selectors.originalSelectorId,
				product: this.productSingleObject,
			};

			this.variants = new slate.Variants(options);

			this.eventHandlers.updateAvailability = this._updateAvailability.bind(
				this
			);
			this.eventHandlers.updateMedia = this._updateMedia.bind(this);
			this.eventHandlers.updatePrice = this._updatePrice.bind(this);
			this.eventHandlers.updateSKU = this._updateSKU.bind(this);

			this.container.addEventListener(
				"variantChange",
				this.eventHandlers.updateAvailability
			);
			this.container.addEventListener(
				"variantImageChange",
				this.eventHandlers.updateMedia
			);
			this.container.addEventListener(
				"variantPriceChange",
				this.eventHandlers.updatePrice
			);
			this.container.addEventListener(
				"variantSKUChange",
				this.eventHandlers.updateSKU
			);
		},

		_initMediaSwitch: function () {
			if (!document.querySelector(this.selectors.productThumbImages)) {
				return;
			}

			var self = this;

			var productThumbImages = document.querySelectorAll(
				this.selectors.productThumbImages
			);

			this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

			productThumbImages.forEach(function (el) {
				el.addEventListener("click", function (evt) {
					evt.preventDefault();
					var mediaId = el.getAttribute("data-thumbnail-id");

					self._switchMedia(mediaId, evt.detail);
					self._setActiveThumbnail(mediaId);
				});
				el.addEventListener("keyup", self.eventHandlers.handleMediaFocus);
			});
		},

		_initAddToCart: function () {
			var productForm = this.container.querySelector(
				this.selectors.productForm
			);
			productForm.addEventListener(
				"submit",
				function (evt) {
					if (this.addToCart.getAttribute("aria-disabled") === "true") {
						evt.preventDefault();
						return;
					}

					if (!this.ajaxEnabled) return;

					evt.preventDefault();

					this.previouslyFocusedElement = document.activeElement;

					var isInvalidQuantity =
						!!this.quantityInput && this.quantityInput.value <= 0;

					if (isInvalidQuantity) {
						this._showErrorMessage(theme.strings.quantityMinimumMessage);
						return;
					}

					if (!isInvalidQuantity && this.ajaxEnabled) {
						// disable the addToCart and dynamic checkout button while
						// request/cart popup is loading and handle loading state
						this._handleButtonLoadingState(true);
						var form = this.container.querySelector(this.selectors.productForm);
						this._addItemToCart(form);
						return;
					}
				}.bind(this)
			);
		},

		_initProductVideo: function () {
			var sectionId = this.settings.sectionId;

			var productMediaTypeVideo = this.container.querySelectorAll(
				this.selectors.productMediaTypeVideo
			);
			productMediaTypeVideo.forEach(function (el) {
				theme.ProductVideo.init(el, sectionId);
			});
		},

		_initModelViewerLibraries: function () {
			var modelViewerElements = this.container.querySelectorAll(
				this.selectors.productMediaTypeModel
			);
			if (modelViewerElements.length < 1) return;
			theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
		},

		_initShopifyXrLaunch: function () {
			this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
				this
			);
			document.addEventListener(
				"shopify_xr_launch",
				this.eventHandlers.initShopifyXrLaunchHandler
			);
		},

		_initShopifyXrLaunchHandler: function () {
			var currentMedia = this.container.querySelector(
				this.selectors.productMediaWrapper +
					":not(." +
					self.classes.hidden +
					")"
			);
			currentMedia.dispatchEvent(
				new CustomEvent("xrLaunch", {
					bubbles: true,
					cancelable: true,
				})
			);
		},

		_addItemToCart: function (form) {
			var self = this;

			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"X-Requested-With": "XMLHttpRequest",
				},
				body: theme.Helpers.serialize(form),
			})
				.then(function (response) {
					return response.json();
				})
				.then(function (json) {
					if (json.status && json.status !== 200) {
						var error = new Error(json.description);
						error.isFromServer = true;
						throw error;
					}
					self._hideErrorMessage();
					if (theme.settings.enableCartDrawer) {
						self._renderSlideCart();
					} else {
						self._setupCartPopup(json);
					}
				})
				.catch(function (error) {
					self.previouslyFocusedElement.focus();
					self._showErrorMessage(
						error.isFromServer && error.message.length
							? error.message
							: theme.strings.cartError
					);
					self._handleButtonLoadingState(false);
					// eslint-disable-next-line no-console
					console.log(error);
				});
		},

		_handleButtonLoadingState: function (isLoading) {
			if (isLoading) {
				this.addToCart.setAttribute("aria-disabled", true);
				this.addToCartText.classList.add(this.classes.hidden);
				this.loader.classList.remove(this.classes.hidden);

				if (this.settings.enableSticky) {
					this.stickyAddToCart.setAttribute("aria-disabled", true);
				}

				if (this.shopifyPaymentButton) {
					this.shopifyPaymentButton.setAttribute("disabled", true);
				}

				this.loaderStatus.setAttribute("aria-hidden", false);
			} else {
				this.addToCart.removeAttribute("aria-disabled");
				this.addToCartText.classList.remove(this.classes.hidden);
				this.loader.classList.add(this.classes.hidden);

				if (this.settings.enableSticky) {
					this.stickyAddToCart.removeAttribute("aria-disabled");
				}

				if (this.shopifyPaymentButton) {
					this.shopifyPaymentButton.removeAttribute("disabled");
				}

				this.loaderStatus.setAttribute("aria-hidden", true);
			}
		},

		_showErrorMessage: function (errorMessage) {
			var errorMessageContainer = this.container.querySelector(
				this.selectors.errorMessage
			);
			errorMessageContainer.innerHTML = errorMessage;

			if (this.quantityInput) {
				this.quantityInput.classList.add(this.classes.inputError);
			}

			this.errorMessageWrapper.classList.remove(
				this.classes.productFormErrorMessageWrapperHidden
			);
			this.errorMessageWrapper.setAttribute("aria-hidden", true);
			this.errorMessageWrapper.removeAttribute("aria-hidden");
		},

		_hideErrorMessage: function () {
			this.errorMessageWrapper.classList.add(
				this.classes.productFormErrorMessageWrapperHidden
			);

			if (this.quantityInput) {
				this.quantityInput.classList.remove(this.classes.inputError);
			}
		},

		_renderSlideCart: function () {
			// find cart drawer button and click it
			document.querySelector("[data-cart-drawer-button]").click();
			// render a fresh cart
			htmx.ajax("GET", "/cart?view=bare", "#CartBare");
			// set loading state of button to false
			this._handleButtonLoadingState(false);
		},

		_onBodyClick: function (event) {
			var target = event.target;

			if (
				target !== this.cartPopupWrapper &&
				!target.closest(this.selectors.cartPopup)
			) {
				this._hideCartPopup(event);
			}
		},

		_setActiveThumbnail: function (mediaId) {
			// If there is no element passed, find it by the current product image
			if (typeof mediaId === "undefined") {
				var productMediaWrapper = this.container.querySelector(
					this.selectors.productMediaWrapper + ":not(.hide)"
				);

				if (!productMediaWrapper) return;
				mediaId = productMediaWrapper.getAttribute("data-media-id");
			}

			var thumbnailWrappers = this.container.querySelectorAll("[data-thumb-swiper-item]");

			var activeThumbnail;
			thumbnailWrappers.forEach(
				function (el) {
					var current = el.querySelector(`[data-thumbnail-id='${mediaId}']`);
					if (current) {
						activeThumbnail = current;
					}
				}.bind(this)
			);

			var productThumbImages = document.querySelectorAll(
				this.selectors.productThumbImages
			);
			productThumbImages.forEach(
				function (el) {
					el.classList.remove(this.classes.activeClass);
					el.removeAttribute("aria-current");
				}.bind(this)
			);

			if (activeThumbnail) {
				activeThumbnail.classList.add(this.classes.activeClass);
				activeThumbnail.setAttribute("aria-current", true);
				this._adjustThumbnailSlider(activeThumbnail);
			}
		},

		_adjustThumbnailSlider: function (activeThumbnail) {
			var sliderItem = activeThumbnail.closest("[data-slider-item]");
			if (!sliderItem) return;

			var slideGroupLeaderIndex =
				Math.floor(
					Number(sliderItem.getAttribute("data-slider-slide-index")) / 3
				) * 3;

			window.setTimeout(
				function () {
					if (!this.slideshow) return;
					this.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
				}.bind(this),
				251
			);
		},

		_switchMedia: function (mediaId, trigger) {
			var currentMedia = this.container.querySelector(
				this.selectors.productMediaWrapper +
					":not(." +
					this.classes.mdHidden +
					")"
			);

			var newMedia = this.container.querySelector(
				this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
			);

			var otherMedia = this.container.querySelectorAll(
				this.selectors.productMediaWrapper +
					":not([data-media-id='" +
					mediaId +
					"'])"
			);

			currentMedia.dispatchEvent(
				new CustomEvent("mediaHidden", {
					bubbles: true,
					cancelable: true,
				})
			);
			newMedia.classList.remove(this.classes.mdHidden);
			newMedia.dispatchEvent(
				new CustomEvent("mediaVisible", {
					bubbles: true,
					cancelable: true,
				})
			);
			otherMedia.forEach(
				function (el) {
					el.classList.add(this.classes.mdHidden);
				}.bind(this)
			);
            // console.log(trigger)
            // console.log(mediaId)
            
            if (trigger.variant) {
                newMedia.scrollIntoView(false);
            }
		},

		_handleMediaFocus: function (evt) {
			if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

			var mediaId = evt.currentTarget.getAttribute("data-thumbnail-id");

			var productMediaWrapper = this.container.querySelector(
				this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
			);
			productMediaWrapper.focus();
		},

		_initThumbnailSlider: function () {
            const theShow = this.container.querySelector("[data-thumb-swiper]")

            const options = {
                direction: theShow.dataset.orientation || 'vertical',
                slidesPerView: 'auto',
                freeMode: true
            }
            
            const swiper = new Swiper(theShow, options);
            this.slideshow = swiper
            this.settings.sliderActive = true;
		},

		_destroyThumbnailSlider: function () {
			this.settings.sliderActive = false;
			this.slideshow.destroy();
			this.slideshow = null;
		},

		_liveRegionText: function (variant) {
			// Dummy content for live region
			var liveRegionText =
				"[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

			if (!variant) {
				liveRegionText = theme.strings.unavailable;
				return liveRegionText;
			}

			// Update availability
			var availability = variant.available ? "" : theme.strings.soldOut + ",";
			liveRegionText = liveRegionText.replace("[Availability]", availability);

			// Update pricing information
			var regularLabel = "";
			var regularPrice = theme.Currency.formatMoney(
				variant.price,
				theme.moneyFormat
			);
			var saleLabel = "";
			var salePrice = "";
			var unitLabel = "";
			var unitPrice = "";

			if (variant.compare_at_price > variant.price) {
				regularLabel = theme.strings.regularPrice;
				regularPrice =
					theme.Currency.formatMoney(
						variant.compare_at_price,
						theme.moneyFormat
					) + ",";
				saleLabel = theme.strings.sale;
				salePrice = theme.Currency.formatMoney(
					variant.price,
					theme.moneyFormat
				);
			}

			if (variant.unit_price) {
				unitLabel = theme.strings.unitPrice;
				unitPrice =
					theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
					" " +
					theme.strings.unitPriceSeparator +
					" " +
					this._getBaseUnit(variant);
			}

			liveRegionText = liveRegionText
				.replace("[Regular]", regularLabel)
				.replace("[$$]", regularPrice)
				.replace("[Sale]", saleLabel)
				.replace("[$]", salePrice)
				.replace("[UnitPrice]", unitLabel)
				.replace("[$$$]", unitPrice)
				.trim();

			return liveRegionText;
		},

		_updateLiveRegion: function (evt) {
			var variant = evt.detail.variant;
			var liveRegion = this.container.querySelector(
				this.selectors.productStatus
			);
			liveRegion.innerHTML = this._liveRegionText(variant);
			liveRegion.setAttribute("aria-hidden", false);
			// hide content from accessibility tree after announcement
			setTimeout(function () {
				liveRegion.setAttribute("aria-hidden", true);
			}, 1000);
		},

		_updateAddToCart: function (evt) {
			var variant = evt.detail.variant;
			var addToCartText = this.container.querySelector(
				this.selectors.addToCartText
			);
			var productForm = this.container.querySelector(
				this.selectors.productForm
			);

			if (variant) {
				if (variant.available) {
					this.addToCart.removeAttribute("aria-disabled");
					this.addToCart.setAttribute("aria-label", theme.strings.addToCart);
					addToCartText.innerHTML = theme.strings.addToCart;
					productForm.classList.remove(this.classes.variantSoldOut);
					if (this.settings.enableSticky) {
						this.stickyAddToCart.removeAttribute("aria-disabled");
						this.stickyAddToCart.setAttribute(
							"aria-label",
							theme.strings.addToCart
						);
						this.stickyAddToCartText.innerHTML = theme.strings.addToCart;
					}
				} else {
					// Variant is sold out, disable submit button and change the text.
					this.addToCart.setAttribute("aria-disabled", true);
					this.addToCart.setAttribute("aria-label", theme.strings.soldOut);
					addToCartText.innerHTML = theme.strings.soldOut;
					productForm.classList.add(this.classes.variantSoldOut);
					if (this.settings.enableSticky) {
						this.stickyAddToCart.setAttribute("aria-disabled", true);
						this.stickyAddToCart.setAttribute(
							"aria-label",
							theme.strings.soldOut
						);
						this.stickyAddToCartText.innerHTML = theme.strings.soldOut;
					}
				}
			} else {
				// The variant doesn't exist, disable submit button and change the text.
				this.addToCart.setAttribute("aria-disabled", true);
				this.addToCart.setAttribute("aria-label", theme.strings.unavailable);
				addToCartText.innerHTML = theme.strings.unavailable;
				productForm.classList.add(this.classes.variantSoldOut);
				if (this.settings.enableSticky) {
					this.stickyAddToCart.setAttribute("aria-disabled", true);
					this.stickyAddToCart.setAttribute(
						"aria-label",
						theme.strings.unavailable
					);
					this.stickyAddToCartText.innerHTML = theme.strings.unavailable;
				}
			}
		},

		_updateAvailability: function (evt) {
			// remove error message if one is showing
			this._hideErrorMessage();

			// update form submit
			this._updateAddToCart(evt);
			// update live region
			this._updateLiveRegion(evt);

			this._updatePrice(evt);
		},


		_updateMedia: function (evt) {
			var variant = evt.detail.variant;
			var mediaId = variant.featured_media.id;
			var sectionMediaId = this.settings.sectionId + "-" + mediaId;
			// var trigger = evt.detail;
            // console.log(trigger)
			this._switchMedia(sectionMediaId, evt.detail);
			this._setActiveThumbnail(sectionMediaId);
		},

		_updatePrice: function (evt) {
			var variant = evt.detail.variant;

			var priceContainer = this.container.querySelector(
				this.selectors.priceContainer
			);
			var regularPrices = priceContainer.querySelectorAll(
				this.selectors.regularPrice
			);
			var salePrice = priceContainer.querySelector(this.selectors.salePrice);
			var unitPrice = priceContainer.querySelector(this.selectors.unitPrice);
			var unitPriceBaseUnit = priceContainer.querySelector(
				this.selectors.unitPriceBaseUnit
			);

			var formatRegularPrice = function (regularPriceElement, price) {
				regularPriceElement.innerHTML = theme.Currency.formatMoney(
					price,
					theme.moneyFormat
				);
			};

			// Reset product price state

			var showIfs = document.querySelectorAll("[data-show-if]");
			var showIfSales = document.querySelectorAll("[data-show-if='sale']");
			var showIfRegulars = document.querySelectorAll(
				"[data-show-if='regular']"
			);
			var showIfUnavailables = document.querySelectorAll(
				"[data-show-if='unavailable']"
			);
			var showIfUnits = document.querySelectorAll("[data-show-if='units']");

			priceContainer.classList.remove(
				this.classes.productUnavailable,
				this.classes.productOnSale,
				this.classes.productUnitAvailable,
				this.classes.productSoldOut
			);
			priceContainer.removeAttribute("aria-hidden");

			showIfs.forEach(function (element) {
				element.classList.add("hidden");
			});

			if (this.productPolicies) {
				this.productPolicies.classList.remove(this.classes.visibilityHidden);
			}

			// Unavailable
			if (!variant) {
				showIfUnavailables.forEach(function (element) {
					element.classList.remove("hidden");
				});
				priceContainer.setAttribute("aria-hidden", true);

				if (this.productPolicies) {
					this.productPolicies.classList.add(this.classes.visibilityHidden);
				}
				return;
			}

			// Sold out
			if (!variant.available) {
				showIfUnavailables.forEach(function (element) {
					element.classList.remove("hidden");
				});
			}

			// On sale
			if (variant.compare_at_price > variant.price) {
				regularPrices.forEach(function (regularPrice) {
					formatRegularPrice(regularPrice, variant.compare_at_price);
				});

				salePrice.innerHTML = theme.Currency.formatMoney(
					variant.price,
					theme.moneyFormat
				);
				showIfSales.forEach(function (element) {
					element.classList.remove("hidden");
				});
			} else {
				// Regular price
				regularPrices.forEach(function (regularPrice) {
					formatRegularPrice(regularPrice, variant.price);
				});
				showIfRegulars.forEach(function (element) {
					element.classList.remove("hidden");
				});
			}

			// Unit price
			if (variant.unit_price) {
				unitPrice.innerHTML = theme.Currency.formatMoney(
					variant.unit_price,
					theme.moneyFormat
				);
				unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
				showIfUnits.forEach(function (element) {
					element.classList.remove("hidden");
				});
			}
		},

		_getBaseUnit: function (variant) {
			return variant.unit_price_measurement.reference_value === 1
				? variant.unit_price_measurement.reference_unit
				: variant.unit_price_measurement.reference_value +
						variant.unit_price_measurement.reference_unit;
		},

		_updateSKU: function (evt) {
			var variant = evt.detail.variant;

			// Update the sku
			var sku = document.querySelector(this.selectors.SKU);
			if (!sku) return;
			sku.innerHTML = variant.sku;
		},

		_quantityInputs: function () {
			if (this.quantityInput) {
				var quantityInput = this.quantityInput;
				this.quantityPlusButton.addEventListener("click", function () {
					quantityInput.value++;
				});
				this.quantityMinusButton.addEventListener("click", function () {
					if (quantityInput.value > 1) {
						quantityInput.value--;
					} else {
						return;
					}
				});
			}
		},

		onUnload: function () {
			this.container.removeEventListener(
				"variantChange",
				this.eventHandlers.updateAvailability
			);
			this.container.removeEventListener(
				"variantImageChange",
				this.eventHandlers.updateMedia
			);
			this.container.removeEventListener(
				"variantPriceChange",
				this.eventHandlers.updatePrice
			);
			this.container.removeEventListener(
				"variantSKUChange",
				this.eventHandlers.updateSKU
			);
			theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
			theme.ProductModel.removeSectionModels(this.settings.sectionId);

		},
	});

	return Product;
})();

theme.Quotes = (function () {
	function Quotes(container) {
        const theShow = container.querySelector(".swiper-container")
        const delay = theShow.dataset.autoPlay ? parseInt(theShow.dataset.autoPlay, 10) : 0
        const loop = theShow.dataset.loop == "false" ? false : true
        const arrows = theShow.dataset.arrows == "false" ? false : true
        const pagination = theShow.dataset.pagination == "false" ? false : true
        const options = {
            loop: loop,
            slidesPerView: 1,
            spaceBetween: 10,
            // Responsive breakpoints
            breakpoints: {
              767: {
                slidesPerView: 3,
                spaceBetween: 30
              },
            },
        }

        if (delay > 0) {
            options.autoplay = { delay: delay }
        }
        if (arrows) {
            const nextEl = container.querySelector(".swiper-button-next")
            const prevEl = container.querySelector(".swiper-button-prev")
            options.navigation = {
                nextEl: nextEl,
                prevEl: prevEl,
            }
        }
        if (pagination) {
            const pagination = container.querySelector(".swiper-pagination")
            options.pagination = {
                el: pagination,
                type: 'bullets',
                clickable: true
            }
        }

        const swiper = new Swiper(theShow, options);
	}
	return Quotes;
})();

theme.SlideshowSection = (function () {
	function SlideshowSection(container) {
        const theShow = container.querySelector(".swiper-container")
        const delay = theShow.dataset.autoPlay ? parseInt(theShow.dataset.autoPlay, 10) : 0
        const loop = theShow.dataset.loop == "false" ? false : true
        const arrows = theShow.dataset.arrows == "false" ? false : true
        const pagination = theShow.dataset.pagination == "false" ? false : true
        const options = {
            loop: loop,
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 30,
                slideShadows: false,
            },
        }

        if (delay > 0) {
            options.autoplay = { delay: delay }
        }
        if (arrows) {
            const nextEl = container.querySelector(".swiper-button-next")
            const prevEl = container.querySelector(".swiper-button-prev")
            options.navigation = {
                nextEl: nextEl,
                prevEl: prevEl,
            }
        }
        if (pagination) {
            const pagination = container.querySelector(".swiper-pagination")
            options.pagination = {
                el: pagination,
                type: 'bullets',
                clickable: true
            }
        }

        const swiper = new Swiper(theShow, options);
	}
	return SlideshowSection;
})();

theme.VideoSection = (function () {
	function VideoSection(container) {
		container.querySelectorAll(".video").forEach(function (el) {
			theme.Video.init(el);
			theme.Video.editorLoadVideo(el.id);
		});
	}

	return VideoSection;
})();

theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
	onUnload: function () {
		theme.Video.removeEvents();
	},
});

theme.ProductModel = (function () {
	var modelJsonSections = {};
	var models = {};
	var xrButtons = {};

	var selectors = {
		mediaGroup: "[data-product-single-media-group]",
		xrButton: "[data-shopify-xr]",
	};

	function init(modelViewerContainers, sectionId) {
		modelJsonSections[sectionId] = {
			loaded: false,
		};

		modelViewerContainers.forEach(function (modelViewerContainer, index) {
			var mediaId = modelViewerContainer.getAttribute("data-media-id");
			var modelViewerElement = modelViewerContainer.querySelector(
				"model-viewer"
			);
			var modelId = modelViewerElement.getAttribute("data-model-id");

			if (index === 0) {
				var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
				var xrButton = mediaGroup.querySelector(selectors.xrButton);
				xrButtons[sectionId] = {
					element: xrButton,
					defaultId: modelId,
				};
			}

			models[mediaId] = {
				modelId: modelId,
				sectionId: sectionId,
				container: modelViewerContainer,
				element: modelViewerElement,
			};
		});

		window.Shopify.loadFeatures([
			{
				name: "shopify-xr",
				version: "1.0",
				onLoad: setupShopifyXr,
			},
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: setupModelViewerUi,
			},
		]);
		theme.LibraryLoader.load("modelViewerUiStyles");
	}

	function setupShopifyXr(errors) {
		if (errors) return;

		if (!window.ShopifyXR) {
			document.addEventListener("shopify_xr_initialized", function () {
				setupShopifyXr();
			});
			return;
		}

		for (var sectionId in modelJsonSections) {
			if (modelJsonSections.hasOwnProperty(sectionId)) {
				var modelSection = modelJsonSections[sectionId];

				if (modelSection.loaded) continue;
				var modelJson = document.querySelector("#ModelJson-" + sectionId);

				window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
				modelSection.loaded = true;
			}
		}
		window.ShopifyXR.setupXRElements();
	}

	function setupModelViewerUi(errors) {
		if (errors) return;

		for (var key in models) {
			if (models.hasOwnProperty(key)) {
				var model = models[key];
				if (!model.modelViewerUi) {
					model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
				}
				setupModelViewerListeners(model);
			}
		}
	}

	function setupModelViewerListeners(model) {
		var xrButton = xrButtons[model.sectionId];

		model.container.addEventListener("mediaVisible", function () {
			xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
			if (theme.Helpers.isTouch()) return;
			model.modelViewerUi.play();
		});

		model.container.addEventListener("mediaHidden", function () {
			xrButton.element.setAttribute(
				"data-shopify-model3d-id",
				xrButton.defaultId
			);
			model.modelViewerUi.pause();
		});

		model.container.addEventListener("xrLaunch", function () {
			model.modelViewerUi.pause();
		});
	}

	function removeSectionModels(sectionId) {
		for (var key in models) {
			if (models.hasOwnProperty(key)) {
				var model = models[key];
				if (model.sectionId === sectionId) {
					models[key].modelViewerUi.destroy();
					delete models[key];
				}
			}
		}
		delete modelJsonSections[sectionId];
	}

	return {
		init: init,
		removeSectionModels: removeSectionModels,
	};
})();

theme.FormStatus = (function () {
	var selectors = {
		statusMessage: "[data-form-status]",
	};

	function init() {
		var statusMessages = document.querySelectorAll(selectors.statusMessage);

		statusMessages.forEach(function (statusMessage) {
			statusMessage.setAttribute("tabindex", -1);
			statusMessage.focus();

			statusMessage.addEventListener(
				"blur",
				function (evt) {
					evt.target.removeAttribute("tabindex");
				},
				{ once: true }
			);
		});
	}

	return {
		init: init,
	};
})();

theme.SearchResultsTemplate = (function () {
	function renderResults(products, isLoading, searchQuery) {
		return [
			'<div class="predictive-search">',
			renderHeader(products, isLoading),
			renderProducts(products, searchQuery),
			"</div>",
		].join("");
	}

	function renderHeader(products, isLoading) {
		if (products.length === 0) {
			return "";
		}

		return [
			'<div class="predictive-search-title">',
			'<h3 id="predictive-search" class="predictive-search-title__content">' +
				theme.strings.products +
				"</h3>",
			'<span class="predictive-search-title__loading-spinner">' +
				(isLoading
					? '<span class= "icon-predictive-search-spinner" ></span >'
					: "") +
				"</span>",
			"</div>",
		].join("");
	}

	function loadingState() {
		return [
			'<div class="predictive-search">',
			'<div class="predictive-search-loading">',
			'<span class="visually-hidden">' + theme.strings.loading + "</span>",
			'<span class="predictive-search-loading__icon">',
			'<span class="icon-predictive-search-spinner"></span>',
			"</span>",
			"</div>",
			"</div>",
		].join("");
	}

	function renderViewAll(searchQuery) {
		return [
			'<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
			theme.strings.searchFor +
				'<span class="predictive-search-view-all__query"> &ldquo;' +
				_htmlEscape(searchQuery) +
				"&rdquo;</span>",
			"</button>",
		].join("");
	}

	function renderProducts(products, searchQuery) {
		var resultsCount = products.length;

		return [
			'<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
			products
				.map(function (product, index) {
					return renderProduct(normalizeProduct(product), index, resultsCount);
				})
				.join(""),
			'<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
				renderViewAll(searchQuery) +
				"</li>",
			"</ul>",
		].join("");
	}

	function renderProduct(product, index, resultsCount) {
		return [
			'<li id="search-result-' +
				index +
				'" class="predictive-search-item" role="option" data-search-result>',
			'<a class="predictive-search-item__link" href="' +
				product.url +
				'" tabindex="-1">',
			'<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
			renderProductImage(product),
			"</div>",
			'<div class="predictive-search__column predictive-search__column--content ' +
				(getDetailsCount() ? "" : "predictive-search__column--center") +
				'">',
			'<span class="predictive-search-item__title">',
			'<span class="predictive-search-item__title-text">' +
				product.title +
				"</span>",
			"</span>" + (getDetailsCount() ? renderProductDetails(product) : ""),
			'<span class="visually-hidden">, </span>',
			'<span class="visually-hidden">' +
				getNumberOfResultsString(index + 1, resultsCount) +
				"</span>",
			"</div>",
			"</a>",
			"</li>",
		].join("");
	}

	function renderProductImage(product) {
		if (product.image === null) {
			return "";
		}

		return (
			'<img class="predictive-search-item__image lazyload" src="' +
			product.image.url +
			'" data-src="' +
			product.image.url +
			'" data-image alt="' +
			product.image.alt +
			'" />'
		);
	}

	function renderProductDetails(product) {
		return [
			'<dl class="predictive-search-item__details price' +
				(product.isOnSale ? " price--on-sale" : "") +
				(!product.available ? " price--sold-out" : "") +
				(!product.isPriceVaries && product.isCompareVaries
					? " price--compare-price-hidden"
					: "") +
				'">',
			'<div class="predictive-search-item__detail">',
			renderVendor(product),
			"</div>",
			'<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
				renderProductPrice(product),
			"</div>",
			"</dl>",
		].join("");
	}
	function renderProductPrice(product) {
		if (!theme.settings.predictiveSearchShowPrice) {
			return "";
		}

		var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

		var priceMarkup =
			'<div class="price__regular">' + renderPrice(product) + "</div>";

		var salePriceMarkup =
			'<div class="price__sale">' + renderSalePrice(product) + "</div>";

		return (
			accessibilityAnnounceComma +
			'<div class="price__pricing-group">' +
			(product.isOnSale ? salePriceMarkup : priceMarkup) +
			"</div>"
		);
	}

	function renderSalePrice(product) {
		return [
			"<dt>",
			'<span class="visually-hidden">' + theme.strings.salePrice + "</span>",
			"</dt>",
			"<dd>",
			'<span class="predictive-search-item__price predictive-search-item__price--sale">' +
				(product.isPriceVaries
					? theme.strings.fromLowestPrice.replace("[price]", product.price)
					: product.price) +
				"</span>",
			"</dd>",
			'<div class="price__compare">' + renderCompareAtPrice(product) + "</div>",
		].join("");
	}

	function renderCompareAtPrice(product) {
		return [
			"<dt>",
			'<span class="visually-hidden">' +
				theme.strings.regularPrice +
				"</span> ",
			"</dt>",
			"<dd>",
			'<span class="predictive-search-item__price predictive-search-item__price--compare">' +
				product.compareAtPrice +
				"</span>",
			"</dd>",
		].join("");
	}

	function renderPrice(product) {
		return [
			"<dt>",
			'<span class="visually-hidden">' + theme.strings.regularPrice + "</span>",
			"</dt>",
			"<dd>",
			'<span class="predictive-search-item__price">' +
				(product.isPriceVaries
					? theme.strings.fromLowestPrice.replace("[price]", product.price)
					: product.price) +
				"</span>",
			"</dd>",
		].join("");
	}

	function renderVendor(product) {
		if (!theme.settings.predictiveSearchShowVendor || product.vendor === "") {
			return "";
		}

		return [
			"<dt>",
			'<span class="visually-hidden">' + theme.strings.vendor + "</span>",
			"</dt>",
			'<dd class="predictive-search-item__vendor">' + product.vendor + "</dd>",
		].join("");
	}

	function normalizeProduct(product) {
		var productOrVariant =
			product.variants.length > 0 ? product.variants[0] : product;

		return {
			url: productOrVariant.url,
			image: getProductImage(product),
			title: product.title,
			vendor: product.vendor || "",
			price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
			compareAtPrice: theme.Currency.formatMoney(
				product.compare_at_price_min,
				theme.moneyFormat
			),
			available: product.available,
			isOnSale: isOnSale(product),
			isPriceVaries: isPriceVaries(product),
			isCompareVaries: isCompareVaries(product),
		};
	}

	function getProductImage(product) {
		var image;
		var featuredImage;

		if (product.variants.length > 0 && product.variants[0].image !== null) {
			featuredImage = product.variants[0].featured_image;
		} else if (product.image) {
			featuredImage = product.featured_image;
		} else {
			image = null;
		}

		if (image !== null) {
			image = {
				url: theme.Images.getSizedImageUrl(featuredImage.url, "100x"),
				alt: featuredImage.alt,
			};
		}

		return image;
	}

	function isOnSale(product) {
		return (
			product.compare_at_price_min !== null &&
			parseInt(product.compare_at_price_min, 10) >
				parseInt(product.price_min, 10)
		);
	}

	function isPriceVaries(product) {
		return product.price_max !== product.price_min;
	}

	function isCompareVaries(product) {
		return product.compare_at_price_max !== product.compare_at_price_min;
	}

	// Returns the number of optional product details to be shown,
	// values of the detailsList need to be boolean.
	function getDetailsCount() {
		var detailsList = [
			theme.settings.predictiveSearchShowPrice,
			theme.settings.predictiveSearchShowVendor,
		];

		var detailsCount = detailsList.reduce(function (acc, detail) {
			return acc + (detail ? 1 : 0);
		}, 0);

		return detailsCount;
	}

	function getNumberOfResultsString(resultNumber, resultsCount) {
		return theme.strings.number_of_results
			.replace("[result_number]", resultNumber)
			.replace("[results_count]", resultsCount);
	}

	function _htmlEscape(input) {
		return input
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	return function (data) {
		var products = data.products || [];
		var isLoading = data.isLoading;
		var searchQuery = data.searchQuery || "";

		if (isLoading && products.length === 0) {
			return loadingState();
		}

		return renderResults(products, isLoading, searchQuery);
	};
})();

theme.Disclosure = (function () {
	var selectors = {
		disclosureForm: "[data-disclosure-form]",
		disclosureList: "[data-disclosure-list]",
		disclosureToggle: "[data-disclosure-toggle]",
		disclosureInput: "[data-disclosure-input]",
		disclosureOptions: "[data-disclosure-option]",
	};

	var classes = {
		listVisible: "disclosure-list--visible",
	};

	function Disclosure(disclosure) {
		this.container = disclosure;
		this._cacheSelectors();
		this._setupListeners();
	}

	Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
		_cacheSelectors: function () {
			this.cache = {
				disclosureForm: this.container.closest(selectors.disclosureForm),
				disclosureList: this.container.querySelector(selectors.disclosureList),
				disclosureToggle: this.container.querySelector(
					selectors.disclosureToggle
				),
				disclosureInput: this.container.querySelector(
					selectors.disclosureInput
				),
				disclosureOptions: this.container.querySelectorAll(
					selectors.disclosureOptions
				),
			};
		},

		_setupListeners: function () {
			this.eventHandlers = this._setupEventHandlers();

			this.cache.disclosureToggle.addEventListener(
				"click",
				this.eventHandlers.toggleList
			);

			this.cache.disclosureOptions.forEach(function (disclosureOption) {
				disclosureOption.addEventListener(
					"click",
					this.eventHandlers.connectOptions
				);
			}, this);

			this.container.addEventListener(
				"keyup",
				this.eventHandlers.onDisclosureKeyUp
			);

			this.cache.disclosureList.addEventListener(
				"focusout",
				this.eventHandlers.onDisclosureListFocusOut
			);

			this.cache.disclosureToggle.addEventListener(
				"focusout",
				this.eventHandlers.onDisclosureToggleFocusOut
			);

			document.body.addEventListener("click", this.eventHandlers.onBodyClick);
		},

		_setupEventHandlers: function () {
			return {
				connectOptions: this._connectOptions.bind(this),
				toggleList: this._toggleList.bind(this),
				onBodyClick: this._onBodyClick.bind(this),
				onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
				onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
				onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
			};
		},

		_connectOptions: function (event) {
			event.preventDefault();

			this._submitForm(event.currentTarget.dataset.value);
		},

		_onDisclosureToggleFocusOut: function (event) {
			var disclosureLostFocus =
				this.container.contains(event.relatedTarget) === false;

			if (disclosureLostFocus) {
				this._hideList();
			}
		},

		_onDisclosureListFocusOut: function (event) {
			var childInFocus = event.currentTarget.contains(event.relatedTarget);

			var isVisible = this.cache.disclosureList.classList.contains(
				classes.listVisible
			);

			if (isVisible && !childInFocus) {
				this._hideList();
			}
		},

		_onDisclosureKeyUp: function (event) {
			if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
			this._hideList();
			this.cache.disclosureToggle.focus();
		},

		_onBodyClick: function (event) {
			var isOption = this.container.contains(event.target);
			var isVisible = this.cache.disclosureList.classList.contains(
				classes.listVisible
			);

			if (isVisible && !isOption) {
				this._hideList();
			}
		},

		_submitForm: function (value) {
			this.cache.disclosureInput.value = value;
			this.cache.disclosureForm.submit();
		},

		_hideList: function () {
			this.cache.disclosureList.classList.remove(classes.listVisible);
			this.cache.disclosureToggle.setAttribute("aria-expanded", false);
		},

		_toggleList: function () {
			var ariaExpanded =
				this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
			this.cache.disclosureList.classList.toggle(classes.listVisible);
			this.cache.disclosureToggle.setAttribute("aria-expanded", !ariaExpanded);
		},

		destroy: function () {
			this.cache.disclosureToggle.removeEventListener(
				"click",
				this.eventHandlers.toggleList
			);

			this.cache.disclosureOptions.forEach(function (disclosureOption) {
				disclosureOption.removeEventListener(
					"click",
					this.eventHandlers.connectOptions
				);
			}, this);

			this.container.removeEventListener(
				"keyup",
				this.eventHandlers.onDisclosureKeyUp
			);

			this.cache.disclosureList.removeEventListener(
				"focusout",
				this.eventHandlers.onDisclosureListFocusOut
			);

			this.cache.disclosureToggle.removeEventListener(
				"focusout",
				this.eventHandlers.onDisclosureToggleFocusOut
			);

			document.body.removeEventListener(
				"click",
				this.eventHandlers.onBodyClick
			);
		},
	});

	return Disclosure;
})();

/* ================ TEMPLATES ================ */
(function () {
	var filterBys = document.querySelectorAll("[data-blog-tag-filter]");

	if (!filterBys.length) return;

	slate.utils.resizeSelects(filterBys);

	filterBys.forEach(function (filterBy) {
		filterBy.addEventListener("change", function (evt) {
			location.href = evt.target.value;
		});
	});
})();

theme.customerTemplates = (function () {
	var selectors = {
		RecoverHeading: "#RecoverHeading",
		RecoverEmail: "#RecoverEmail",
		LoginHeading: "#LoginHeading",
	};

	function initEventListeners() {
		this.recoverHeading = document.querySelector(selectors.RecoverHeading);
		this.recoverEmail = document.querySelector(selectors.RecoverEmail);
		this.loginHeading = document.querySelector(selectors.LoginHeading);
		var recoverPassword = document.getElementById("RecoverPassword");
		var hideRecoverPasswordLink = document.getElementById(
			"HideRecoverPasswordLink"
		);

		// Show reset password form
		if (recoverPassword) {
			recoverPassword.addEventListener(
				"click",
				function (evt) {
					evt.preventDefault();
					showRecoverPasswordForm();
					this.recoverHeading.setAttribute("tabindex", "-1");
					this.recoverHeading.focus();
				}.bind(this)
			);
		}

		// Hide reset password form
		if (hideRecoverPasswordLink) {
			hideRecoverPasswordLink.addEventListener(
				"click",
				function (evt) {
					evt.preventDefault();
					hideRecoverPasswordForm();
					this.loginHeading.setAttribute("tabindex", "-1");
					this.loginHeading.focus();
				}.bind(this)
			);
		}

		if (this.recoverHeading) {
			this.recoverHeading.addEventListener("blur", function (evt) {
				evt.target.removeAttribute("tabindex");
			});
		}

		if (this.loginHeading) {
			this.loginHeading.addEventListener("blur", function (evt) {
				evt.target.removeAttribute("tabindex");
			});
		}
	}

	/**
	 *
	 *  Show/Hide recover password form
	 *
	 */

	function showRecoverPasswordForm() {
		document.getElementById("RecoverPasswordForm").classList.remove("hide");
		document.getElementById("CustomerLoginForm").classList.add("hide");

		if (this.recoverEmail.getAttribute("aria-invalid") === "true") {
			this.recoverEmail.focus();
		}
	}

	function hideRecoverPasswordForm() {
		document.getElementById("RecoverPasswordForm").classList.add("hide");
		document.getElementById("CustomerLoginForm").classList.remove("hide");
	}

	/**
	 *
	 *  Show reset password success message
	 *
	 */
	function resetPasswordSuccess() {
		var formState = document.querySelector(".reset-password-success");

		// check if reset password form was successfully submited.
		if (!formState) {
			return;
		}

		// show success message
		var resetSuccess = document.getElementById("ResetSuccess");
		resetSuccess.classList.remove("hide");
		resetSuccess.focus();
	}

	/**
	 *
	 *  Show/hide customer address forms
	 *
	 */
	function customerAddressForm() {
		var newAddressForm = document.getElementById("AddressNewForm");
		var newAddressFormButton = document.getElementById("AddressNewButton");

		if (!newAddressForm) {
			return;
		}

		// Initialize observers on address selectors, defined in shopify_common.js
		if (Shopify) {
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(
				"AddressCountryNew",
				"AddressProvinceNew",
				{
					hideElement: "AddressProvinceContainerNew",
				}
			);
		}

		// Initialize each edit form's country/province selector
		document
			.querySelectorAll(".address-country-option")
			.forEach(function (option) {
				var formId = option.dataset.formId;
				var countrySelector = "AddressCountry_" + formId;
				var provinceSelector = "AddressProvince_" + formId;
				var containerSelector = "AddressProvinceContainer_" + formId;

				// eslint-disable-next-line no-new
				new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
					hideElement: containerSelector,
				});
			});

		// Toggle new/edit address forms
		document
			.querySelectorAll("[data-address-toggle]")
			.forEach(function (button) {
				button.addEventListener("click", function () {
					var isExpanded =
						newAddressFormButton.getAttribute("aria-expanded") === "true";

					newAddressForm.classList.toggle("hidden");
					newAddressFormButton.setAttribute("aria-expanded", !isExpanded);
					newAddressFormButton.focus();
				});
			});

		document
			.querySelectorAll("[data-address-edit-toggle]")
			.forEach(function (button) {
				button.addEventListener("click", function (evt) {
					var formId = evt.target.dataset.formId;
					var editButton = document.getElementById("EditFormButton_" + formId);
					var editAddress = document.getElementById("EditAddress_" + formId);
					var isExpanded = editButton.getAttribute("aria-expanded") === "true";

					editAddress.classList.toggle("hidden");
					editButton.setAttribute("aria-expanded", !isExpanded);
					editButton.focus();
				});
			});

		document
			.querySelectorAll("[data-address-delete]")
			.forEach(function (button) {
				button.addEventListener("click", function (evt) {
					var target = evt.target.dataset.target;
					var confirmMessage = evt.target.dataset.confirmMessage;

					// eslint-disable-next-line no-alert
					if (
						confirm(
							confirmMessage || "Are you sure you wish to delete this address?"
						)
					) {
						Shopify.postLink(target, {
							parameters: { _method: "delete" },
						});
					}
				});
			});
	}

	/**
	 *
	 *  Check URL for reset password hash
	 *
	 */
	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === "#recover") {
			showRecoverPasswordForm.bind(this)();
		}
	}

	return {
		init: function () {
			initEventListeners();
			checkUrlHash();
			resetPasswordSuccess();
			customerAddressForm();
		},
	};
})();

document.addEventListener("DOMContentLoaded", function () {
	var sections = new theme.Sections();

	sections.register("cart-template", theme.Cart);
	sections.register("product", theme.Product);
	sections.register("collection-template", theme.Filters);
	sections.register("product-template", theme.Product);
	sections.register("header-section", theme.HeaderSection);
	sections.register("map", theme.Maps);
	sections.register("slideshow-section", theme.SlideshowSection);
	sections.register("video-section", theme.VideoSection);
	sections.register("quotes", theme.Quotes);
	sections.register("cycle", theme.CycleSection);

	sections.register("product-recommendations", theme.ProductRecommendations);
	sections.register("footer-section", theme.FooterSection);

	theme.customerTemplates.init();

	// Theme-specific selectors to make iframes responsive
	var iframeSelectors =
		'.rte iframe[src*="youtube.com/embed"],' +
		'.rte iframe[src*="player.vimeo"],' +
		'.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
		'.custom__item-inner--html iframe[src*="player.vimeo"]';

	slate.rte.wrapIframe({
		iframes: document.querySelectorAll(iframeSelectors),
		iframeWrapperClass: "video-wrapper",
	});

	// Common a11y fixes
	slate.a11y.pageLinkFocus(
		document.getElementById(window.location.hash.substr(1))
	);

	var inPageLink = document.querySelector(".in-page-link");
	if (inPageLink) {
		inPageLink.addEventListener("click", function (evt) {
			slate.a11y.pageLinkFocus(
				document.getElementById(evt.currentTarget.hash.substr(1))
			);
		});
	}

	document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
		anchor.addEventListener("click", function (evt) {
			evt.preventDefault();
		});
	});

	slate.a11y.accessibleLinks({
		messages: {
			newWindow: theme.strings.newWindow,
			external: theme.strings.external,
			newWindowExternal: theme.strings.newWindowExternal,
		},
		links: document.querySelectorAll(
			"a[href]:not([aria-describedby]), .product-single__thumbnail"
		),
	});

	theme.FormStatus.init();

	document.addEventListener(
		"touchstart",
		function () {
			theme.Helpers.setTouch();
		},
		{ once: true }
	);

});

// Youtube API callback
function onYouTubeIframeAPIReady() {
	theme.Video.loadVideos();
	theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelectorAll("[data-accordion-siblings]")) {
		const containers = document.querySelectorAll("[data-accordion-siblings]");

		const closeOthers = function (evt, summaries) {
			summaries.forEach((summary) => {
				if (summary != evt.target) {
					summary.parentElement.removeAttribute("open");
				}
			});
		};

		containers.forEach((container) => {
			const summaries = container.querySelectorAll(
				"[data-accordion-sibling] > summary"
			);
			summaries.forEach((summary) => {
				summary.addEventListener("click", (evt) => {
					closeOthers(evt, summaries);
				});
			});
		});
	}
});

theme.CartDrawer = (function () {
	var selectors = {
		headerSection: "[data-header-section]",
		drawer: "[data-cart-drawer]",
		drawerOpenButton: "[data-cart-drawer-button]",
		drawerCloseButton: "[data-cart-close]",
	};

	var drawerInstance;

	function init() {
		setAccessibilityProps();

		drawerInstance = new theme.Drawers("CartDrawer", "right", {
			onDrawerOpen: function () {
				theme.MobileNav.closeMobileNav();
				if (theme.settings.enableQuickShop) {
					document.querySelector("[data-quick-shop]").classList.add("hidden");
				}
				lockBodyScroll();
			},
			onDrawerClose: function () {
				var drawerOpenButton = document.querySelector(
					selectors.drawerOpenButton
				);
				if (drawerOpenButton) drawerOpenButton.focus();
				unlockBodyScroll();
			},
		});
	}

	function setAccessibilityProps() {
		var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

		if (drawerOpenButton) {
			drawerOpenButton.setAttribute("aria-controls", "CartDrawer");
			drawerOpenButton.setAttribute("aria-expanded", "false");
			drawerOpenButton.setAttribute("aria-controls", "dialog");
		}
	}

	function close() {
		drawerInstance.close();
	}

	function lockBodyScroll() {
		theme.Helpers.enableScrollLock();
	}

	function unlockBodyScroll() {
		theme.Helpers.disableScrollLock();
	}

	return {
		init: init,
		close: close,
	};
})();

if (window.theme.settings.devMode) {
	document.addEventListener(
		"focusin",
		function () {
			console.log("focused: ", document.activeElement);
		},
		true
	);
}

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector("[data-sticky-add-to-cart]")) {
		const stickyContainer = document.querySelector(
			"[data-sticky-add-to-cart-container]"
		);
		const stickyButton = document.querySelector("[data-sticky-add-to-cart]");
		const regularButton = document.querySelector("[data-add-to-cart]");
		const footer = document.querySelector("footer");

		let atcIntersection = true;
		let footerIntersection = true;

		let options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.5,
		};

		let callback = (entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target == regularButton) {
						atcIntersection = true;
					} else if (entry.target == footer) {
						footerIntersection = true;
					}
				} else {
					if (entry.target == regularButton) {
						atcIntersection = false;
					} else if (entry.target == footer) {
						footerIntersection = false;
					}
				}
			});
			if (atcIntersection || footerIntersection) {
				hideSticky();
			} else {
				showSticky();
			}
		};

		let stickyObserver = new IntersectionObserver(callback, options);

		stickyObserver.observe(regularButton);
		stickyObserver.observe(footer);

		function showSticky() {
			if (stickyContainer.classList.contains("opacity-0")) {
				stickyContainer.classList.remove("opacity-0", "pointer-events-none");
			}
		}
		function hideSticky() {
			if (stickyContainer.classList.contains("opacity-0")) {
				return;
			} else {
				stickyContainer.classList.add("opacity-0", "pointer-events-none");
			}
		}

		stickyButton.addEventListener("click", function () {
			if (stickyButton.getAttribute("aria-disabled")) {
				return;
			} else {
				regularButton.click();
			}
		});
	}
});

const quickShop = function () {
	const quickModal = document.querySelector("[data-quick-shop]");
	const quickButtons = document.querySelectorAll("[data-quick-shop-button]");
	const quickClose = document.querySelector("[data-quick-shop-close]");

	const closeQuickShop = function (instigator) {
		quickModal.classList.add("hidden");
		quickModal.setAttribute("aria-hidden", "true");
		instigator.focus();
	};

	const listenToClose = function (button) {
		document.addEventListener("click", (e) => {
			if (e.target == quickModal) {
				closeQuickShop(button);
			}
		});
		quickClose.addEventListener("click", (e) => {
			closeQuickShop(button);
		});
		document.addEventListener("keyup", (e) => {
			if (e.key == "Escape") {
				closeQuickShop(button);
			}
		});
	};

	quickButtons.forEach((button) => {
		button.addEventListener("click", function () {
			quickModal.classList.remove("hidden");
			quickModal.setAttribute("aria-hidden", "false");
			listenToClose(button);
		});
	});
};

document.addEventListener("DOMContentLoaded", function () {
	quickShop();
});

function resetScrollReveal() {
	if (theme.settings.enableAnimations) {
		ScrollReveal().reveal("[data-reveal]", { distance: "32px" });
		ScrollReveal().reveal("[data-reveal-interval]", {
			interval: 200,
			distance: "32px",
		});
		ScrollReveal().reveal("[data-reveal-interval-quick]", {
			interval: 50,
			distance: "32px",
		});
		ScrollReveal().reveal("[data-reveal-spread='1']", {
			delay: 100,
			duration: 1000,
			distance: "32px",
			origin: "right",
		});
		ScrollReveal().reveal("[data-reveal-spread='2']", {
			delay: 300,
			duration: 1000,
			distance: "32px",
			origin: "left",
		});
	}
}
resetScrollReveal();

//AMD insanity
(function (root, factory) {
	if (typeof define === "function" && define.amd) {
		// AMD. Register as an anonymous module.
		define([], factory);
	} else {
		// Browser globals
		root.htmx = factory();
	}
})(typeof self !== "undefined" ? self : this, function () {
	return (function () {
		"use strict";

		// Public API
		var htmx = {
			onLoad: onLoadHelper,
			process: processNode,
			on: addEventListenerImpl,
			off: removeEventListenerImpl,
			trigger: triggerEvent,
			ajax: ajaxHelper,
			find: find,
			findAll: findAll,
			closest: closest,
			values: function (elt, type) {
				var inputValues = getInputValues(elt, type || "post");
				return inputValues.values;
			},
			remove: removeElement,
			addClass: addClassToElement,
			removeClass: removeClassFromElement,
			toggleClass: toggleClassOnElement,
			takeClass: takeClassForElement,
			defineExtension: defineExtension,
			removeExtension: removeExtension,
			logAll: logAll,
			logger: null,
			config: {
				historyEnabled: true,
				historyCacheSize: 10,
				refreshOnHistoryMiss: false,
				defaultSwapStyle: "innerHTML",
				defaultSwapDelay: 0,
				defaultSettleDelay: 100,
				includeIndicatorStyles: true,
				indicatorClass: "htmx-indicator",
				requestClass: "htmx-request",
				settlingClass: "htmx-settling",
				swappingClass: "htmx-swapping",
				allowEval: true,
				attributesToSettle: ["class", "style", "width", "height"],
				wsReconnectDelay: "full-jitter",
				disableSelector: "[hx-disable], [data-hx-disable]",
			},
			parseInterval: parseInterval,
			_: internalEval,
			createEventSource: function (url) {
				return new EventSource(url, { withCredentials: true });
			},
			createWebSocket: function (url) {
				return new WebSocket(url, []);
			},
		};

		var VERBS = ["get", "post", "put", "delete", "patch"];
		var VERB_SELECTOR = VERBS.map(function (verb) {
			return "[hx-" + verb + "], [data-hx-" + verb + "]";
		}).join(", ");

		//====================================================================
		// Utilities
		//====================================================================

		function parseInterval(str) {
			if (str == undefined) {
				return undefined;
			}
			if (str.slice(-2) == "ms") {
				return parseFloat(str.slice(0, -2)) || undefined;
			}
			if (str.slice(-1) == "s") {
				return parseFloat(str.slice(0, -1)) * 1000 || undefined;
			}
			return parseFloat(str) || undefined;
		}

		function getRawAttribute(elt, name) {
			return elt.getAttribute && elt.getAttribute(name);
		}

		// resolve with both hx and data-hx prefixes
		function hasAttribute(elt, qualifiedName) {
			return (
				elt.hasAttribute &&
				(elt.hasAttribute(qualifiedName) ||
					elt.hasAttribute("data-" + qualifiedName))
			);
		}

		function getAttributeValue(elt, qualifiedName) {
			return (
				getRawAttribute(elt, qualifiedName) ||
				getRawAttribute(elt, "data-" + qualifiedName)
			);
		}

		function parentElt(elt) {
			return elt.parentElement;
		}

		function getDocument() {
			return document;
		}

		function getClosestMatch(elt, condition) {
			if (condition(elt)) {
				return elt;
			} else if (parentElt(elt)) {
				return getClosestMatch(parentElt(elt), condition);
			} else {
				return null;
			}
		}

		function getClosestAttributeValue(elt, attributeName) {
			var closestAttr = null;
			getClosestMatch(elt, function (e) {
				return (closestAttr = getAttributeValue(e, attributeName));
			});
			return closestAttr;
		}

		function matches(elt, selector) {
			// noinspection JSUnresolvedVariable
			var matchesFunction =
				elt.matches ||
				elt.matchesSelector ||
				elt.msMatchesSelector ||
				elt.mozMatchesSelector ||
				elt.webkitMatchesSelector ||
				elt.oMatchesSelector;
			return matchesFunction && matchesFunction.call(elt, selector);
		}

		function getStartTag(str) {
			var tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
			var match = tagMatcher.exec(str);
			if (match) {
				return match[1].toLowerCase();
			} else {
				return "";
			}
		}

		function parseHTML(resp, depth) {
			var parser = new DOMParser();
			var responseDoc = parser.parseFromString(resp, "text/html");
			var responseNode = responseDoc.body;
			while (depth > 0) {
				depth--;
				responseNode = responseNode.firstChild;
			}
			if (responseNode == null) {
				responseNode = getDocument().createDocumentFragment();
			}
			return responseNode;
		}

		function makeFragment(resp) {
			var startTag = getStartTag(resp);
			switch (startTag) {
				case "thead":
				case "tbody":
				case "tfoot":
				case "colgroup":
				case "caption":
					return parseHTML("<table>" + resp + "</table>", 1);
				case "col":
					return parseHTML(
						"<table><colgroup>" + resp + "</colgroup></table>",
						2
					);
				case "tr":
					return parseHTML("<table><tbody>" + resp + "</tbody></table>", 2);
				case "td":
				case "th":
					return parseHTML(
						"<table><tbody><tr>" + resp + "</tr></tbody></table>",
						3
					);
				case "script":
					return parseHTML("<div>" + resp + "</div>", 1);
				default:
					return parseHTML(resp, 0);
			}
		}

		function maybeCall(func) {
			if (func) {
				func();
			}
		}

		function isType(o, type) {
			return Object.prototype.toString.call(o) === "[object " + type + "]";
		}

		function isFunction(o) {
			return isType(o, "Function");
		}

		function isRawObject(o) {
			return isType(o, "Object");
		}

		function getInternalData(elt) {
			var dataProp = "htmx-internal-data";
			var data = elt[dataProp];
			if (!data) {
				data = elt[dataProp] = {};
			}
			return data;
		}

		function toArray(arr) {
			var returnArr = [];
			if (arr) {
				for (var i = 0; i < arr.length; i++) {
					returnArr.push(arr[i]);
				}
			}
			return returnArr;
		}

		function forEach(arr, func) {
			if (arr) {
				for (var i = 0; i < arr.length; i++) {
					func(arr[i]);
				}
			}
		}

		function isScrolledIntoView(el) {
			var rect = el.getBoundingClientRect();
			var elemTop = rect.top;
			var elemBottom = rect.bottom;
			return elemTop < window.innerHeight && elemBottom >= 0;
		}

		function bodyContains(elt) {
			return getDocument().body.contains(elt);
		}

		function splitOnWhitespace(trigger) {
			return trigger.trim().split(/\s+/);
		}

		function mergeObjects(obj1, obj2) {
			for (var key in obj2) {
				if (obj2.hasOwnProperty(key)) {
					obj1[key] = obj2[key];
				}
			}
			return obj1;
		}

		function parseJSON(jString) {
			try {
				return JSON.parse(jString);
			} catch (error) {
				logError(error);
				return null;
			}
		}

		//==========================================================================================
		// public API
		//==========================================================================================

		function internalEval(str) {
			return maybeEval(getDocument().body, function () {
				return eval(str);
			});
		}

		function onLoadHelper(callback) {
			var value = htmx.on("htmx:load", function (evt) {
				callback(evt.detail.elt);
			});
			return value;
		}

		function logAll() {
			htmx.logger = function (elt, event, data) {
				if (console) {
					console.log(event, elt, data);
				}
			};
		}

		function find(eltOrSelector, selector) {
			if (selector) {
				return eltOrSelector.querySelector(selector);
			} else {
				return find(getDocument(), eltOrSelector);
			}
		}

		function findAll(eltOrSelector, selector) {
			if (selector) {
				return eltOrSelector.querySelectorAll(selector);
			} else {
				return findAll(getDocument(), eltOrSelector);
			}
		}

		function removeElement(elt, delay) {
			elt = resolveTarget(elt);
			if (delay) {
				setTimeout(function () {
					removeElement(elt);
				}, delay);
			} else {
				elt.parentElement.removeChild(elt);
			}
		}

		function addClassToElement(elt, clazz, delay) {
			elt = resolveTarget(elt);
			if (delay) {
				setTimeout(function () {
					addClassToElement(elt, clazz);
				}, delay);
			} else {
				elt.classList.add(clazz);
			}
		}

		function removeClassFromElement(elt, clazz, delay) {
			elt = resolveTarget(elt);
			if (delay) {
				setTimeout(function () {
					removeClassFromElement(elt, clazz);
				}, delay);
			} else {
				elt.classList.remove(clazz);
			}
		}

		function toggleClassOnElement(elt, clazz) {
			elt = resolveTarget(elt);
			elt.classList.toggle(clazz);
		}

		function takeClassForElement(elt, clazz) {
			elt = resolveTarget(elt);
			forEach(elt.parentElement.children, function (child) {
				removeClassFromElement(child, clazz);
			});
			addClassToElement(elt, clazz);
		}

		function closest(elt, selector) {
			elt = resolveTarget(elt);
			if (elt.closest) {
				return elt.closest(selector);
			} else {
				do {
					if (elt == null || matches(elt, selector)) {
						return elt;
					}
				} while ((elt = elt && parentElt(elt)));
			}
		}

		function querySelectorAllExt(elt, selector) {
			if (selector.indexOf("closest ") === 0) {
				return [closest(elt, selector.substr(8))];
			} else if (selector.indexOf("find ") === 0) {
				return [find(elt, selector.substr(5))];
			} else {
				return getDocument().querySelectorAll(selector);
			}
		}

		function querySelectorExt(eltOrSelector, selector) {
			return querySelectorAllExt(eltOrSelector, selector)[0];
		}

		function resolveTarget(arg2) {
			if (isType(arg2, "String")) {
				return find(arg2);
			} else {
				return arg2;
			}
		}

		function processEventArgs(arg1, arg2, arg3) {
			if (isFunction(arg2)) {
				return {
					target: getDocument().body,
					event: arg1,
					listener: arg2,
				};
			} else {
				return {
					target: resolveTarget(arg1),
					event: arg2,
					listener: arg3,
				};
			}
		}

		function addEventListenerImpl(arg1, arg2, arg3) {
			ready(function () {
				var eventArgs = processEventArgs(arg1, arg2, arg3);
				eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener);
			});
			var b = isFunction(arg2);
			return b ? arg2 : arg3;
		}

		function removeEventListenerImpl(arg1, arg2, arg3) {
			ready(function () {
				var eventArgs = processEventArgs(arg1, arg2, arg3);
				eventArgs.target.removeEventListener(
					eventArgs.event,
					eventArgs.listener
				);
			});
			return isFunction(arg2) ? arg2 : arg3;
		}

		//====================================================================
		// Node processing
		//====================================================================

		function getTarget(elt) {
			var explicitTarget = getClosestMatch(elt, function (e) {
				return getAttributeValue(e, "hx-target") !== null;
			});
			if (explicitTarget) {
				var targetStr = getAttributeValue(explicitTarget, "hx-target");
				if (targetStr === "this") {
					return explicitTarget;
				} else {
					return querySelectorExt(elt, targetStr);
				}
			} else {
				var data = getInternalData(elt);
				if (data.boosted) {
					return getDocument().body;
				} else {
					return elt;
				}
			}
		}

		function shouldSettleAttribute(name) {
			var attributesToSettle = htmx.config.attributesToSettle;
			for (var i = 0; i < attributesToSettle.length; i++) {
				if (name === attributesToSettle[i]) {
					return true;
				}
			}
			return false;
		}

		function cloneAttributes(mergeTo, mergeFrom) {
			forEach(mergeTo.attributes, function (attr) {
				if (
					!mergeFrom.hasAttribute(attr.name) &&
					shouldSettleAttribute(attr.name)
				) {
					mergeTo.removeAttribute(attr.name);
				}
			});
			forEach(mergeFrom.attributes, function (attr) {
				if (shouldSettleAttribute(attr.name)) {
					mergeTo.setAttribute(attr.name, attr.value);
				}
			});
		}

		function isInlineSwap(swapStyle, target) {
			var extensions = getExtensions(target);
			for (var i = 0; i < extensions.length; i++) {
				var extension = extensions[i];
				try {
					if (extension.isInlineSwap(swapStyle)) {
						return true;
					}
				} catch (e) {
					logError(e);
				}
			}
			return swapStyle === "outerHTML";
		}

		function oobSwap(oobValue, oobElement, settleInfo) {
			var selector = "#" + oobElement.id;
			var swapStyle = "outerHTML";
			if (oobValue === "true") {
				// do nothing
			} else if (oobValue.indexOf(":") > 0) {
				swapStyle = oobValue.substr(0, oobValue.indexOf(":"));
				selector = oobValue.substr(oobValue.indexOf(":") + 1, oobValue.length);
			} else {
				swapStyle = oobValue;
			}

			var target = getDocument().querySelector(selector);
			if (target) {
				var fragment;
				fragment = getDocument().createDocumentFragment();
				fragment.appendChild(oobElement); // pulls the child out of the existing fragment
				if (!isInlineSwap(swapStyle, target)) {
					fragment = oobElement; // if this is not an inline swap, we use the content of the node, not the node itself
				}
				swap(swapStyle, target, target, fragment, settleInfo);
			} else {
				oobElement.parentNode.removeChild(oobElement);
				triggerErrorEvent(getDocument().body, "htmx:oobErrorNoTarget", {
					content: oobElement,
				});
			}
			return oobValue;
		}

		function handleOutOfBandSwaps(fragment, settleInfo) {
			forEach(
				findAll(fragment, "[hx-swap-oob], [data-hx-swap-oob]"),
				function (oobElement) {
					var oobValue = getAttributeValue(oobElement, "hx-swap-oob");
					if (oobValue != null) {
						oobSwap(oobValue, oobElement, settleInfo);
					}
				}
			);
		}

		function handlePreservedElements(fragment) {
			forEach(
				findAll(fragment, "[hx-preserve], [data-hx-preserve]"),
				function (preservedElt) {
					var id = getAttributeValue(preservedElt, "id");
					var oldElt = getDocument().getElementById(id);
					if (oldElt != null) {
						preservedElt.parentNode.replaceChild(oldElt, preservedElt);
					}
				}
			);
		}

		function handleAttributes(parentNode, fragment, settleInfo) {
			forEach(fragment.querySelectorAll("[id]"), function (newNode) {
				if (newNode.id && newNode.id.length > 0) {
					var oldNode = parentNode.querySelector(
						newNode.tagName + "[id='" + newNode.id + "']"
					);
					if (oldNode && oldNode !== parentNode) {
						var newAttributes = newNode.cloneNode();
						cloneAttributes(newNode, oldNode);
						settleInfo.tasks.push(function () {
							cloneAttributes(newNode, newAttributes);
						});
					}
				}
			});
		}

		function makeAjaxLoadTask(child) {
			return function () {
				processNode(child);
				processScripts(child);
				processFocus(child);
				triggerEvent(child, "htmx:load");
			};
		}

		function processFocus(child) {
			var autofocus = "[autofocus]";
			var autoFocusedElt = matches(child, autofocus)
				? child
				: child.querySelector(autofocus);
			if (autoFocusedElt != null) {
				autoFocusedElt.focus();
			}
		}

		function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
			handleAttributes(parentNode, fragment, settleInfo);
			while (fragment.childNodes.length > 0) {
				var child = fragment.firstChild;
				parentNode.insertBefore(child, insertBefore);
				if (
					child.nodeType !== Node.TEXT_NODE &&
					child.nodeType !== Node.COMMENT_NODE
				) {
					settleInfo.tasks.push(makeAjaxLoadTask(child));
				}
			}
		}

		function cleanUpElement(element) {
			var internalData = getInternalData(element);
			if (internalData.webSocket) {
				internalData.webSocket.close();
			}
			if (internalData.sseEventSource) {
				internalData.sseEventSource.close();
			}
			if (internalData.listenerInfos) {
				forEach(internalData.listenerInfos, function (info) {
					if (element !== info.on) {
						info.on.removeEventListener(info.trigger, info.listener);
					}
				});
			}
			if (element.children) {
				// IE
				forEach(element.children, function (child) {
					cleanUpElement(child);
				});
			}
		}

		function swapOuterHTML(target, fragment, settleInfo) {
			if (target.tagName === "BODY") {
				return swapInnerHTML(target, fragment);
			} else {
				var eltBeforeNewContent = target.previousSibling;
				insertNodesBefore(parentElt(target), target, fragment, settleInfo);
				if (eltBeforeNewContent == null) {
					var newElt = parentElt(target).firstChild;
				} else {
					var newElt = eltBeforeNewContent.nextSibling;
				}
				getInternalData(target).replacedWith = newElt; // tuck away so we can fire events on it later
				settleInfo.elts = []; // clear existing elements
				while (newElt && newElt !== target) {
					if (newElt.nodeType === Node.ELEMENT_NODE) {
						settleInfo.elts.push(newElt);
					}
					newElt = newElt.nextElementSibling;
				}
				cleanUpElement(target);
				parentElt(target).removeChild(target);
			}
		}

		function swapAfterBegin(target, fragment, settleInfo) {
			return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
		}

		function swapBeforeBegin(target, fragment, settleInfo) {
			return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
		}

		function swapBeforeEnd(target, fragment, settleInfo) {
			return insertNodesBefore(target, null, fragment, settleInfo);
		}

		function swapAfterEnd(target, fragment, settleInfo) {
			return insertNodesBefore(
				parentElt(target),
				target.nextSibling,
				fragment,
				settleInfo
			);
		}

		function swapInnerHTML(target, fragment, settleInfo) {
			var firstChild = target.firstChild;
			insertNodesBefore(target, firstChild, fragment, settleInfo);
			if (firstChild) {
				while (firstChild.nextSibling) {
					cleanUpElement(firstChild.nextSibling);
					target.removeChild(firstChild.nextSibling);
				}
				cleanUpElement(firstChild);
				target.removeChild(firstChild);
			}
		}

		function maybeSelectFromResponse(elt, fragment) {
			var selector = getClosestAttributeValue(elt, "hx-select");
			if (selector) {
				var newFragment = getDocument().createDocumentFragment();
				forEach(fragment.querySelectorAll(selector), function (node) {
					newFragment.appendChild(node);
				});
				fragment = newFragment;
			}
			return fragment;
		}

		function swap(swapStyle, elt, target, fragment, settleInfo) {
			switch (swapStyle) {
				case "none":
					return;
				case "outerHTML":
					swapOuterHTML(target, fragment, settleInfo);
					return;
				case "afterbegin":
					swapAfterBegin(target, fragment, settleInfo);
					return;
				case "beforebegin":
					swapBeforeBegin(target, fragment, settleInfo);
					return;
				case "beforeend":
					swapBeforeEnd(target, fragment, settleInfo);
					return;
				case "afterend":
					swapAfterEnd(target, fragment, settleInfo);
					return;
				default:
					var extensions = getExtensions(elt);
					for (var i = 0; i < extensions.length; i++) {
						var ext = extensions[i];
						try {
							var newElements = ext.handleSwap(
								swapStyle,
								target,
								fragment,
								settleInfo
							);
							if (newElements) {
								if (typeof newElements.length !== "undefined") {
									// if handleSwap returns an array (like) of elements, we handle them
									for (var j = 0; j < newElements.length; j++) {
										var child = newElements[j];
										if (
											child.nodeType !== Node.TEXT_NODE &&
											child.nodeType !== Node.COMMENT_NODE
										) {
											settleInfo.tasks.push(makeAjaxLoadTask(child));
										}
									}
								}
								return;
							}
						} catch (e) {
							logError(e);
						}
					}
					swapInnerHTML(target, fragment, settleInfo);
			}
		}

		var TITLE_FINDER = /<title>([\s\S]+?)<\/title>/im;
		function findTitle(content) {
			var result = TITLE_FINDER.exec(content);
			if (result) {
				return result[1];
			}
		}

		function selectAndSwap(swapStyle, target, elt, responseText, settleInfo) {
			var title = findTitle(responseText);
			if (title) {
				var titleElt = find("title");
				if (titleElt) {
					titleElt.innerHTML = title;
				} else {
					window.document.title = title;
				}
			}
			var fragment = makeFragment(responseText);
			if (fragment) {
				handleOutOfBandSwaps(fragment, settleInfo);
				fragment = maybeSelectFromResponse(elt, fragment);
				handlePreservedElements(fragment);
				return swap(swapStyle, elt, target, fragment, settleInfo);
			}
		}

		function handleTrigger(xhr, header, elt) {
			var triggerBody = xhr.getResponseHeader(header);
			if (triggerBody.indexOf("{") === 0) {
				var triggers = parseJSON(triggerBody);
				for (var eventName in triggers) {
					if (triggers.hasOwnProperty(eventName)) {
						var detail = triggers[eventName];
						if (!isRawObject(detail)) {
							detail = { value: detail };
						}
						triggerEvent(elt, eventName, detail);
					}
				}
			} else {
				triggerEvent(elt, triggerBody, []);
			}
		}

		var WHITESPACE = /\s/;
		var WHITESPACE_OR_COMMA = /[\s,]/;
		var SYMBOL_START = /[_$a-zA-Z]/;
		var SYMBOL_CONT = /[_$a-zA-Z0-9]/;
		var STRINGISH_START = ['"', "'", "/"];
		var NOT_WHITESPACE = /[^\s]/;
		function tokenizeString(str) {
			var tokens = [];
			var position = 0;
			while (position < str.length) {
				if (SYMBOL_START.exec(str.charAt(position))) {
					var startPosition = position;
					while (SYMBOL_CONT.exec(str.charAt(position + 1))) {
						position++;
					}
					tokens.push(str.substr(startPosition, position - startPosition + 1));
				} else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
					var startChar = str.charAt(position);
					var startPosition = position;
					position++;
					while (position < str.length && str.charAt(position) !== startChar) {
						if (str.charAt(position) === "\\") {
							position++;
						}
						position++;
					}
					tokens.push(str.substr(startPosition, position - startPosition + 1));
				} else {
					var symbol = str.charAt(position);
					tokens.push(symbol);
				}
				position++;
			}
			return tokens;
		}

		function isPossibleRelativeReference(token, last, paramName) {
			return (
				SYMBOL_START.exec(token.charAt(0)) &&
				token !== "true" &&
				token !== "false" &&
				token !== "this" &&
				token !== paramName &&
				last !== "."
			);
		}

		function maybeGenerateConditional(elt, tokens, paramName) {
			if (tokens[0] === "[") {
				tokens.shift();
				var bracketCount = 1;
				var conditionalSource =
					" return (function(" + paramName + "){ return (";
				var last = null;
				while (tokens.length > 0) {
					var token = tokens[0];
					if (token === "]") {
						bracketCount--;
						if (bracketCount === 0) {
							if (last === null) {
								conditionalSource = conditionalSource + "true";
							}
							tokens.shift();
							conditionalSource += ")})";
							try {
								var conditionFunction = maybeEval(
									elt,
									function () {
										return Function(conditionalSource)();
									},
									function () {
										return true;
									}
								);
								conditionFunction.source = conditionalSource;
								return conditionFunction;
							} catch (e) {
								triggerErrorEvent(getDocument().body, "htmx:syntax:error", {
									error: e,
									source: conditionalSource,
								});
								return null;
							}
						}
					} else if (token === "[") {
						bracketCount++;
					}
					if (isPossibleRelativeReference(token, last, paramName)) {
						conditionalSource +=
							"((" +
							paramName +
							"." +
							token +
							") ? (" +
							paramName +
							"." +
							token +
							") : (window." +
							token +
							"))";
					} else {
						conditionalSource = conditionalSource + token;
					}
					last = tokens.shift();
				}
			}
		}

		function consumeUntil(tokens, match) {
			var result = "";
			while (tokens.length > 0 && !tokens[0].match(match)) {
				result += tokens.shift();
			}
			return result;
		}

		var INPUT_SELECTOR = "input, textarea, select";
		function getTriggerSpecs(elt) {
			var explicitTrigger = getAttributeValue(elt, "hx-trigger");
			var triggerSpecs = [];
			if (explicitTrigger) {
				var tokens = tokenizeString(explicitTrigger);
				do {
					consumeUntil(tokens, NOT_WHITESPACE);
					var initialLength = tokens.length;
					var trigger = consumeUntil(tokens, /[,\[\s]/);
					if (trigger !== "") {
						if (trigger === "every") {
							var every = { trigger: "every" };
							consumeUntil(tokens, NOT_WHITESPACE);
							every.pollInterval = parseInterval(
								consumeUntil(tokens, WHITESPACE)
							);
							triggerSpecs.push(every);
						} else if (trigger.indexOf("sse:") === 0) {
							triggerSpecs.push({
								trigger: "sse",
								sseEvent: trigger.substr(4),
							});
						} else {
							var triggerSpec = { trigger: trigger };
							var eventFilter = maybeGenerateConditional(elt, tokens, "event");
							if (eventFilter) {
								triggerSpec.eventFilter = eventFilter;
							}
							while (tokens.length > 0 && tokens[0] !== ",") {
								consumeUntil(tokens, NOT_WHITESPACE);
								var token = tokens.shift();
								if (token === "changed") {
									triggerSpec.changed = true;
								} else if (token === "once") {
									triggerSpec.once = true;
								} else if (token === "consume") {
									triggerSpec.consume = true;
								} else if (token === "delay" && tokens[0] === ":") {
									tokens.shift();
									triggerSpec.delay = parseInterval(
										consumeUntil(tokens, WHITESPACE_OR_COMMA)
									);
								} else if (token === "from" && tokens[0] === ":") {
									tokens.shift();
									triggerSpec.from = consumeUntil(tokens, WHITESPACE_OR_COMMA);
								} else if (token === "target" && tokens[0] === ":") {
									tokens.shift();
									triggerSpec.target = consumeUntil(
										tokens,
										WHITESPACE_OR_COMMA
									);
								} else if (token === "throttle" && tokens[0] === ":") {
									tokens.shift();
									triggerSpec.throttle = parseInterval(
										consumeUntil(tokens, WHITESPACE_OR_COMMA)
									);
								} else {
									triggerErrorEvent(elt, "htmx:syntax:error", {
										token: tokens.shift(),
									});
								}
							}
							triggerSpecs.push(triggerSpec);
						}
					}
					if (tokens.length === initialLength) {
						triggerErrorEvent(elt, "htmx:syntax:error", {
							token: tokens.shift(),
						});
					}
					consumeUntil(tokens, NOT_WHITESPACE);
				} while (tokens[0] === "," && tokens.shift());
			}

			if (triggerSpecs.length > 0) {
				return triggerSpecs;
			} else if (matches(elt, "form")) {
				return [{ trigger: "submit" }];
			} else if (matches(elt, INPUT_SELECTOR)) {
				return [{ trigger: "change" }];
			} else {
				return [{ trigger: "click" }];
			}
		}

		function cancelPolling(elt) {
			getInternalData(elt).cancelled = true;
		}

		function processPolling(elt, verb, path, interval) {
			var nodeData = getInternalData(elt);
			nodeData.timeout = setTimeout(function () {
				if (bodyContains(elt) && nodeData.cancelled !== true) {
					issueAjaxRequest(verb, path, elt);
					processPolling(
						elt,
						verb,
						getAttributeValue(elt, "hx-" + verb),
						interval
					);
				}
			}, interval);
		}

		function isLocalLink(elt) {
			return (
				location.hostname === elt.hostname &&
				getRawAttribute(elt, "href") &&
				getRawAttribute(elt, "href").indexOf("#") !== 0
			);
		}

		function boostElement(elt, nodeData, triggerSpecs) {
			if ((elt.tagName === "A" && isLocalLink(elt)) || elt.tagName === "FORM") {
				nodeData.boosted = true;
				var verb, path;
				if (elt.tagName === "A") {
					verb = "get";
					path = getRawAttribute(elt, "href");
				} else {
					var rawAttribute = getRawAttribute(elt, "method");
					verb = rawAttribute ? rawAttribute.toLowerCase() : "get";
					path = getRawAttribute(elt, "action");
				}
				triggerSpecs.forEach(function (triggerSpec) {
					addEventListener(elt, verb, path, nodeData, triggerSpec, true);
				});
			}
		}

		function shouldCancel(elt) {
			return (
				elt.tagName === "FORM" ||
				(matches(elt, 'input[type="submit"], button') &&
					closest(elt, "form") !== null) ||
				(elt.tagName === "A" &&
					elt.href &&
					(elt.getAttribute("href") === "#" ||
						elt.getAttribute("href").indexOf("#") !== 0))
			);
		}

		function ignoreBoostedAnchorCtrlClick(elt, evt) {
			return (
				getInternalData(elt).boosted &&
				elt.tagName === "A" &&
				evt.type === "click" &&
				evt.ctrlKey
			);
		}

		function maybeFilterEvent(triggerSpec, evt) {
			var eventFilter = triggerSpec.eventFilter;
			if (eventFilter) {
				try {
					return eventFilter(evt) !== true;
				} catch (e) {
					triggerErrorEvent(getDocument().body, "htmx:eventFilter:error", {
						error: e,
						source: eventFilter.source,
					});
					return true;
				}
			}
			return false;
		}

		function addEventListener(
			elt,
			verb,
			path,
			nodeData,
			triggerSpec,
			explicitCancel
		) {
			var eltToListenOn = elt;
			if (triggerSpec.from) {
				eltToListenOn = find(triggerSpec.from);
			}
			var eventListener = function (evt) {
				if (!bodyContains(elt)) {
					eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
					return;
				}
				if (ignoreBoostedAnchorCtrlClick(elt, evt)) {
					return;
				}
				if (explicitCancel || shouldCancel(elt)) {
					evt.preventDefault();
				}
				if (maybeFilterEvent(triggerSpec, evt)) {
					return;
				}
				var eventData = getInternalData(evt);
				if (eventData.handledFor == null) {
					eventData.handledFor = [];
				}
				var elementData = getInternalData(elt);
				if (eventData.handledFor.indexOf(elt) < 0) {
					eventData.handledFor.push(elt);
					if (triggerSpec.consume) {
						evt.stopPropagation();
					}
					if (triggerSpec.target && evt.target) {
						if (!matches(evt.target, triggerSpec.target)) {
							return;
						}
					}
					if (triggerSpec.once) {
						if (elementData.triggeredOnce) {
							return;
						} else {
							elementData.triggeredOnce = true;
						}
					}
					if (triggerSpec.changed) {
						if (elementData.lastValue === elt.value) {
							return;
						} else {
							elementData.lastValue = elt.value;
						}
					}
					if (elementData.delayed) {
						clearTimeout(elementData.delayed);
					}
					if (elementData.throttle) {
						return;
					}

					if (triggerSpec.throttle) {
						elementData.throttle = setTimeout(function () {
							issueAjaxRequest(verb, path, elt, evt);
							elementData.throttle = null;
						}, triggerSpec.throttle);
					} else if (triggerSpec.delay) {
						elementData.delayed = setTimeout(function () {
							issueAjaxRequest(verb, path, elt, evt);
						}, triggerSpec.delay);
					} else {
						issueAjaxRequest(verb, path, elt, evt);
					}
				}
			};
			if (nodeData.listenerInfos == null) {
				nodeData.listenerInfos = [];
			}
			nodeData.listenerInfos.push({
				trigger: triggerSpec.trigger,
				listener: eventListener,
				on: eltToListenOn,
			});
			eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
		}

		var windowIsScrolling = false; // used by initScrollHandler
		var scrollHandler = null;
		function initScrollHandler() {
			if (!scrollHandler) {
				scrollHandler = function () {
					windowIsScrolling = true;
				};
				window.addEventListener("scroll", scrollHandler);
				setInterval(function () {
					if (windowIsScrolling) {
						windowIsScrolling = false;
						forEach(
							getDocument().querySelectorAll(
								"[hx-trigger='revealed'],[data-hx-trigger='revealed']"
							),
							function (elt) {
								maybeReveal(elt);
							}
						);
					}
				}, 200);
			}
		}

		function maybeReveal(elt) {
			var nodeData = getInternalData(elt);
			if (!nodeData.revealed && isScrolledIntoView(elt)) {
				nodeData.revealed = true;
				issueAjaxRequest(nodeData.verb, nodeData.path, elt);
			}
		}

		function processWebSocketInfo(elt, nodeData, info) {
			var values = splitOnWhitespace(info);
			for (var i = 0; i < values.length; i++) {
				var value = values[i].split(/:(.+)/);
				if (value[0] === "connect") {
					ensureWebSocket(elt, value[1], 0);
				}
				if (value[0] === "send") {
					processWebSocketSend(elt);
				}
			}
		}

		function ensureWebSocket(elt, wssSource, retryCount) {
			if (!bodyContains(elt)) {
				return; // stop ensuring websocket connection when socket bearing element ceases to exist
			}

			if (wssSource.indexOf("/") == 0) {
				// complete absolute paths only
				var base_part =
					location.hostname + (location.port ? ":" + location.port : "");
				if (location.protocol == "https:") {
					wssSource = "wss://" + base_part + wssSource;
				} else if (location.protocol == "http:") {
					wssSource = "ws://" + base_part + wssSource;
				}
			}
			var socket = htmx.createWebSocket(wssSource);
			socket.onerror = function (e) {
				triggerErrorEvent(elt, "htmx:wsError", { error: e, socket: socket });
				maybeCloseWebSocketSource(elt);
			};

			socket.onclose = function (e) {
				if ([1006, 1012, 1013].includes(e.code)) {
					// Abnormal Closure/Service Restart/Try Again Later
					var delay = getWebSocketReconnectDelay(retryCount);
					setTimeout(function () {
						ensureWebSocket(elt, wssSource, retryCount + 1); // creates a websocket with a new timeout
					}, delay);
				}
			};
			socket.onopen = function (e) {
				retryCount = 0;
			};

			getInternalData(elt).webSocket = socket;
			socket.addEventListener("message", function (event) {
				if (maybeCloseWebSocketSource(elt)) {
					return;
				}

				var response = event.data;
				withExtensions(elt, function (extension) {
					response = extension.transformResponse(response, null, elt);
				});

				var settleInfo = makeSettleInfo(elt);
				var fragment = makeFragment(response);
				var children = toArray(fragment.children);
				for (var i = 0; i < children.length; i++) {
					var child = children[i];
					oobSwap(
						getAttributeValue(child, "hx-swap-oob") || "true",
						child,
						settleInfo
					);
				}

				settleImmediately(settleInfo.tasks);
			});
		}

		function maybeCloseWebSocketSource(elt) {
			if (!bodyContains(elt)) {
				getInternalData(elt).webSocket.close();
				return true;
			}
		}

		function processWebSocketSend(elt) {
			var webSocketSourceElt = getClosestMatch(elt, function (parent) {
				return getInternalData(parent).webSocket != null;
			});
			if (webSocketSourceElt) {
				elt.addEventListener(getTriggerSpecs(elt)[0].trigger, function (evt) {
					var webSocket = getInternalData(webSocketSourceElt).webSocket;
					var headers = getHeaders(elt, webSocketSourceElt);
					var results = getInputValues(elt, "post");
					var errors = results.errors;
					var rawParameters = results.values;
					var expressionVars = getExpressionVars(elt);
					var allParameters = mergeObjects(rawParameters, expressionVars);
					var filteredParameters = filterValues(allParameters, elt);
					filteredParameters["HEADERS"] = headers;
					if (errors && errors.length > 0) {
						triggerEvent(elt, "htmx:validation:halted", errors);
						return;
					}
					webSocket.send(JSON.stringify(filteredParameters));
					if (shouldCancel(elt)) {
						evt.preventDefault();
					}
				});
			} else {
				triggerErrorEvent(elt, "htmx:noWebSocketSourceError");
			}
		}

		function getWebSocketReconnectDelay(retryCount) {
			var delay = htmx.config.wsReconnectDelay;
			if (typeof delay === "function") {
				return delay(retryCount);
			}
			if (delay === "full-jitter") {
				var exp = Math.min(retryCount, 6);
				var maxDelay = 1000 * Math.pow(2, exp);
				return maxDelay * Math.random();
			}
			logError(
				'htmx.config.wsReconnectDelay must either be a function or the string "full-jitter"'
			);
		}

		//====================================================================
		// Server Sent Events
		//====================================================================

		function processSSEInfo(elt, nodeData, info) {
			var values = splitOnWhitespace(info);
			for (var i = 0; i < values.length; i++) {
				var value = values[i].split(/:(.+)/);
				if (value[0] === "connect") {
					processSSESource(elt, value[1]);
				}

				if (value[0] === "swap") {
					processSSESwap(elt, value[1]);
				}
			}
		}

		function processSSESource(elt, sseSrc) {
			var source = htmx.createEventSource(sseSrc);
			source.onerror = function (e) {
				triggerErrorEvent(elt, "htmx:sseError", { error: e, source: source });
				maybeCloseSSESource(elt);
			};
			getInternalData(elt).sseEventSource = source;
		}

		function processSSESwap(elt, sseEventName) {
			var sseSourceElt = getClosestMatch(elt, hasEventSource);
			if (sseSourceElt) {
				var sseEventSource = getInternalData(sseSourceElt).sseEventSource;
				var sseListener = function (event) {
					if (maybeCloseSSESource(sseSourceElt)) {
						sseEventSource.removeEventListener(sseEventName, sseListener);
						return;
					}

					///////////////////////////
					// TODO: merge this code with AJAX and WebSockets code in the future.

					var response = event.data;
					withExtensions(elt, function (extension) {
						response = extension.transformResponse(response, null, elt);
					});

					var swapSpec = getSwapSpecification(elt);
					var target = getTarget(elt);
					var settleInfo = makeSettleInfo(elt);

					selectAndSwap(swapSpec.swapStyle, elt, target, response, settleInfo);
					settleImmediately(settleInfo.tasks);
					triggerEvent(elt, "htmx:sseMessage", event);
				};

				getInternalData(elt).sseListener = sseListener;
				sseEventSource.addEventListener(sseEventName, sseListener);
			} else {
				triggerErrorEvent(elt, "htmx:noSSESourceError");
			}
		}

		function processSSETrigger(elt, verb, path, sseEventName) {
			var sseSourceElt = getClosestMatch(elt, hasEventSource);
			if (sseSourceElt) {
				var sseEventSource = getInternalData(sseSourceElt).sseEventSource;
				var sseListener = function () {
					if (!maybeCloseSSESource(sseSourceElt)) {
						if (bodyContains(elt)) {
							issueAjaxRequest(verb, path, elt);
						} else {
							sseEventSource.removeEventListener(sseEventName, sseListener);
						}
					}
				};
				getInternalData(elt).sseListener = sseListener;
				sseEventSource.addEventListener(sseEventName, sseListener);
			} else {
				triggerErrorEvent(elt, "htmx:noSSESourceError");
			}
		}

		function maybeCloseSSESource(elt) {
			if (!bodyContains(elt)) {
				getInternalData(elt).sseEventSource.close();
				return true;
			}
		}

		function hasEventSource(node) {
			return getInternalData(node).sseEventSource != null;
		}

		//====================================================================

		function loadImmediately(elt, verb, path, nodeData, delay) {
			var load = function () {
				if (!nodeData.loaded) {
					nodeData.loaded = true;
					issueAjaxRequest(verb, path, elt);
				}
			};
			if (delay) {
				setTimeout(load, delay);
			} else {
				load();
			}
		}

		function processVerbs(elt, nodeData, triggerSpecs) {
			var explicitAction = false;
			forEach(VERBS, function (verb) {
				if (hasAttribute(elt, "hx-" + verb)) {
					var path = getAttributeValue(elt, "hx-" + verb);
					explicitAction = true;
					nodeData.path = path;
					nodeData.verb = verb;
					triggerSpecs.forEach(function (triggerSpec) {
						if (triggerSpec.sseEvent) {
							processSSETrigger(elt, verb, path, triggerSpec.sseEvent);
						} else if (triggerSpec.trigger === "revealed") {
							initScrollHandler();
							maybeReveal(elt);
						} else if (triggerSpec.trigger === "load") {
							loadImmediately(elt, verb, path, nodeData, triggerSpec.delay);
						} else if (triggerSpec.pollInterval) {
							nodeData.polling = true;
							processPolling(elt, verb, path, triggerSpec.pollInterval);
						} else {
							addEventListener(elt, verb, path, nodeData, triggerSpec);
						}
					});
				}
			});
			return explicitAction;
		}

		function evalScript(script) {
			if (script.type === "text/javascript" || script.type === "") {
				try {
					maybeEval(script, function () {
						Function(script.innerText)();
					});
				} catch (e) {
					logError(e);
				}
			}
		}

		function processScripts(elt) {
			if (matches(elt, "script")) {
				evalScript(elt);
			}
			forEach(findAll(elt, "script"), function (script) {
				evalScript(script);
			});
		}

		function isBoosted() {
			return document.querySelector("[hx-boost], [data-hx-boost]");
		}

		function findElementsToProcess(elt) {
			if (elt.querySelectorAll) {
				var boostedElts = isBoosted() ? ", a, form" : "";
				var results = elt.querySelectorAll(
					VERB_SELECTOR +
						boostedElts +
						", [hx-sse], [data-hx-sse], [hx-ws]," +
						" [data-hx-ws]"
				);
				return results;
			} else {
				return [];
			}
		}

		function initNode(elt) {
			if (elt.closest && elt.closest(htmx.config.disableSelector)) {
				return;
			}
			var nodeData = getInternalData(elt);
			if (!nodeData.initialized) {
				nodeData.initialized = true;
				triggerEvent(elt, "htmx:beforeProcessNode");

				if (elt.value) {
					nodeData.lastValue = elt.value;
				}

				var triggerSpecs = getTriggerSpecs(elt);
				var explicitAction = processVerbs(elt, nodeData, triggerSpecs);

				if (
					!explicitAction &&
					getClosestAttributeValue(elt, "hx-boost") === "true"
				) {
					boostElement(elt, nodeData, triggerSpecs);
				}

				var sseInfo = getAttributeValue(elt, "hx-sse");
				if (sseInfo) {
					processSSEInfo(elt, nodeData, sseInfo);
				}

				var wsInfo = getAttributeValue(elt, "hx-ws");
				if (wsInfo) {
					processWebSocketInfo(elt, nodeData, wsInfo);
				}
				triggerEvent(elt, "htmx:afterProcessNode");
			}
		}

		function processNode(elt) {
			elt = resolveTarget(elt);
			initNode(elt);
			forEach(findElementsToProcess(elt), function (child) {
				initNode(child);
			});
		}

		//====================================================================
		// Event/Log Support
		//====================================================================

		function kebabEventName(str) {
			return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
		}

		function makeEvent(eventName, detail) {
			var evt;
			if (window.CustomEvent && typeof window.CustomEvent === "function") {
				evt = new CustomEvent(eventName, {
					bubbles: true,
					cancelable: true,
					detail: detail,
				});
			} else {
				evt = getDocument().createEvent("CustomEvent");
				evt.initCustomEvent(eventName, true, true, detail);
			}
			return evt;
		}

		function triggerErrorEvent(elt, eventName, detail) {
			triggerEvent(elt, eventName, mergeObjects({ error: eventName }, detail));
		}

		function ignoreEventForLogging(eventName) {
			return eventName === "htmx:afterProcessNode";
		}

		function withExtensions(elt, toDo) {
			forEach(getExtensions(elt), function (extension) {
				try {
					toDo(extension);
				} catch (e) {
					logError(e);
				}
			});
		}

		function logError(msg) {
			if (console.error) {
				console.error(msg);
			} else if (console.log) {
				console.log("ERROR: ", msg);
			}
		}

		function triggerEvent(elt, eventName, detail) {
			elt = resolveTarget(elt);
			if (detail == null) {
				detail = {};
			}
			detail["elt"] = elt;
			var event = makeEvent(eventName, detail);
			if (htmx.logger && !ignoreEventForLogging(eventName)) {
				htmx.logger(elt, eventName, detail);
			}
			if (detail.error) {
				logError(detail.error);
				triggerEvent(elt, "htmx:error", { errorInfo: detail });
			}
			var eventResult = elt.dispatchEvent(event);
			var kebabName = kebabEventName(eventName);
			if (eventResult && kebabName !== eventName) {
				var kebabedEvent = makeEvent(kebabName, event.detail);
				eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
			}
			withExtensions(elt, function (extension) {
				eventResult =
					eventResult && extension.onEvent(eventName, event) !== false;
			});
			return eventResult;
		}

		//====================================================================
		// History Support
		//====================================================================
		var currentPathForHistory = null;

		function getHistoryElement() {
			var historyElt = getDocument().querySelector(
				"[hx-history-elt],[data-hx-history-elt]"
			);
			return historyElt || getDocument().body;
		}

		function saveToHistoryCache(url, content, title, scroll) {
			var historyCache =
				parseJSON(localStorage.getItem("htmx-history-cache")) || [];
			for (var i = 0; i < historyCache.length; i++) {
				if (historyCache[i].url === url) {
					historyCache.splice(i, 1);
					break;
				}
			}
			historyCache.push({
				url: url,
				content: content,
				title: title,
				scroll: scroll,
			});
			while (historyCache.length > htmx.config.historyCacheSize) {
				historyCache.shift();
			}
			while (historyCache.length > 0) {
				try {
					localStorage.setItem(
						"htmx-history-cache",
						JSON.stringify(historyCache)
					);
					break;
				} catch (e) {
					triggerErrorEvent(getDocument().body, "htmx:historyCacheError", {
						cause: e,
						cache: historyCache,
					});
					historyCache.shift(); // shrink the cache and retry
				}
			}
		}

		function getCachedHistory(url) {
			var historyCache =
				parseJSON(localStorage.getItem("htmx-history-cache")) || [];
			for (var i = 0; i < historyCache.length; i++) {
				if (historyCache[i].url === url) {
					return historyCache[i];
				}
			}
			return null;
		}

		function cleanInnerHtmlForHistory(elt) {
			var className = htmx.config.requestClass;
			var clone = elt.cloneNode(true);
			forEach(findAll(clone, "." + className), function (child) {
				removeClassFromElement(child, className);
			});
			return clone.innerHTML;
		}

		function saveHistory() {
			var elt = getHistoryElement();
			var path = currentPathForHistory || location.pathname + location.search;
			triggerEvent(getDocument().body, "htmx:beforeHistorySave", {
				path: path,
				historyElt: elt,
			});
			if (htmx.config.historyEnabled)
				history.replaceState(
					{ htmx: true },
					getDocument().title,
					window.location.href
				);
			saveToHistoryCache(
				path,
				cleanInnerHtmlForHistory(elt),
				getDocument().title,
				window.scrollY
			);
		}

		function pushUrlIntoHistory(path) {
			if (htmx.config.historyEnabled)
				history.pushState({ htmx: true }, "", path);
			currentPathForHistory = path;
		}

		function settleImmediately(tasks) {
			forEach(tasks, function (task) {
				task.call();
			});
		}

		function loadHistoryFromServer(path) {
			var request = new XMLHttpRequest();
			var details = { path: path, xhr: request };
			triggerEvent(getDocument().body, "htmx:historyCacheMiss", details);
			request.open("GET", path, true);
			request.setRequestHeader("HX-History-Restore-Request", "true");
			request.onload = function () {
				if (this.status >= 200 && this.status < 400) {
					triggerEvent(
						getDocument().body,
						"htmx:historyCacheMissLoad",
						details
					);
					var fragment = makeFragment(this.response);
					fragment =
						fragment.querySelector("[hx-history-elt],[data-hx-history-elt]") ||
						fragment;
					var historyElement = getHistoryElement();
					var settleInfo = makeSettleInfo(historyElement);
					swapInnerHTML(historyElement, fragment, settleInfo);
					settleImmediately(settleInfo.tasks);
					currentPathForHistory = path;
					triggerEvent(getDocument().body, "htmx:historyRestore", {
						path: path,
					});
				} else {
					triggerErrorEvent(
						getDocument().body,
						"htmx:historyCacheMissLoadError",
						details
					);
				}
			};
			request.send();
		}

		function restoreHistory(path) {
			saveHistory();
			path = path || location.pathname + location.search;
			var cached = getCachedHistory(path);
			if (cached) {
				var fragment = makeFragment(cached.content);
				var historyElement = getHistoryElement();
				var settleInfo = makeSettleInfo(historyElement);
				swapInnerHTML(historyElement, fragment, settleInfo);
				settleImmediately(settleInfo.tasks);
				document.title = cached.title;
				window.scrollTo(0, cached.scroll);
				currentPathForHistory = path;
				triggerEvent(getDocument().body, "htmx:historyRestore", { path: path });
			} else {
				if (htmx.config.refreshOnHistoryMiss) {
					window.location.reload(true);
				} else {
					loadHistoryFromServer(path);
				}
			}
		}

		function shouldPush(elt) {
			var pushUrl = getClosestAttributeValue(elt, "hx-push-url");
			return (
				(pushUrl && pushUrl !== "false") ||
				(elt.tagName === "A" && getInternalData(elt).boosted)
			);
		}

		function getPushUrl(elt) {
			var pushUrl = getClosestAttributeValue(elt, "hx-push-url");
			return pushUrl === "true" || pushUrl === "false" ? null : pushUrl;
		}

		function addRequestIndicatorClasses(elt) {
			var indicator = getClosestAttributeValue(elt, "hx-indicator");
			if (indicator) {
				var indicators = querySelectorAllExt(elt, indicator);
			} else {
				indicators = [elt];
			}
			forEach(indicators, function (ic) {
				ic.classList["add"].call(ic.classList, htmx.config.requestClass);
			});
			return indicators;
		}

		function removeRequestIndicatorClasses(indicators) {
			forEach(indicators, function (ic) {
				ic.classList["remove"].call(ic.classList, htmx.config.requestClass);
			});
		}

		//====================================================================
		// Input Value Processing
		//====================================================================

		function haveSeenNode(processed, elt) {
			for (var i = 0; i < processed.length; i++) {
				var node = processed[i];
				if (node.isSameNode(elt)) {
					return true;
				}
			}
			return false;
		}

		function shouldInclude(elt) {
			if (elt.name === "" || elt.name == null || elt.disabled) {
				return false;
			}
			// ignore "submitter" types (see jQuery src/serialize.js)
			if (
				elt.type === "button" ||
				elt.type === "submit" ||
				elt.tagName === "image" ||
				elt.tagName === "reset" ||
				elt.tagName === "file"
			) {
				return false;
			}
			if (elt.type === "checkbox" || elt.type === "radio") {
				return elt.checked;
			}
			return true;
		}

		function processInputValue(processed, values, errors, elt, validate) {
			if (elt == null || haveSeenNode(processed, elt)) {
				return;
			} else {
				processed.push(elt);
			}
			if (shouldInclude(elt)) {
				var name = getRawAttribute(elt, "name");
				var value = elt.value;
				if (elt.multiple) {
					value = toArray(elt.querySelectorAll("option:checked")).map(function (
						e
					) {
						return e.value;
					});
				}
				// include file inputs
				if (elt.files) {
					value = toArray(elt.files);
				}
				// This is a little ugly because both the current value of the named value in the form
				// and the new value could be arrays, so we have to handle all four cases :/
				if (name != null && value != null) {
					var current = values[name];
					if (current) {
						if (Array.isArray(current)) {
							if (Array.isArray(value)) {
								values[name] = current.concat(value);
							} else {
								current.push(value);
							}
						} else {
							if (Array.isArray(value)) {
								values[name] = [current].concat(value);
							} else {
								values[name] = [current, value];
							}
						}
					} else {
						values[name] = value;
					}
				}
				if (validate) {
					validateElement(elt, errors);
				}
			}
			if (matches(elt, "form")) {
				var inputs = elt.elements;
				forEach(inputs, function (input) {
					processInputValue(processed, values, errors, input, validate);
				});
			}
		}

		function validateElement(element, errors) {
			if (element.willValidate) {
				triggerEvent(element, "htmx:validation:validate");
				if (!element.checkValidity()) {
					errors.push({
						elt: element,
						message: element.validationMessage,
						validity: element.validity,
					});
					triggerEvent(element, "htmx:validation:failed", {
						message: element.validationMessage,
						validity: element.validity,
					});
				}
			}
		}

		function getInputValues(elt, verb) {
			var processed = [];
			var values = {};
			var formValues = {};
			var errors = [];

			// only validate when form is directly submitted and novalidate is not set
			var validate = matches(elt, "form") && elt.noValidate !== true;

			// for a non-GET include the closest form
			if (verb !== "get") {
				processInputValue(
					processed,
					formValues,
					errors,
					closest(elt, "form"),
					validate
				);
			}

			// include the element itself
			processInputValue(processed, values, errors, elt, validate);

			// include any explicit includes
			var includes = getClosestAttributeValue(elt, "hx-include");
			if (includes) {
				var nodes = querySelectorAllExt(elt, includes);
				forEach(nodes, function (node) {
					processInputValue(processed, values, errors, node, validate);
					// if a non-form is included, include any input values within it
					if (!matches(node, "form")) {
						forEach(
							node.querySelectorAll(INPUT_SELECTOR),
							function (descendant) {
								processInputValue(
									processed,
									values,
									errors,
									descendant,
									validate
								);
							}
						);
					}
				});
			}

			// form values take precedence, overriding the regular values
			values = mergeObjects(values, formValues);

			return { errors: errors, values: values };
		}

		function appendParam(returnStr, name, realValue) {
			if (returnStr !== "") {
				returnStr += "&";
			}
			returnStr +=
				encodeURIComponent(name) + "=" + encodeURIComponent(realValue);
			return returnStr;
		}

		function urlEncode(values) {
			var returnStr = "";
			for (var name in values) {
				if (values.hasOwnProperty(name)) {
					var value = values[name];
					if (Array.isArray(value)) {
						forEach(value, function (v) {
							returnStr = appendParam(returnStr, name, v);
						});
					} else {
						returnStr = appendParam(returnStr, name, value);
					}
				}
			}
			return returnStr;
		}

		function makeFormData(values) {
			var formData = new FormData();
			for (var name in values) {
				if (values.hasOwnProperty(name)) {
					var value = values[name];
					if (Array.isArray(value)) {
						forEach(value, function (v) {
							formData.append(name, v);
						});
					} else {
						formData.append(name, value);
					}
				}
			}
			return formData;
		}

		//====================================================================
		// Ajax
		//====================================================================

		function getHeaders(elt, target, prompt) {
			var headers = {
				"HX-Request": "true",
				"HX-Trigger": getRawAttribute(elt, "id"),
				"HX-Trigger-Name": getRawAttribute(elt, "name"),
				"HX-Target": getAttributeValue(target, "id"),
				"HX-Current-URL": getDocument().location.href,
			};
			getValuesForElement(elt, "hx-headers", false, headers);
			if (prompt !== undefined) {
				headers["HX-Prompt"] = prompt;
			}
			return headers;
		}

		function filterValues(inputValues, elt) {
			var paramsValue = getClosestAttributeValue(elt, "hx-params");
			if (paramsValue) {
				if (paramsValue === "none") {
					return {};
				} else if (paramsValue === "*") {
					return inputValues;
				} else if (paramsValue.indexOf("not ") === 0) {
					forEach(paramsValue.substr(4).split(","), function (name) {
						name = name.trim();
						delete inputValues[name];
					});
					return inputValues;
				} else {
					var newValues = {};
					forEach(paramsValue.split(","), function (name) {
						name = name.trim();
						newValues[name] = inputValues[name];
					});
					return newValues;
				}
			} else {
				return inputValues;
			}
		}

		function isAnchorLink(elt) {
			return (
				getRawAttribute(elt, "href") &&
				getRawAttribute(elt, "href").indexOf("#") >= 0
			);
		}

		function getSwapSpecification(elt) {
			var swapInfo = getClosestAttributeValue(elt, "hx-swap");
			var swapSpec = {
				swapStyle: getInternalData(elt).boosted
					? "innerHTML"
					: htmx.config.defaultSwapStyle,
				swapDelay: htmx.config.defaultSwapDelay,
				settleDelay: htmx.config.defaultSettleDelay,
			};
			if (getInternalData(elt).boosted && !isAnchorLink(elt)) {
				swapSpec["show"] = "top";
			}
			if (swapInfo) {
				var split = splitOnWhitespace(swapInfo);
				if (split.length > 0) {
					swapSpec["swapStyle"] = split[0];
					for (var i = 1; i < split.length; i++) {
						var modifier = split[i];
						if (modifier.indexOf("swap:") === 0) {
							swapSpec["swapDelay"] = parseInterval(modifier.substr(5));
						}
						if (modifier.indexOf("settle:") === 0) {
							swapSpec["settleDelay"] = parseInterval(modifier.substr(7));
						}
						if (modifier.indexOf("scroll:") === 0) {
							swapSpec["scroll"] = modifier.substr(7);
						}
						if (modifier.indexOf("show:") === 0) {
							swapSpec["show"] = modifier.substr(5);
						}
					}
				}
			}
			return swapSpec;
		}

		function encodeParamsForBody(xhr, elt, filteredParameters) {
			var encodedParameters = null;
			withExtensions(elt, function (extension) {
				if (encodedParameters == null) {
					encodedParameters = extension.encodeParameters(
						xhr,
						filteredParameters,
						elt
					);
				}
			});
			if (encodedParameters != null) {
				return encodedParameters;
			} else {
				if (
					getClosestAttributeValue(elt, "hx-encoding") === "multipart/form-data"
				) {
					return makeFormData(filteredParameters);
				} else {
					return urlEncode(filteredParameters);
				}
			}
		}

		function makeSettleInfo(target) {
			return { tasks: [], elts: [target] };
		}

		function updateScrollState(content, swapSpec) {
			var first = content[0];
			var last = content[content.length - 1];
			if (swapSpec.scroll) {
				if (swapSpec.scroll === "top" && first) {
					first.scrollTop = 0;
				}
				if (swapSpec.scroll === "bottom" && last) {
					last.scrollTop = last.scrollHeight;
				}
			}
			if (swapSpec.show) {
				if (swapSpec.show === "top" && first) {
					first.scrollIntoView(true);
				}
				if (swapSpec.show === "bottom" && last) {
					last.scrollIntoView(false);
				}
			}
		}

		function getValuesForElement(elt, attr, evalAsDefault, values) {
			if (values == null) {
				values = {};
			}
			if (elt == null) {
				return values;
			}
			var attributeValue = getAttributeValue(elt, attr);
			if (attributeValue) {
				var str = attributeValue.trim();
				var evaluateValue = evalAsDefault;
				if (str.indexOf("javascript:") === 0) {
					str = str.substr(11);
					evaluateValue = true;
				}
				if (str.indexOf("{") !== 0) {
					str = "{" + str + "}";
				}
				var varsValues;
				if (evaluateValue) {
					varsValues = maybeEval(
						elt,
						function () {
							return Function("return (" + str + ")")();
						},
						{}
					);
				} else {
					varsValues = parseJSON(str);
				}
				for (var key in varsValues) {
					if (varsValues.hasOwnProperty(key)) {
						if (values[key] == null) {
							values[key] = varsValues[key];
						}
					}
				}
			}
			return getValuesForElement(parentElt(elt), attr, evalAsDefault, values);
		}

		function maybeEval(elt, toEval, defaultVal) {
			if (htmx.config.allowEval) {
				return toEval();
			} else {
				triggerErrorEvent(elt, "htmx:evalDisallowedError");
				return defaultVal;
			}
		}

		function getHXVarsForElement(elt, expressionVars) {
			return getValuesForElement(elt, "hx-vars", true, expressionVars);
		}

		function getHXValsForElement(elt, expressionVars) {
			return getValuesForElement(elt, "hx-vals", false, expressionVars);
		}

		function getExpressionVars(elt) {
			return mergeObjects(getHXVarsForElement(elt), getHXValsForElement(elt));
		}

		function safelySetHeaderValue(xhr, header, headerValue) {
			if (headerValue !== null) {
				try {
					xhr.setRequestHeader(header, headerValue);
				} catch (e) {
					// On an exception, try to set the header URI encoded instead
					xhr.setRequestHeader(header, encodeURIComponent(headerValue));
					xhr.setRequestHeader(header + "-URI-AutoEncoded", "true");
				}
			}
		}

		function getResponseURL(xhr) {
			// NB: IE11 does not support this stuff
			if (xhr.responseURL && typeof URL !== "undefined") {
				try {
					var url = new URL(xhr.responseURL);
					return url.pathname + url.search;
				} catch (e) {
					triggerErrorEvent(getDocument().body, "htmx:badResponseUrl", {
						url: xhr.responseURL,
					});
				}
			}
		}

		function hasHeader(xhr, regexp) {
			return xhr.getAllResponseHeaders().match(regexp);
		}

		function ajaxHelper(verb, path, context) {
			if (context) {
				if (context instanceof Element || isType(context, "String")) {
					return issueAjaxRequest(verb, path, null, null, {
						targetOverride: resolveTarget(context),
					});
				} else {
					return issueAjaxRequest(
						verb,
						path,
						resolveTarget(context.source),
						context.event,
						{
							handler: context.handler,
							headers: context.headers,
							values: context.values,
							targetOverride: resolveTarget(context.target),
						}
					);
				}
			} else {
				return issueAjaxRequest(verb, path);
			}
		}

		function issueAjaxRequest(verb, path, elt, event, etc) {
			var resolve = null;
			var reject = null;
			etc = etc != null ? etc : {};
			if (typeof Promise !== "undefined") {
				var promise = new Promise(function (_resolve, _reject) {
					resolve = _resolve;
					reject = _reject;
				});
			}
			if (elt == null) {
				elt = getDocument().body;
			}
			var responseHandler = etc.handler || handleAjaxResponse;

			if (!bodyContains(elt)) {
				return; // do not issue requests for elements removed from the DOM
			}
			var target = etc.targetOverride || getTarget(elt);
			if (target == null) {
				triggerErrorEvent(elt, "htmx:targetError", {
					target: getAttributeValue(elt, "hx-target"),
				});
				return;
			}
			var eltData = getInternalData(elt);
			if (eltData.requestInFlight) {
				eltData.queuedRequest = function () {
					issueAjaxRequest(verb, path, elt, event);
				};
				return;
			} else {
				eltData.requestInFlight = true;
			}
			var endRequestLock = function () {
				eltData.requestInFlight = false;
				var queuedRequest = eltData.queuedRequest;
				eltData.queuedRequest = null;
				if (queuedRequest) {
					queuedRequest();
				}
			};
			var promptQuestion = getClosestAttributeValue(elt, "hx-prompt");
			if (promptQuestion) {
				var promptResponse = prompt(promptQuestion);
				// prompt returns null if cancelled and empty string if accepted with no entry
				if (
					promptResponse === null ||
					!triggerEvent(elt, "htmx:prompt", {
						prompt: promptResponse,
						target: target,
					})
				)
					maybeCall(resolve);
				endRequestLock();
				return promise;
			}

			var confirmQuestion = getClosestAttributeValue(elt, "hx-confirm");
			if (confirmQuestion) {
				if (!confirm(confirmQuestion)) {
					maybeCall(resolve);
					endRequestLock();
					return promise;
				}
			}

			var xhr = new XMLHttpRequest();

			var headers = getHeaders(elt, target, promptResponse);
			if (etc.headers) {
				headers = mergeObjects(headers, etc.values);
			}
			var results = getInputValues(elt, verb);
			var errors = results.errors;
			var rawParameters = results.values;
			if (etc.values) {
				rawParameters = mergeObjects(rawParameters, etc.values);
			}
			var expressionVars = getExpressionVars(elt);
			var allParameters = mergeObjects(rawParameters, expressionVars);
			var filteredParameters = filterValues(allParameters, elt);

			if (
				verb !== "get" &&
				getClosestAttributeValue(elt, "hx-encoding") == null
			) {
				headers["Content-Type"] =
					"application/x-www-form-urlencoded; charset=UTF-8";
			}

			// behavior of anchors w/ empty href is to use the current URL
			if (path == null || path === "") {
				path = getDocument().location.href;
			}

			var requestConfig = {
				parameters: filteredParameters,
				unfilteredParameters: allParameters,
				headers: headers,
				target: target,
				verb: verb,
				errors: errors,
				path: path,
				triggeringEvent: event,
			};

			if (!triggerEvent(elt, "htmx:configRequest", requestConfig))
				return endRequestLock();
			// copy out in case the object was overwritten
			path = requestConfig.path;
			verb = requestConfig.verb;
			headers = requestConfig.headers;
			filteredParameters = requestConfig.parameters;
			errors = requestConfig.errors;

			if (errors && errors.length > 0) {
				triggerEvent(elt, "htmx:validation:halted", requestConfig);
				maybeCall(resolve);
				endRequestLock();
				return promise;
			}

			var splitPath = path.split("#");
			var pathNoAnchor = splitPath[0];
			var anchor = splitPath[1];
			if (verb === "get") {
				var finalPathForGet = pathNoAnchor;
				var values = Object.keys(filteredParameters).length !== 0;
				if (values) {
					if (finalPathForGet.indexOf("?") < 0) {
						finalPathForGet += "?";
					} else {
						finalPathForGet += "&";
					}
					finalPathForGet += urlEncode(filteredParameters);
					if (anchor) {
						finalPathForGet += "#" + anchor;
					}
				}
				xhr.open("GET", finalPathForGet, true);
			} else {
				xhr.open(verb.toUpperCase(), path, true);
			}

			xhr.overrideMimeType("text/html");

			// request headers
			for (var header in headers) {
				if (headers.hasOwnProperty(header)) {
					var headerValue = headers[header];
					safelySetHeaderValue(xhr, header, headerValue);
				}
			}

			var responseInfo = {
				xhr: xhr,
				target: target,
				requestConfig: requestConfig,
				pathInfo: {
					path: path,
					finalPath: finalPathForGet,
					anchor: anchor,
				},
			};
			xhr.onload = function () {
				try {
					responseHandler(elt, responseInfo);
				} catch (e) {
					triggerErrorEvent(
						elt,
						"htmx:onLoadError",
						mergeObjects({ error: e }, responseInfo)
					);
					throw e;
				} finally {
					removeRequestIndicatorClasses(indicators);
					var finalElt = elt;
					if (!bodyContains(elt)) {
						finalElt = getInternalData(target).replacedWith || target;
					}
					triggerEvent(finalElt, "htmx:afterRequest", responseInfo);
					triggerEvent(finalElt, "htmx:afterOnLoad", responseInfo);
					maybeCall(resolve);
					endRequestLock();
				}
			};
			xhr.onerror = function () {
				removeRequestIndicatorClasses(indicators);
				var finalElt = elt;
				if (!bodyContains(elt)) {
					finalElt = getInternalData(target).replacedWith || target;
				}
				triggerErrorEvent(finalElt, "htmx:afterRequest", responseInfo);
				triggerErrorEvent(finalElt, "htmx:sendError", responseInfo);
				maybeCall(reject);
				endRequestLock();
			};
			xhr.onabort = function () {
				removeRequestIndicatorClasses(indicators);
				var finalElt = elt;
				if (!bodyContains(elt)) {
					finalElt = getInternalData(target).replacedWith || target;
				}
				triggerErrorEvent(finalElt, "htmx:afterRequest", responseInfo);
				triggerErrorEvent(finalElt, "htmx:sendAbort", responseInfo);
				maybeCall(reject);
				endRequestLock();
			};
			if (!triggerEvent(elt, "htmx:beforeRequest", responseInfo)) {
				maybeCall(resolve);
				endRequestLock();
				return promise;
			}
			var indicators = addRequestIndicatorClasses(elt);

			forEach(
				["loadstart", "loadend", "progress", "abort"],
				function (eventName) {
					forEach([xhr, xhr.upload], function (target) {
						target.addEventListener(eventName, function (event) {
							triggerEvent(elt, "htmx:xhr:" + eventName, {
								lengthComputable: event.lengthComputable,
								loaded: event.loaded,
								total: event.total,
							});
						});
					});
				}
			);
			triggerEvent(elt, "htmx:beforeSend", responseInfo);
			xhr.send(
				verb === "get"
					? null
					: encodeParamsForBody(xhr, elt, filteredParameters)
			);
			return promise;
		}

		function handleAjaxResponse(elt, responseInfo) {
			var xhr = responseInfo.xhr;
			var target = responseInfo.target;

			if (!triggerEvent(elt, "htmx:beforeOnLoad", responseInfo)) return;

			if (hasHeader(xhr, /HX-Trigger:/i)) {
				handleTrigger(xhr, "HX-Trigger", elt);
			}

			if (hasHeader(xhr, /HX-Push:/i)) {
				var pushedUrl = xhr.getResponseHeader("HX-Push");
			}

			if (hasHeader(xhr, /HX-Redirect:/i)) {
				window.location.href = xhr.getResponseHeader("HX-Redirect");
				return;
			}

			if (hasHeader(xhr, /HX-Refresh:/i)) {
				if ("true" === xhr.getResponseHeader("HX-Refresh")) {
					location.reload();
					return;
				}
			}

			var shouldSaveHistory = shouldPush(elt) || pushedUrl;

			if (xhr.status >= 200 && xhr.status < 400) {
				if (xhr.status === 286) {
					cancelPolling(elt);
				}
				// don't process 'No Content'
				if (xhr.status !== 204) {
					if (!triggerEvent(target, "htmx:beforeSwap", responseInfo)) return;

					var serverResponse = xhr.response;
					withExtensions(elt, function (extension) {
						serverResponse = extension.transformResponse(
							serverResponse,
							xhr,
							elt
						);
					});

					// Save current page
					if (shouldSaveHistory) {
						saveHistory();
					}

					var swapSpec = getSwapSpecification(elt);

					target.classList.add(htmx.config.swappingClass);
					var doSwap = function () {
						try {
							var activeElt = document.activeElement;
							var selectionInfo = {
								elt: activeElt,
								start: activeElt ? activeElt.selectionStart : null,
								end: activeElt ? activeElt.selectionEnd : null,
							};

							var settleInfo = makeSettleInfo(target);
							selectAndSwap(
								swapSpec.swapStyle,
								target,
								elt,
								serverResponse,
								settleInfo
							);

							if (
								selectionInfo.elt &&
								!bodyContains(selectionInfo.elt) &&
								selectionInfo.elt.id
							) {
								var newActiveElt = document.getElementById(
									selectionInfo.elt.id
								);
								if (newActiveElt) {
									if (selectionInfo.start && newActiveElt.setSelectionRange) {
										newActiveElt.setSelectionRange(
											selectionInfo.start,
											selectionInfo.end
										);
									}
									newActiveElt.focus();
								}
							}

							target.classList.remove(htmx.config.swappingClass);
							forEach(settleInfo.elts, function (elt) {
								if (elt.classList) {
									elt.classList.add(htmx.config.settlingClass);
								}
								triggerEvent(elt, "htmx:afterSwap", responseInfo);
							});
							if (responseInfo.pathInfo.anchor) {
								location.hash = responseInfo.pathInfo.anchor;
							}

							if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
								var finalElt = elt;
								if (!bodyContains(elt)) {
									finalElt = getDocument().body;
								}
								handleTrigger(xhr, "HX-Trigger-After-Swap", finalElt);
							}

							var doSettle = function () {
								forEach(settleInfo.tasks, function (task) {
									task.call();
								});
								forEach(settleInfo.elts, function (elt) {
									if (elt.classList) {
										elt.classList.remove(htmx.config.settlingClass);
									}
									triggerEvent(elt, "htmx:afterSettle", responseInfo);
								});
								// push URL and save new page
								if (shouldSaveHistory) {
									var pathToPush =
										pushedUrl ||
										getPushUrl(elt) ||
										getResponseURL(xhr) ||
										responseInfo.pathInfo.finalPath ||
										responseInfo.pathInfo.path;
									pushUrlIntoHistory(pathToPush);
									triggerEvent(getDocument().body, "htmx:pushedIntoHistory", {
										path: pathToPush,
									});
								}
								updateScrollState(settleInfo.elts, swapSpec);

								if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
									var finalElt = elt;
									if (!bodyContains(elt)) {
										finalElt = getDocument().body;
									}
									handleTrigger(xhr, "HX-Trigger-After-Settle", finalElt);
								}
							};

							if (swapSpec.settleDelay > 0) {
								setTimeout(doSettle, swapSpec.settleDelay);
							} else {
								doSettle();
							}
						} catch (e) {
							triggerErrorEvent(elt, "htmx:swapError", responseInfo);
							throw e;
						}
					};

					if (swapSpec.swapDelay > 0) {
						setTimeout(doSwap, swapSpec.swapDelay);
					} else {
						doSwap();
					}
				}
			} else {
				triggerErrorEvent(
					elt,
					"htmx:responseError",
					mergeObjects(
						{
							error:
								"Response Status Error Code " +
								xhr.status +
								" from " +
								responseInfo.pathInfo.path,
						},
						responseInfo
					)
				);
			}
		}

		//====================================================================
		// Extensions API
		//====================================================================
		var extensions = {};
		function extensionBase() {
			return {
				onEvent: function (name, evt) {
					return true;
				},
				transformResponse: function (text, xhr, elt) {
					return text;
				},
				isInlineSwap: function (swapStyle) {
					return false;
				},
				handleSwap: function (swapStyle, target, fragment, settleInfo) {
					return false;
				},
				encodeParameters: function (xhr, parameters, elt) {
					return null;
				},
			};
		}

		function defineExtension(name, extension) {
			extensions[name] = mergeObjects(extensionBase(), extension);
		}

		function removeExtension(name) {
			delete extensions[name];
		}

		function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
			if (elt == undefined) {
				return extensionsToReturn;
			}
			if (extensionsToReturn == undefined) {
				extensionsToReturn = [];
			}
			if (extensionsToIgnore == undefined) {
				extensionsToIgnore = [];
			}
			var extensionsForElement = getAttributeValue(elt, "hx-ext");
			if (extensionsForElement) {
				forEach(extensionsForElement.split(","), function (extensionName) {
					extensionName = extensionName.replace(/ /g, "");
					if (extensionName.slice(0, 7) == "ignore:") {
						extensionsToIgnore.push(extensionName.slice(7));
						return;
					}
					if (extensionsToIgnore.indexOf(extensionName) < 0) {
						var extension = extensions[extensionName];
						if (extension && extensionsToReturn.indexOf(extension) < 0) {
							extensionsToReturn.push(extension);
						}
					}
				});
			}
			return getExtensions(
				parentElt(elt),
				extensionsToReturn,
				extensionsToIgnore
			);
		}

		//====================================================================
		// Initialization
		//====================================================================

		function ready(fn) {
			if (getDocument().readyState !== "loading") {
				fn();
			} else {
				getDocument().addEventListener("DOMContentLoaded", fn);
			}
		}

		function insertIndicatorStyles() {
			if (htmx.config.includeIndicatorStyles !== false) {
				getDocument().head.insertAdjacentHTML(
					"beforeend",
					"<style>\
                      ." +
						htmx.config.indicatorClass +
						"{opacity:0;transition: opacity 200ms ease-in;}\
                      ." +
						htmx.config.requestClass +
						" ." +
						htmx.config.indicatorClass +
						"{opacity:1}\
                      ." +
						htmx.config.requestClass +
						"." +
						htmx.config.indicatorClass +
						"{opacity:1}\
                    </style>"
				);
			}
		}

		function getMetaConfig() {
			var element = getDocument().querySelector('meta[name="htmx-config"]');
			if (element) {
				return parseJSON(element.content);
			} else {
				return null;
			}
		}

		function mergeMetaConfig() {
			var metaConfig = getMetaConfig();
			if (metaConfig) {
				htmx.config = mergeObjects(htmx.config, metaConfig);
			}
		}

		// initialize the document
		ready(function () {
			mergeMetaConfig();
			insertIndicatorStyles();
			var body = getDocument().body;
			processNode(body);
			window.onpopstate = function (event) {
				if (event.state && event.state.htmx) {
					restoreHistory();
				}
			};
			setTimeout(function () {
				triggerEvent(body, "htmx:load", {}); // give ready handlers a chance to load up before firing this event
			}, 0);
		});

		return htmx;
	})();
});

if (window.theme.settings.devMode) {
	// htmx.logAll();
}

htmx.on("htmx:afterSettle", function (evt) {
	// console.log(evt.detail);

	resetLozad();
	quickShop();

	if (evt.target.id == "CartBare") {
		htmx.ajax("GET", "/cart?view=count", "#CartCount");
	}
	// when triggering form updates from the cart drawer, re-render from the bare view
	if (evt.detail.elt.id == "CartFormDrawerTarget") {
		rerenderSlideCart();
	}
	if (evt.detail.elt.id == "CartFormTarget") {
		htmx.ajax("GET", "/cart", "");
	}

	// for removal of an item from the cart
	if (evt.target.id.includes("CartItem")) {
		rerenderSlideCart();
	}

	// re-render when adding the add-on
	if (evt.detail.elt.id == "EmptyTarget") {
		rerenderSlideCart();
	}

	// re-render when adding the free gift
	if (evt.detail.elt.id == "FREEGIFT") {
		rerenderSlideCart();
	}

	// re-render when adding the add-on
	if (evt.detail.elt.id == "EmptyTarget2") {
		rerenderSlideCart();
		const cartButton = document.querySelector("[data-cart-drawer-button]");
		if (
			theme.settings.enableAjax &&
			cartButton.getAttribute("aria-expanded") == "false"
		) {
			cartButton.click();
		}
	}

	if (evt.target.id == "quick-shop-modal") {
		var quicksections = new theme.Sections();
		quicksections.register("product", theme.Product);
		document.querySelector("[data-quick-shop-close]").focus();
	}
});

function rerenderSlideCart() {
	htmx.ajax("GET", "/cart?view=bare", "#CartBare");
}

/*! lozad.js - v1.9.0 - 2019-02-09
 * https://github.com/ApoorvSaxena/lozad.js
 * Copyright (c) 2019 Apoorv Saxena; Licensed MIT */
!(function (t, e) {
	"object" == typeof exports && "undefined" != typeof module
		? (module.exports = e())
		: "function" == typeof define && define.amd
		? define(e)
		: (t.lozad = e());
})(this, function () {
	"use strict";
	var g =
			Object.assign ||
			function (t) {
				for (var e = 1; e < arguments.length; e++) {
					var r = arguments[e];
					for (var o in r)
						Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
				}
				return t;
			},
		n = "undefined" != typeof document && document.documentMode,
		l = {
			rootMargin: "0px",
			threshold: 0,
			load: function (t) {
				if ("picture" === t.nodeName.toLowerCase()) {
					var e = document.createElement("img");
					n &&
						t.getAttribute("data-iesrc") &&
						(e.src = t.getAttribute("data-iesrc")),
						t.getAttribute("data-alt") && (e.alt = t.getAttribute("data-alt")),
						t.appendChild(e);
				}
				if (
					"video" === t.nodeName.toLowerCase() &&
					!t.getAttribute("data-src") &&
					t.children
				) {
					for (var r = t.children, o = void 0, a = 0; a <= r.length - 1; a++)
						(o = r[a].getAttribute("data-src")) && (r[a].src = o);
					t.load();
				}
				t.getAttribute("data-src") && (t.src = t.getAttribute("data-src")),
					t.getAttribute("data-srcset") &&
						t.setAttribute("srcset", t.getAttribute("data-srcset")),
					t.getAttribute("data-background-image") &&
						(t.style.backgroundImage =
							"url('" + t.getAttribute("data-background-image") + "')"),
					t.getAttribute("data-toggle-class") &&
						t.classList.toggle(t.getAttribute("data-toggle-class"));
			},
			loaded: function () {},
		};
	/**
	 * Detect IE browser
	 * @const {boolean}
	 * @private
	 */ function f(t) {
		t.setAttribute("data-loaded", !0);
	}
	var b = function (t) {
		return "true" === t.getAttribute("data-loaded");
	};
	return function () {
		var r,
			o,
			a =
				0 < arguments.length && void 0 !== arguments[0]
					? arguments[0]
					: ".lozad",
			t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
			e = g({}, l, t),
			n = e.root,
			i = e.rootMargin,
			d = e.threshold,
			c = e.load,
			u = e.loaded,
			s = void 0;
		return (
			window.IntersectionObserver &&
				(s = new IntersectionObserver(
					((r = c),
					(o = u),
					function (t, e) {
						t.forEach(function (t) {
							(0 < t.intersectionRatio || t.isIntersecting) &&
								(e.unobserve(t.target),
								b(t.target) || (r(t.target), f(t.target), o(t.target)));
						});
					}),
					{ root: n, rootMargin: i, threshold: d }
				)),
			{
				observe: function () {
					for (
						var t = (function (t) {
								var e =
									1 < arguments.length && void 0 !== arguments[1]
										? arguments[1]
										: document;
								return t instanceof Element
									? [t]
									: t instanceof NodeList
									? t
									: e.querySelectorAll(t);
							})(a, n),
							e = 0;
						e < t.length;
						e++
					)
						b(t[e]) || (s ? s.observe(t[e]) : (c(t[e]), f(t[e]), u(t[e])));
				},
				triggerLoad: function (t) {
					b(t) || (c(t), f(t), u(t));
				},
				observer: s,
			}
		);
	};
});

const lozadObserver = lozad(".lozad", {
	enableAutoReload: true, // it will reload the new image when validating attributes changes
});
lozadObserver.observe();

function resetLozad() {
	lozadObserver.observe();
}

const firstSection = document.querySelectorAll(
	"#MainContent .shopify-section"
)[0];
if (firstSection) {
	const eagerImages = firstSection.querySelectorAll(".lozad");
	eagerImages.forEach((element) => {
		lozadObserver.triggerLoad(element);
		const lazy = element.querySelectorAll('[loading="lazy"]')[0];
		if (lazy) {
			lazy.setAttribute("loading", "eager");
		}
	});
}

/**
 * Swiper 6.5.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 5, 2021
 */

 (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Swiper = factory());
  }(this, (function () { 'use strict';
  
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
  
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }
  
    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
  
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
  
        return target;
      };
  
      return _extends.apply(this, arguments);
    }
  
    /**
     * SSR Window 3.0.0
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2020, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: November 9, 2020
     */
  
    /* eslint-disable no-param-reassign */
    function isObject(obj) {
      return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
    }
  
    function extend(target, src) {
      if (target === void 0) {
        target = {};
      }
  
      if (src === void 0) {
        src = {};
      }
  
      Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
          extend(target[key], src[key]);
        }
      });
    }
  
    var ssrDocument = {
      body: {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      activeElement: {
        blur: function blur() {},
        nodeName: ''
      },
      querySelector: function querySelector() {
        return null;
      },
      querySelectorAll: function querySelectorAll() {
        return [];
      },
      getElementById: function getElementById() {
        return null;
      },
      createEvent: function createEvent() {
        return {
          initEvent: function initEvent() {}
        };
      },
      createElement: function createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute: function setAttribute() {},
          getElementsByTagName: function getElementsByTagName() {
            return [];
          }
        };
      },
      createElementNS: function createElementNS() {
        return {};
      },
      importNode: function importNode() {
        return null;
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      }
    };
  
    function getDocument() {
      var doc = typeof document !== 'undefined' ? document : {};
      extend(doc, ssrDocument);
      return doc;
    }
  
    var ssrWindow = {
      document: ssrDocument,
      navigator: {
        userAgent: ''
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
      },
      history: {
        replaceState: function replaceState() {},
        pushState: function pushState() {},
        go: function go() {},
        back: function back() {}
      },
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      getComputedStyle: function getComputedStyle() {
        return {
          getPropertyValue: function getPropertyValue() {
            return '';
          }
        };
      },
      Image: function Image() {},
      Date: function Date() {},
      screen: {},
      setTimeout: function setTimeout() {},
      clearTimeout: function clearTimeout() {},
      matchMedia: function matchMedia() {
        return {};
      },
      requestAnimationFrame: function requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
          callback();
          return null;
        }
  
        return setTimeout(callback, 0);
      },
      cancelAnimationFrame: function cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
          return;
        }
  
        clearTimeout(id);
      }
    };
  
    function getWindow() {
      var win = typeof window !== 'undefined' ? window : {};
      extend(win, ssrWindow);
      return win;
    }
  
    /**
     * Dom7 3.0.0
     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
     * https://framework7.io/docs/dom7.html
     *
     * Copyright 2020, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: November 9, 2020
     */
  
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }
  
    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }
  
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  
      return _setPrototypeOf(o, p);
    }
  
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
  
      try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
  
    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
  
      return _construct.apply(null, arguments);
    }
  
    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
  
    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;
  
      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
  
        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }
  
        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);
  
          _cache.set(Class, Wrapper);
        }
  
        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
  
        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };
  
      return _wrapNativeSuper(Class);
    }
  
    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
  
      return self;
    }
    /* eslint-disable no-proto */
  
  
    function makeReactive(obj) {
      var proto = obj.__proto__;
      Object.defineProperty(obj, '__proto__', {
        get: function get() {
          return proto;
        },
        set: function set(value) {
          proto.__proto__ = value;
        }
      });
    }
  
    var Dom7 = /*#__PURE__*/function (_Array) {
      _inheritsLoose(Dom7, _Array);
  
      function Dom7(items) {
        var _this;
  
        _this = _Array.call.apply(_Array, [this].concat(items)) || this;
        makeReactive(_assertThisInitialized(_this));
        return _this;
      }
  
      return Dom7;
    }( /*#__PURE__*/_wrapNativeSuper(Array));
  
    function arrayFlat(arr) {
      if (arr === void 0) {
        arr = [];
      }
  
      var res = [];
      arr.forEach(function (el) {
        if (Array.isArray(el)) {
          res.push.apply(res, arrayFlat(el));
        } else {
          res.push(el);
        }
      });
      return res;
    }
  
    function arrayFilter(arr, callback) {
      return Array.prototype.filter.call(arr, callback);
    }
  
    function arrayUnique(arr) {
      var uniqueArray = [];
  
      for (var i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
      }
  
      return uniqueArray;
    }
  
    function qsa(selector, context) {
      if (typeof selector !== 'string') {
        return [selector];
      }
  
      var a = [];
      var res = context.querySelectorAll(selector);
  
      for (var i = 0; i < res.length; i += 1) {
        a.push(res[i]);
      }
  
      return a;
    }
  
    function $(selector, context) {
      var window = getWindow();
      var document = getDocument();
      var arr = [];
  
      if (!context && selector instanceof Dom7) {
        return selector;
      }
  
      if (!selector) {
        return new Dom7(arr);
      }
  
      if (typeof selector === 'string') {
        var html = selector.trim();
  
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) toCreate = 'ul';
          if (html.indexOf('<tr') === 0) toCreate = 'tbody';
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
          if (html.indexOf('<tbody') === 0) toCreate = 'table';
          if (html.indexOf('<option') === 0) toCreate = 'select';
          var tempParent = document.createElement(toCreate);
          tempParent.innerHTML = html;
  
          for (var i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          arr = qsa(selector.trim(), context || document);
        } // arr = qsa(selector, document);
  
      } else if (selector.nodeType || selector === window || selector === document) {
        arr.push(selector);
      } else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
      }
  
      return new Dom7(arrayUnique(arr));
    }
  
    $.fn = Dom7.prototype;
  
    function addClass() {
      for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
      }
  
      var classNames = arrayFlat(classes.map(function (c) {
        return c.split(' ');
      }));
      this.forEach(function (el) {
        var _el$classList;
  
        (_el$classList = el.classList).add.apply(_el$classList, classNames);
      });
      return this;
    }
  
    function removeClass() {
      for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classes[_key2] = arguments[_key2];
      }
  
      var classNames = arrayFlat(classes.map(function (c) {
        return c.split(' ');
      }));
      this.forEach(function (el) {
        var _el$classList2;
  
        (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
      });
      return this;
    }
  
    function toggleClass() {
      for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        classes[_key3] = arguments[_key3];
      }
  
      var classNames = arrayFlat(classes.map(function (c) {
        return c.split(' ');
      }));
      this.forEach(function (el) {
        classNames.forEach(function (className) {
          el.classList.toggle(className);
        });
      });
    }
  
    function hasClass() {
      for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        classes[_key4] = arguments[_key4];
      }
  
      var classNames = arrayFlat(classes.map(function (c) {
        return c.split(' ');
      }));
      return arrayFilter(this, function (el) {
        return classNames.filter(function (className) {
          return el.classList.contains(className);
        }).length > 0;
      }).length > 0;
    }
  
    function attr(attrs, value) {
      if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
      } // Set attrs
  
  
      for (var i = 0; i < this.length; i += 1) {
        if (arguments.length === 2) {
          // String
          this[i].setAttribute(attrs, value);
        } else {
          // Object
          for (var attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }
  
      return this;
    }
  
    function removeAttr(attr) {
      for (var i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }
  
      return this;
    }
  
    function transform(transform) {
      for (var i = 0; i < this.length; i += 1) {
        this[i].style.transform = transform;
      }
  
      return this;
    }
  
    function transition(duration) {
      for (var i = 0; i < this.length; i += 1) {
        this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
      }
  
      return this;
    }
  
    function on() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
  
      var eventType = args[0],
          targetSelector = args[1],
          listener = args[2],
          capture = args[3];
  
      if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
      }
  
      if (!capture) capture = false;
  
      function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
  
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
  
        if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
          var _parents = $(target).parents(); // eslint-disable-line
  
  
          for (var k = 0; k < _parents.length; k += 1) {
            if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
          }
        }
      }
  
      function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
  
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
  
        listener.apply(this, eventData);
      }
  
      var events = eventType.split(' ');
      var j;
  
      for (var i = 0; i < this.length; i += 1) {
        var el = this[i];
  
        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
              listener: listener,
              proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          // Live events
          for (j = 0; j < events.length; j += 1) {
            var _event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
  
            el.dom7LiveListeners[_event].push({
              listener: listener,
              proxyListener: handleLiveEvent
            });
  
            el.addEventListener(_event, handleLiveEvent, capture);
          }
        }
      }
  
      return this;
    }
  
    function off() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
  
      var eventType = args[0],
          targetSelector = args[1],
          listener = args[2],
          capture = args[3];
  
      if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
      }
  
      if (!capture) capture = false;
      var events = eventType.split(' ');
  
      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];
  
        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
          var handlers = void 0;
  
          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }
  
          if (handlers && handlers.length) {
            for (var k = handlers.length - 1; k >= 0; k -= 1) {
              var handler = handlers[k];
  
              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }
  
      return this;
    }
  
    function trigger() {
      var window = getWindow();
  
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
  
      var events = args[0].split(' ');
      var eventData = args[1];
  
      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];
  
        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
  
          if (window.CustomEvent) {
            var evt = new window.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true
            });
            el.dom7EventData = args.filter(function (data, dataIndex) {
              return dataIndex > 0;
            });
            el.dispatchEvent(evt);
            el.dom7EventData = [];
            delete el.dom7EventData;
          }
        }
      }
  
      return this;
    }
  
    function transitionEnd(callback) {
      var dom = this;
  
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
      }
  
      if (callback) {
        dom.on('transitionend', fireCallBack);
      }
  
      return this;
    }
  
    function outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          var _styles = this.styles();
  
          return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
        }
  
        return this[0].offsetWidth;
      }
  
      return null;
    }
  
    function outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          var _styles2 = this.styles();
  
          return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
        }
  
        return this[0].offsetHeight;
      }
  
      return null;
    }
  
    function offset() {
      if (this.length > 0) {
        var window = getWindow();
        var document = getDocument();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft
        };
      }
  
      return null;
    }
  
    function styles() {
      var window = getWindow();
      if (this[0]) return window.getComputedStyle(this[0], null);
      return {};
    }
  
    function css(props, value) {
      var window = getWindow();
      var i;
  
      if (arguments.length === 1) {
        if (typeof props === 'string') {
          // .css('width')
          if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
          // .css({ width: '100px' })
          for (i = 0; i < this.length; i += 1) {
            for (var _prop in props) {
              this[i].style[_prop] = props[_prop];
            }
          }
  
          return this;
        }
      }
  
      if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }
  
        return this;
      }
  
      return this;
    }
  
    function each(callback) {
      if (!callback) return this;
      this.forEach(function (el, index) {
        callback.apply(el, [el, index]);
      });
      return this;
    }
  
    function filter(callback) {
      var result = arrayFilter(this, callback);
      return $(result);
    }
  
    function html(html) {
      if (typeof html === 'undefined') {
        return this[0] ? this[0].innerHTML : null;
      }
  
      for (var i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }
  
      return this;
    }
  
    function text(text) {
      if (typeof text === 'undefined') {
        return this[0] ? this[0].textContent.trim() : null;
      }
  
      for (var i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }
  
      return this;
    }
  
    function is(selector) {
      var window = getWindow();
      var document = getDocument();
      var el = this[0];
      var compareWith;
      var i;
      if (!el || typeof selector === 'undefined') return false;
  
      if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
  
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
  
        return false;
      }
  
      if (selector === document) {
        return el === document;
      }
  
      if (selector === window) {
        return el === window;
      }
  
      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;
  
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
  
        return false;
      }
  
      return false;
    }
  
    function index() {
      var child = this[0];
      var i;
  
      if (child) {
        i = 0; // eslint-disable-next-line
  
        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) i += 1;
        }
  
        return i;
      }
  
      return undefined;
    }
  
    function eq(index) {
      if (typeof index === 'undefined') return this;
      var length = this.length;
  
      if (index > length - 1) {
        return $([]);
      }
  
      if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([this[returnIndex]]);
      }
  
      return $([this[index]]);
    }
  
    function append() {
      var newChild;
      var document = getDocument();
  
      for (var k = 0; k < arguments.length; k += 1) {
        newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
  
        for (var i = 0; i < this.length; i += 1) {
          if (typeof newChild === 'string') {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
  
            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (var j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }
  
      return this;
    }
  
    function prepend(newChild) {
      var document = getDocument();
      var i;
      var j;
  
      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = newChild;
  
          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }
  
      return this;
    }
  
    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
            return $([this[0].nextElementSibling]);
          }
  
          return $([]);
        }
  
        if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
        return $([]);
      }
  
      return $([]);
    }
  
    function nextAll(selector) {
      var nextEls = [];
      var el = this[0];
      if (!el) return $([]);
  
      while (el.nextElementSibling) {
        var _next = el.nextElementSibling; // eslint-disable-line
  
        if (selector) {
          if ($(_next).is(selector)) nextEls.push(_next);
        } else nextEls.push(_next);
  
        el = _next;
      }
  
      return $(nextEls);
    }
  
    function prev(selector) {
      if (this.length > 0) {
        var el = this[0];
  
        if (selector) {
          if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
            return $([el.previousElementSibling]);
          }
  
          return $([]);
        }
  
        if (el.previousElementSibling) return $([el.previousElementSibling]);
        return $([]);
      }
  
      return $([]);
    }
  
    function prevAll(selector) {
      var prevEls = [];
      var el = this[0];
      if (!el) return $([]);
  
      while (el.previousElementSibling) {
        var _prev = el.previousElementSibling; // eslint-disable-line
  
        if (selector) {
          if ($(_prev).is(selector)) prevEls.push(_prev);
        } else prevEls.push(_prev);
  
        el = _prev;
      }
  
      return $(prevEls);
    }
  
    function parent(selector) {
      var parents = []; // eslint-disable-line
  
      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }
  
      return $(parents);
    }
  
    function parents(selector) {
      var parents = []; // eslint-disable-line
  
      for (var i = 0; i < this.length; i += 1) {
        var _parent = this[i].parentNode; // eslint-disable-line
  
        while (_parent) {
          if (selector) {
            if ($(_parent).is(selector)) parents.push(_parent);
          } else {
            parents.push(_parent);
          }
  
          _parent = _parent.parentNode;
        }
      }
  
      return $(parents);
    }
  
    function closest(selector) {
      var closest = this; // eslint-disable-line
  
      if (typeof selector === 'undefined') {
        return $([]);
      }
  
      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }
  
      return closest;
    }
  
    function find(selector) {
      var foundElements = [];
  
      for (var i = 0; i < this.length; i += 1) {
        var found = this[i].querySelectorAll(selector);
  
        for (var j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }
  
      return $(foundElements);
    }
  
    function children(selector) {
      var children = []; // eslint-disable-line
  
      for (var i = 0; i < this.length; i += 1) {
        var childNodes = this[i].children;
  
        for (var j = 0; j < childNodes.length; j += 1) {
          if (!selector || $(childNodes[j]).is(selector)) {
            children.push(childNodes[j]);
          }
        }
      }
  
      return $(children);
    }
  
    function remove() {
      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
      }
  
      return this;
    }
  
    var Methods = {
      addClass: addClass,
      removeClass: removeClass,
      hasClass: hasClass,
      toggleClass: toggleClass,
      attr: attr,
      removeAttr: removeAttr,
      transform: transform,
      transition: transition,
      on: on,
      off: off,
      trigger: trigger,
      transitionEnd: transitionEnd,
      outerWidth: outerWidth,
      outerHeight: outerHeight,
      styles: styles,
      offset: offset,
      css: css,
      each: each,
      html: html,
      text: text,
      is: is,
      index: index,
      eq: eq,
      append: append,
      prepend: prepend,
      next: next,
      nextAll: nextAll,
      prev: prev,
      prevAll: prevAll,
      parent: parent,
      parents: parents,
      closest: closest,
      find: find,
      children: children,
      filter: filter,
      remove: remove
    };
    Object.keys(Methods).forEach(function (methodName) {
      $.fn[methodName] = Methods[methodName];
    });
  
    function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {// no getter for object
        }
  
        try {
          delete object[key];
        } catch (e) {// something got wrong
        }
      });
    }
  
    function nextTick(callback, delay) {
      if (delay === void 0) {
        delay = 0;
      }
  
      return setTimeout(callback, delay);
    }
  
    function now() {
      return Date.now();
    }
  
    function getTranslate(el, axis) {
      if (axis === void 0) {
        axis = 'x';
      }
  
      var window = getWindow();
      var matrix;
      var curTransform;
      var transformMatrix;
      var curStyle = window.getComputedStyle(el, null);
  
      if (window.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
  
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) {
            return a.replace(',', '.');
          }).join(', ');
        } // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
  
  
        transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }
  
      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
          else curTransform = parseFloat(matrix[4]);
      }
  
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
          else curTransform = parseFloat(matrix[5]);
      }
  
      return curTransform || 0;
    }
  
    function isObject$1(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    }
  
    function extend$1() {
      var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  
      for (var i = 1; i < arguments.length; i += 1) {
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
  
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
  
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
  
            if (desc !== undefined && desc.enumerable) {
              if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
                extend$1(to[nextKey], nextSource[nextKey]);
              } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
                to[nextKey] = {};
                extend$1(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
  
      return to;
    }
  
    function bindModuleMethods(instance, obj) {
      Object.keys(obj).forEach(function (key) {
        if (isObject$1(obj[key])) {
          Object.keys(obj[key]).forEach(function (subKey) {
            if (typeof obj[key][subKey] === 'function') {
              obj[key][subKey] = obj[key][subKey].bind(instance);
            }
          });
        }
  
        instance[key] = obj[key];
      });
    }
  
    var support;
  
    function calcSupport() {
      var window = getWindow();
      var document = getDocument();
      return {
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
        observer: function checkObserver() {
          return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
        }(),
        passiveListener: function checkPassiveListener() {
          var supportsPassive = false;
  
          try {
            var opts = Object.defineProperty({}, 'passive', {
              // eslint-disable-next-line
              get: function get() {
                supportsPassive = true;
              }
            });
            window.addEventListener('testPassiveListener', null, opts);
          } catch (e) {// No support
          }
  
          return supportsPassive;
        }(),
        gestures: function checkGestures() {
          return 'ongesturestart' in window;
        }()
      };
    }
  
    function getSupport() {
      if (!support) {
        support = calcSupport();
      }
  
      return support;
    }
  
    var device;
  
    function calcDevice(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          userAgent = _ref.userAgent;
  
      var support = getSupport();
      var window = getWindow();
      var platform = window.navigator.platform;
      var ua = userAgent || window.navigator.userAgent;
      var device = {
        ios: false,
        android: false
      };
      var screenWidth = window.screen.width;
      var screenHeight = window.screen.height;
      var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      var windows = platform === 'Win32';
      var macos = platform === 'MacIntel'; // iPadOs 13 fix
  
      var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  
      if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [0, 1, '13_0_0'];
        macos = false;
      } // Android
  
  
      if (android && !windows) {
        device.os = 'android';
        device.android = true;
      }
  
      if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
      } // Export object
  
  
      return device;
    }
  
    function getDevice(overrides) {
      if (overrides === void 0) {
        overrides = {};
      }
  
      if (!device) {
        device = calcDevice(overrides);
      }
  
      return device;
    }
  
    var browser;
  
    function calcBrowser() {
      var window = getWindow();
  
      function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
      }
  
      return {
        isEdge: !!window.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
      };
    }
  
    function getBrowser() {
      if (!browser) {
        browser = calcBrowser();
      }
  
      return browser;
    }
  
    var supportsResizeObserver = function supportsResizeObserver() {
      var window = getWindow();
      return typeof window.ResizeObserver !== 'undefined';
    };
  
    var Resize = {
      name: 'resize',
      create: function create() {
        var swiper = this;
        extend$1(swiper, {
          resize: {
            observer: null,
            createObserver: function createObserver() {
              if (!swiper || swiper.destroyed || !swiper.initialized) return;
              swiper.resize.observer = new ResizeObserver(function (entries) {
                var width = swiper.width,
                    height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function (_ref) {
                  var contentBoxSize = _ref.contentBoxSize,
                      contentRect = _ref.contentRect,
                      target = _ref.target;
                  if (target && target !== swiper.el) return;
                  newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                  newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
  
                if (newWidth !== width || newHeight !== height) {
                  swiper.resize.resizeHandler();
                }
              });
              swiper.resize.observer.observe(swiper.el);
            },
            removeObserver: function removeObserver() {
              if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
                swiper.resize.observer.unobserve(swiper.el);
                swiper.resize.observer = null;
              }
            },
            resizeHandler: function resizeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) return;
              swiper.emit('beforeResize');
              swiper.emit('resize');
            },
            orientationChangeHandler: function orientationChangeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) return;
              swiper.emit('orientationchange');
            }
          }
        });
      },
      on: {
        init: function init(swiper) {
          var window = getWindow();
  
          if (swiper.params.resizeObserver && supportsResizeObserver()) {
            swiper.resize.createObserver();
            return;
          } // Emit resize
  
  
          window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange
  
          window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy(swiper) {
          var window = getWindow();
          swiper.resize.removeObserver();
          window.removeEventListener('resize', swiper.resize.resizeHandler);
          window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        }
      }
    };
  
    var Observer = {
      attach: function attach(target, options) {
        if (options === void 0) {
          options = {};
        }
  
        var window = getWindow();
        var swiper = this;
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function (mutations) {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (mutations.length === 1) {
            swiper.emit('observerUpdate', mutations[0]);
            return;
          }
  
          var observerUpdate = function observerUpdate() {
            swiper.emit('observerUpdate', mutations[0]);
          };
  
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(observerUpdate);
          } else {
            window.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
          childList: typeof options.childList === 'undefined' ? true : options.childList,
          characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
      },
      init: function init() {
        var swiper = this;
        if (!swiper.support.observer || !swiper.params.observer) return;
  
        if (swiper.params.observeParents) {
          var containerParents = swiper.$el.parents();
  
          for (var i = 0; i < containerParents.length; i += 1) {
            swiper.observer.attach(containerParents[i]);
          }
        } // Observe container
  
  
        swiper.observer.attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
  
        swiper.observer.attach(swiper.$wrapperEl[0], {
          attributes: false
        });
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function (observer) {
          observer.disconnect();
        });
        swiper.observer.observers = [];
      }
    };
    var Observer$1 = {
      name: 'observer',
      params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          observer: _extends({}, Observer, {
            observers: []
          })
        });
      },
      on: {
        init: function init(swiper) {
          swiper.observer.init();
        },
        destroy: function destroy(swiper) {
          swiper.observer.destroy();
        }
      }
    };
  
    var modular = {
      useParams: function useParams(instanceParams) {
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function (moduleName) {
          var module = instance.modules[moduleName]; // Extend params
  
          if (module.params) {
            extend$1(instanceParams, module.params);
          }
        });
      },
      useModules: function useModules(modulesParams) {
        if (modulesParams === void 0) {
          modulesParams = {};
        }
  
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function (moduleName) {
          var module = instance.modules[moduleName];
          var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
  
          if (module.on && instance.on) {
            Object.keys(module.on).forEach(function (moduleEventName) {
              instance.on(moduleEventName, module.on[moduleEventName]);
            });
          } // Module create callback
  
  
          if (module.create) {
            module.create.bind(instance)(moduleParams);
          }
        });
      }
    };
  
    /* eslint-disable no-underscore-dangle */
    var eventsEmitter = {
      on: function on(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function (event) {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      },
      once: function once(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
  
        function onceHandler() {
          self.off(events, onceHandler);
  
          if (onceHandler.__emitterProxy) {
            delete onceHandler.__emitterProxy;
          }
  
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
  
          handler.apply(self, args);
        }
  
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
      },
      onAny: function onAny(handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
  
        if (self.eventsAnyListeners.indexOf(handler) < 0) {
          self.eventsAnyListeners[method](handler);
        }
  
        return self;
      },
      offAny: function offAny(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
  
        if (index >= 0) {
          self.eventsAnyListeners.splice(index, 1);
        }
  
        return self;
      },
      off: function off(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function (event) {
          if (typeof handler === 'undefined') {
            self.eventsListeners[event] = [];
          } else if (self.eventsListeners[event]) {
            self.eventsListeners[event].forEach(function (eventHandler, index) {
              if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      },
      emit: function emit() {
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
  
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
  
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }
  
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function (event) {
          if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
            self.eventsAnyListeners.forEach(function (eventHandler) {
              eventHandler.apply(context, [event].concat(data));
            });
          }
  
          if (self.eventsListeners && self.eventsListeners[event]) {
            self.eventsListeners[event].forEach(function (eventHandler) {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      }
    };
  
    function updateSize() {
      var swiper = this;
      var width;
      var height;
      var $el = swiper.$el;
  
      if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }
  
      if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }
  
      if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
      } // Subtract paddings
  
  
      width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
      height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
      if (Number.isNaN(width)) width = 0;
      if (Number.isNaN(height)) height = 0;
      extend$1(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
      });
    }
  
    function updateSlides() {
      var swiper = this;
  
      var getDirectionLabel = function getDirectionLabel(property) {
        if (swiper.isHorizontal()) {
          return property;
        } // prettier-ignore
  
  
        return {
          'width': 'height',
          'margin-top': 'margin-left',
          'margin-bottom ': 'margin-right',
          'margin-left': 'margin-top',
          'margin-right': 'margin-bottom',
          'padding-left': 'padding-top',
          'padding-right': 'padding-bottom',
          'marginRight': 'marginBottom'
        }[property];
      };
  
      var getDirectionPropertyValue = function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
      };
  
      var window = getWindow();
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl,
          swiperSize = swiper.size,
          rtl = swiper.rtlTranslate,
          wrongRTL = swiper.wrongRTL;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
      var slides = $wrapperEl.children("." + swiper.params.slideClass);
      var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
      var snapGrid = [];
      var slidesGrid = [];
      var slidesSizesGrid = [];
  
      function slidesForMargin(slideEl, slideIndex) {
        if (!params.cssMode) return true;
  
        if (slideIndex === slides.length - 1) {
          return false;
        }
  
        return true;
      }
  
      var offsetBefore = params.slidesOffsetBefore;
  
      if (typeof offsetBefore === 'function') {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }
  
      var offsetAfter = params.slidesOffsetAfter;
  
      if (typeof offsetAfter === 'function') {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }
  
      var previousSnapGridLength = swiper.snapGrid.length;
      var previousSlidesGridLength = swiper.slidesGrid.length;
      var spaceBetween = params.spaceBetween;
      var slidePosition = -offsetBefore;
      var prevSlideSize = 0;
      var index = 0;
  
      if (typeof swiperSize === 'undefined') {
        return;
      }
  
      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
      }
  
      swiper.virtualSize = -spaceBetween; // reset margins
  
      if (rtl) slides.css({
        marginLeft: '',
        marginTop: ''
      });else slides.css({
        marginRight: '',
        marginBottom: ''
      });
      var slidesNumberEvenToRows;
  
      if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
          slidesNumberEvenToRows = slidesLength;
        } else {
          slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        }
  
        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
          slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
        }
      } // Calc slides
  
  
      var slideSize;
      var slidesPerColumn = params.slidesPerColumn;
      var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
      var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
  
      for (var i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        var slide = slides.eq(i);
  
        if (params.slidesPerColumn > 1) {
          // Set slides order
          var newSlideOrderIndex = void 0;
          var column = void 0;
          var row = void 0;
  
          if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
            var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
            slide.css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex
            });
          } else if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - column * slidesPerColumn;
  
            if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
              row += 1;
  
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
          }
  
          slide.css(getDirectionLabel('margin-top'), row !== 0 && params.spaceBetween && params.spaceBetween + "px");
        }
  
        if (slide.css('display') === 'none') continue; // eslint-disable-line
  
        if (params.slidesPerView === 'auto') {
          var slideStyles = window.getComputedStyle(slide[0], null);
          var currentTransform = slide[0].style.transform;
          var currentWebKitTransform = slide[0].style.webkitTransform;
  
          if (currentTransform) {
            slide[0].style.transform = 'none';
          }
  
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = 'none';
          }
  
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
          } else {
            // eslint-disable-next-line
            var width = getDirectionPropertyValue(slideStyles, 'width');
            var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
            var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
            var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
            var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
            var boxSizing = slideStyles.getPropertyValue(slideStyles, 'box-sizing');
  
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              var _slide$ = slide[0],
                  clientWidth = _slide$.clientWidth,
                  offsetWidth = _slide$.offsetWidth;
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
            }
          }
  
          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }
  
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }
  
          if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
          slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
          if (params.roundLengths) slideSize = Math.floor(slideSize);
  
          if (slides[i]) {
            slides[i].style[getDirectionLabel('width')] = slideSize + "px";
          }
        }
  
        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }
  
        slidesSizesGrid.push(slideSize);
  
        if (params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }
  
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }
  
      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      var newSlidesGrid;
  
      if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        $wrapperEl.css({
          width: swiper.virtualSize + params.spaceBetween + "px"
        });
      }
  
      if (params.setWrapperSize) {
        var _$wrapperEl$css;
  
        $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
      }
  
      if (params.slidesPerColumn > 1) {
        var _$wrapperEl$css2;
  
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));
  
        if (params.centeredSlides) {
          newSlidesGrid = [];
  
          for (var _i = 0; _i < snapGrid.length; _i += 1) {
            var slidesGridItem = snapGrid[_i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
          }
  
          snapGrid = newSlidesGrid;
        }
      } // Remove last grid elements depending on width
  
  
      if (!params.centeredSlides) {
        newSlidesGrid = [];
  
        for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
          var _slidesGridItem = snapGrid[_i2];
          if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
  
          if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(_slidesGridItem);
          }
        }
  
        snapGrid = newSlidesGrid;
  
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
  
      if (snapGrid.length === 0) snapGrid = [0];
  
      if (params.spaceBetween !== 0) {
        var _slides$filter$css;
  
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter(slidesForMargin).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
      }
  
      if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function (slideSizeValue) {
          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function (snap) {
          if (snap < 0) return -offsetBefore;
          if (snap > maxSnap) return maxSnap + offsetAfter;
          return snap;
        });
      }
  
      if (params.centerInsufficientSlides) {
        var _allSlidesSize = 0;
        slidesSizesGrid.forEach(function (slideSizeValue) {
          _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        _allSlidesSize -= params.spaceBetween;
  
        if (_allSlidesSize < swiperSize) {
          var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
          snapGrid.forEach(function (snap, snapIndex) {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach(function (snap, snapIndex) {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }
  
      extend$1(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
      });
  
      if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
      }
  
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
      }
  
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
      }
  
      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesOffset();
      }
    }
  
    function updateAutoHeight(speed) {
      var swiper = this;
      var activeSlides = [];
      var newHeight = 0;
      var i;
  
      if (typeof speed === 'number') {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      } // Find slides currently in view
  
  
      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) {
          swiper.visibleSlides.each(function (slide) {
            activeSlides.push(slide);
          });
        } else {
          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length) break;
            activeSlides.push(swiper.slides.eq(index)[0]);
          }
        }
      } else {
        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
      } // Find new height from highest slide in view
  
  
      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
          var height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      } // Update Height
  
  
      if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
    }
  
    function updateSlidesOffset() {
      var swiper = this;
      var slides = swiper.slides;
  
      for (var i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
      }
    }
  
    function updateSlidesProgress(translate) {
      if (translate === void 0) {
        translate = this && this.translate || 0;
      }
  
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides,
          rtl = swiper.rtlTranslate;
      if (slides.length === 0) return;
      if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
      var offsetCenter = -translate;
      if (rtl) offsetCenter = translate; // Visible Slides
  
      slides.removeClass(params.slideVisibleClass);
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];
  
      for (var i = 0; i < slides.length; i += 1) {
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
  
        if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
          var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
          var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
          var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
  
          if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
          }
        }
  
        slide.progress = rtl ? -slideProgress : slideProgress;
      }
  
      swiper.visibleSlides = $(swiper.visibleSlides);
    }
  
    function updateProgress(translate) {
      var swiper = this;
  
      if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
  
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
      }
  
      var params = swiper.params;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      var progress = swiper.progress,
          isBeginning = swiper.isBeginning,
          isEnd = swiper.isEnd;
      var wasBeginning = isBeginning;
      var wasEnd = isEnd;
  
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }
  
      extend$1(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
      });
      if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  
      if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
      }
  
      if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
      }
  
      if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit('fromEdge');
      }
  
      swiper.emit('progress', progress);
    }
  
    function updateSlidesClasses() {
      var swiper = this;
      var slides = swiper.slides,
          params = swiper.params,
          $wrapperEl = swiper.$wrapperEl,
          activeIndex = swiper.activeIndex,
          realIndex = swiper.realIndex;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
      var activeSlide;
  
      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
      } else {
        activeSlide = slides.eq(activeIndex);
      } // Active classes
  
  
      activeSlide.addClass(params.slideActiveClass);
  
      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        }
      } // Next Slide
  
  
      var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
  
      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      } // Prev Slide
  
  
      var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
  
      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }
  
      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        }
  
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        }
      }
  
      swiper.emitSlidesClasses();
    }
  
    function updateActiveIndex(newActiveIndex) {
      var swiper = this;
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      var slidesGrid = swiper.slidesGrid,
          snapGrid = swiper.snapGrid,
          params = swiper.params,
          previousIndex = swiper.activeIndex,
          previousRealIndex = swiper.realIndex,
          previousSnapIndex = swiper.snapIndex;
      var activeIndex = newActiveIndex;
      var snapIndex;
  
      if (typeof activeIndex === 'undefined') {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
              activeIndex = i;
            } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        } // Normalize slideIndex
  
  
        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
      }
  
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
      }
  
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  
      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit('snapIndexChange');
        }
  
        return;
      } // Get real index
  
  
      var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
      extend$1(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
      });
      swiper.emit('activeIndexChange');
      swiper.emit('snapIndexChange');
  
      if (previousRealIndex !== realIndex) {
        swiper.emit('realIndexChange');
      }
  
      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        swiper.emit('slideChange');
      }
    }
  
    function updateClickedSlide(e) {
      var swiper = this;
      var params = swiper.params;
      var slide = $(e.target).closest("." + params.slideClass)[0];
      var slideFound = false;
      var slideIndex;
  
      if (slide) {
        for (var i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
          }
        }
      }
  
      if (slide && slideFound) {
        swiper.clickedSlide = slide;
  
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
        } else {
          swiper.clickedIndex = slideIndex;
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
  
      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
      }
    }
  
    var update = {
      updateSize: updateSize,
      updateSlides: updateSlides,
      updateAutoHeight: updateAutoHeight,
      updateSlidesOffset: updateSlidesOffset,
      updateSlidesProgress: updateSlidesProgress,
      updateProgress: updateProgress,
      updateSlidesClasses: updateSlidesClasses,
      updateActiveIndex: updateActiveIndex,
      updateClickedSlide: updateClickedSlide
    };
  
    function getSwiperTranslate(axis) {
      if (axis === void 0) {
        axis = this.isHorizontal() ? 'x' : 'y';
      }
  
      var swiper = this;
      var params = swiper.params,
          rtl = swiper.rtlTranslate,
          translate = swiper.translate,
          $wrapperEl = swiper.$wrapperEl;
  
      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
  
      if (params.cssMode) {
        return translate;
      }
  
      var currentTranslate = getTranslate($wrapperEl[0], axis);
      if (rtl) currentTranslate = -currentTranslate;
      return currentTranslate || 0;
    }
  
    function setTranslate(translate, byController) {
      var swiper = this;
      var rtl = swiper.rtlTranslate,
          params = swiper.params,
          $wrapperEl = swiper.$wrapperEl,
          wrapperEl = swiper.wrapperEl,
          progress = swiper.progress;
      var x = 0;
      var y = 0;
      var z = 0;
  
      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }
  
      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }
  
      if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
      } else if (!params.virtualTranslate) {
        $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
      }
  
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
  
      var newProgress;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
  
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }
  
      swiper.emit('setTranslate', swiper.translate, byController);
    }
  
    function minTranslate() {
      return -this.snapGrid[0];
    }
  
    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }
  
    function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
      if (translate === void 0) {
        translate = 0;
      }
  
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      if (translateBounds === void 0) {
        translateBounds = true;
      }
  
      var swiper = this;
      var params = swiper.params,
          wrapperEl = swiper.wrapperEl;
  
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
  
      var minTranslate = swiper.minTranslate();
      var maxTranslate = swiper.maxTranslate();
      var newTranslate;
      if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress
  
      swiper.updateProgress(newTranslate);
  
      if (params.cssMode) {
        var isH = swiper.isHorizontal();
  
        if (speed === 0) {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        } else {
          // eslint-disable-next-line
          if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
  
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
          } else {
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
          }
        }
  
        return true;
      }
  
      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
  
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionEnd');
        }
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
  
        if (runCallbacks) {
          swiper.emit('beforeTransitionStart', speed, internal);
          swiper.emit('transitionStart');
        }
  
        if (!swiper.animating) {
          swiper.animating = true;
  
          if (!swiper.onTranslateToWrapperTransitionEnd) {
            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
              swiper.onTranslateToWrapperTransitionEnd = null;
              delete swiper.onTranslateToWrapperTransitionEnd;
  
              if (runCallbacks) {
                swiper.emit('transitionEnd');
              }
            };
          }
  
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
      }
  
      return true;
    }
  
    var translate = {
      getTranslate: getSwiperTranslate,
      setTranslate: setTranslate,
      minTranslate: minTranslate,
      maxTranslate: maxTranslate,
      translateTo: translateTo
    };
  
    function setTransition(duration, byController) {
      var swiper = this;
  
      if (!swiper.params.cssMode) {
        swiper.$wrapperEl.transition(duration);
      }
  
      swiper.emit('setTransition', duration, byController);
    }
  
    function transitionStart(runCallbacks, direction) {
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      var activeIndex = swiper.activeIndex,
          params = swiper.params,
          previousIndex = swiper.previousIndex;
      if (params.cssMode) return;
  
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
  
      var dir = direction;
  
      if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
      }
  
      swiper.emit('transitionStart');
  
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionStart');
          return;
        }
  
        swiper.emit('slideChangeTransitionStart');
  
        if (dir === 'next') {
          swiper.emit('slideNextTransitionStart');
        } else {
          swiper.emit('slidePrevTransitionStart');
        }
      }
    }
  
    function transitionEnd$1(runCallbacks, direction) {
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      var activeIndex = swiper.activeIndex,
          previousIndex = swiper.previousIndex,
          params = swiper.params;
      swiper.animating = false;
      if (params.cssMode) return;
      swiper.setTransition(0);
      var dir = direction;
  
      if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
      }
  
      swiper.emit('transitionEnd');
  
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionEnd');
          return;
        }
  
        swiper.emit('slideChangeTransitionEnd');
  
        if (dir === 'next') {
          swiper.emit('slideNextTransitionEnd');
        } else {
          swiper.emit('slidePrevTransitionEnd');
        }
      }
    }
  
    var transition$1 = {
      setTransition: setTransition,
      transitionStart: transitionStart,
      transitionEnd: transitionEnd$1
    };
  
    function slideTo(index, speed, runCallbacks, internal) {
      if (index === void 0) {
        index = 0;
      }
  
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      if (typeof index !== 'number' && typeof index !== 'string') {
        throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
      }
  
      if (typeof index === 'string') {
        /**
         * The `index` argument converted from `string` to `number`.
         * @type {number}
         */
        var indexAsNumber = parseInt(index, 10);
        /**
         * Determines whether the `index` argument is a valid `number`
         * after being converted from the `string` type.
         * @type {boolean}
         */
  
        var isValidNumber = isFinite(indexAsNumber);
  
        if (!isValidNumber) {
          throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
        } // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
  
  
        index = indexAsNumber;
      }
  
      var swiper = this;
      var slideIndex = index;
      if (slideIndex < 0) slideIndex = 0;
      var params = swiper.params,
          snapGrid = swiper.snapGrid,
          slidesGrid = swiper.slidesGrid,
          previousIndex = swiper.previousIndex,
          activeIndex = swiper.activeIndex,
          rtl = swiper.rtlTranslate,
          wrapperEl = swiper.wrapperEl;
  
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
  
      var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
      var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  
      if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
      }
  
      var translate = -snapGrid[snapIndex]; // Update progress
  
      swiper.updateProgress(translate); // Normalize slideIndex
  
      if (params.normalizeSlideIndex) {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          var normalizedTranslate = -Math.floor(translate * 100);
          var normalizedGird = Math.floor(slidesGrid[i] * 100);
          var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
  
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
              slideIndex = i;
            } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
              slideIndex = i + 1;
            }
          } else if (normalizedTranslate >= normalizedGird) {
            slideIndex = i;
          }
        }
      } // Directions locks
  
  
      if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
          return false;
        }
  
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
          if ((activeIndex || 0) !== slideIndex) return false;
        }
      }
  
      var direction;
      if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index
  
      if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
  
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
  
        swiper.updateSlidesClasses();
  
        if (params.effect !== 'slide') {
          swiper.setTranslate(translate);
        }
  
        if (direction !== 'reset') {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
  
        return false;
      }
  
      if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = -translate;
  
        if (rtl) {
          t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        }
  
        if (speed === 0) {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        } else {
          // eslint-disable-next-line
          if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
  
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
          } else {
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
          }
        }
  
        return true;
      }
  
      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
  
        if (!swiper.animating) {
          swiper.animating = true;
  
          if (!swiper.onSlideToWrapperTransitionEnd) {
            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
              swiper.onSlideToWrapperTransitionEnd = null;
              delete swiper.onSlideToWrapperTransitionEnd;
              swiper.transitionEnd(runCallbacks, direction);
            };
          }
  
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        }
      }
  
      return true;
    }
  
    function slideToLoop(index, speed, runCallbacks, internal) {
      if (index === void 0) {
        index = 0;
      }
  
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      var newIndex = index;
  
      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }
  
      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    }
  
    /* eslint no-unused-vars: "off" */
    function slideNext(speed, runCallbacks, internal) {
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      var params = swiper.params,
          animating = swiper.animating;
      var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
  
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
  
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
  
      return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
    }
  
    /* eslint no-unused-vars: "off" */
    function slidePrev(speed, runCallbacks, internal) {
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      var params = swiper.params,
          animating = swiper.animating,
          snapGrid = swiper.snapGrid,
          slidesGrid = swiper.slidesGrid,
          rtlTranslate = swiper.rtlTranslate;
  
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
  
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
  
      var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  
      function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
      }
  
      var normalizedTranslate = normalize(translate);
      var normalizedSnapGrid = snapGrid.map(function (val) {
        return normalize(val);
      });
      snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
      var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  
      if (typeof prevSnap === 'undefined' && params.cssMode) {
        snapGrid.forEach(function (snap) {
          if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
        });
      }
  
      var prevIndex;
  
      if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
      }
  
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }
  
    /* eslint no-unused-vars: "off" */
    function slideReset(speed, runCallbacks, internal) {
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      var swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }
  
    /* eslint no-unused-vars: "off" */
    function slideToClosest(speed, runCallbacks, internal, threshold) {
      if (speed === void 0) {
        speed = this.params.speed;
      }
  
      if (runCallbacks === void 0) {
        runCallbacks = true;
      }
  
      if (threshold === void 0) {
        threshold = 0.5;
      }
  
      var swiper = this;
      var index = swiper.activeIndex;
      var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
      var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  
      if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
  
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
          index += swiper.params.slidesPerGroup;
        }
      } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var _currentSnap = swiper.snapGrid[snapIndex];
  
        if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
          index -= swiper.params.slidesPerGroup;
        }
      }
  
      index = Math.max(index, 0);
      index = Math.min(index, swiper.slidesGrid.length - 1);
      return swiper.slideTo(index, speed, runCallbacks, internal);
    }
  
    function slideToClickedSlide() {
      var swiper = this;
      var params = swiper.params,
          $wrapperEl = swiper.$wrapperEl;
      var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
      var slideToIndex = swiper.clickedIndex;
      var realIndex;
  
      if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
  
        if (params.centeredSlides) {
          if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
            nextTick(function () {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
          nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }
  
    var slide = {
      slideTo: slideTo,
      slideToLoop: slideToLoop,
      slideNext: slideNext,
      slidePrev: slidePrev,
      slideReset: slideReset,
      slideToClosest: slideToClosest,
      slideToClickedSlide: slideToClickedSlide
    };
  
    function loopCreate() {
      var swiper = this;
      var document = getDocument();
      var params = swiper.params,
          $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
  
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
      var slides = $wrapperEl.children("." + params.slideClass);
  
      if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
  
        if (blankSlidesNum !== params.slidesPerGroup) {
          for (var i = 0; i < blankSlidesNum; i += 1) {
            var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
            $wrapperEl.append(blankNode);
          }
  
          slides = $wrapperEl.children("." + params.slideClass);
        }
      }
  
      if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
      swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
      swiper.loopedSlides += params.loopAdditionalSlides;
  
      if (swiper.loopedSlides > slides.length) {
        swiper.loopedSlides = slides.length;
      }
  
      var prependSlides = [];
      var appendSlides = [];
      slides.each(function (el, index) {
        var slide = $(el);
  
        if (index < swiper.loopedSlides) {
          appendSlides.push(el);
        }
  
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
          prependSlides.push(el);
        }
  
        slide.attr('data-swiper-slide-index', index);
      });
  
      for (var _i = 0; _i < appendSlides.length; _i += 1) {
        $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
  
      for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
        $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
    }
  
    function loopFix() {
      var swiper = this;
      swiper.emit('beforeLoopFix');
      var activeIndex = swiper.activeIndex,
          slides = swiper.slides,
          loopedSlides = swiper.loopedSlides,
          allowSlidePrev = swiper.allowSlidePrev,
          allowSlideNext = swiper.allowSlideNext,
          snapGrid = swiper.snapGrid,
          rtl = swiper.rtlTranslate;
      var newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      var snapTranslate = -snapGrid[activeIndex];
      var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
  
      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
  
        if (slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
  
        var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
  
        if (_slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      }
  
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit('loopFix');
    }
  
    function loopDestroy() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl,
          params = swiper.params,
          slides = swiper.slides;
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
      slides.removeAttr('data-swiper-slide-index');
    }
  
    var loop = {
      loopCreate: loopCreate,
      loopFix: loopFix,
      loopDestroy: loopDestroy
    };
  
    function setGrabCursor(moving) {
      var swiper = this;
      if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
      var el = swiper.el;
      el.style.cursor = 'move';
      el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
      el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
      el.style.cursor = moving ? 'grabbing' : 'grab';
    }
  
    function unsetGrabCursor() {
      var swiper = this;
  
      if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
        return;
      }
  
      swiper.el.style.cursor = '';
    }
  
    var grabCursor = {
      setGrabCursor: setGrabCursor,
      unsetGrabCursor: unsetGrabCursor
    };
  
    function appendSlide(slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl,
          params = swiper.params;
  
      if (params.loop) {
        swiper.loopDestroy();
      }
  
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.append(slides[i]);
        }
      } else {
        $wrapperEl.append(slides);
      }
  
      if (params.loop) {
        swiper.loopCreate();
      }
  
      if (!(params.observer && swiper.support.observer)) {
        swiper.update();
      }
    }
  
    function prependSlide(slides) {
      var swiper = this;
      var params = swiper.params,
          $wrapperEl = swiper.$wrapperEl,
          activeIndex = swiper.activeIndex;
  
      if (params.loop) {
        swiper.loopDestroy();
      }
  
      var newActiveIndex = activeIndex + 1;
  
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.prepend(slides[i]);
        }
  
        newActiveIndex = activeIndex + slides.length;
      } else {
        $wrapperEl.prepend(slides);
      }
  
      if (params.loop) {
        swiper.loopCreate();
      }
  
      if (!(params.observer && swiper.support.observer)) {
        swiper.update();
      }
  
      swiper.slideTo(newActiveIndex, 0, false);
    }
  
    function addSlide(index, slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl,
          params = swiper.params,
          activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;
  
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }
  
      var baseLength = swiper.slides.length;
  
      if (index <= 0) {
        swiper.prependSlide(slides);
        return;
      }
  
      if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
      }
  
      var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
      var slidesBuffer = [];
  
      for (var i = baseLength - 1; i >= index; i -= 1) {
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
      }
  
      if (typeof slides === 'object' && 'length' in slides) {
        for (var _i = 0; _i < slides.length; _i += 1) {
          if (slides[_i]) $wrapperEl.append(slides[_i]);
        }
  
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
      } else {
        $wrapperEl.append(slides);
      }
  
      for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
        $wrapperEl.append(slidesBuffer[_i2]);
      }
  
      if (params.loop) {
        swiper.loopCreate();
      }
  
      if (!(params.observer && swiper.support.observer)) {
        swiper.update();
      }
  
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }
  
    function removeSlide(slidesIndexes) {
      var swiper = this;
      var params = swiper.params,
          $wrapperEl = swiper.$wrapperEl,
          activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;
  
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }
  
      var newActiveIndex = activeIndexBuffer;
      var indexToRemove;
  
      if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for (var i = 0; i < slidesIndexes.length; i += 1) {
          indexToRemove = slidesIndexes[i];
          if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
          if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
  
        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
      }
  
      if (params.loop) {
        swiper.loopCreate();
      }
  
      if (!(params.observer && swiper.support.observer)) {
        swiper.update();
      }
  
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }
  
    function removeAllSlides() {
      var swiper = this;
      var slidesIndexes = [];
  
      for (var i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
      }
  
      swiper.removeSlide(slidesIndexes);
    }
  
    var manipulation = {
      appendSlide: appendSlide,
      prependSlide: prependSlide,
      addSlide: addSlide,
      removeSlide: removeSlide,
      removeAllSlides: removeAllSlides
    };
  
    function onTouchStart(event) {
      var swiper = this;
      var document = getDocument();
      var window = getWindow();
      var data = swiper.touchEventsData;
      var params = swiper.params,
          touches = swiper.touches;
  
      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
  
      var e = event;
      if (e.originalEvent) e = e.originalEvent;
      var $targetEl = $(e.target);
  
      if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
      }
  
      data.isTouchEvent = e.type === 'touchstart';
      if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
      if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
      if (data.isTouched && data.isMoved) return; // change target el for shadow root componenet
  
      var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  
      if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
        $targetEl = $(event.path[0]);
      }
  
      if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
        swiper.allowClick = true;
        return;
      }
  
      if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
      }
  
      touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      var startX = touches.currentX;
      var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
  
      var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  
      if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
          event.preventDefault();
        } else {
          return;
        }
      }
  
      extend$1(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) data.allowThresholdMove = false;
  
      if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($targetEl.is(data.formElements)) preventDefault = false;
  
        if (document.activeElement && $(document.activeElement).is(data.formElements) && document.activeElement !== $targetEl[0]) {
          document.activeElement.blur();
        }
  
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
          e.preventDefault();
        }
      }
  
      swiper.emit('touchStart', e);
    }
  
    function onTouchMove(event) {
      var document = getDocument();
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params,
          touches = swiper.touches,
          rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) e = e.originalEvent;
  
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit('touchMoveOpposite', e);
        }
  
        return;
      }
  
      if (data.isTouchEvent && e.type !== 'touchmove') return;
      var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
      var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
      var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
  
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
  
      if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
  
        if (data.isTouched) {
          extend$1(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY
          });
          data.touchStartTime = now();
        }
  
        return;
      }
  
      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
          return;
        }
      }
  
      if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && $(e.target).is(data.formElements)) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
  
      if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
      }
  
      if (e.targetTouches && e.targetTouches.length > 1) return;
      touches.currentX = pageX;
      touches.currentY = pageY;
      var diffX = touches.currentX - touches.startX;
      var diffY = touches.currentY - touches.startY;
      if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
  
      if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
  
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
          }
        }
      }
  
      if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
  
      if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
          data.startMoving = true;
        }
      }
  
      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }
  
      if (!data.startMoving) {
        return;
      }
  
      swiper.allowClick = false;
  
      if (!params.cssMode && e.cancelable) {
        e.preventDefault();
      }
  
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }
  
      if (!data.isMoved) {
        if (params.loop) {
          swiper.loopFix();
        }
  
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
  
        if (swiper.animating) {
          swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        }
  
        data.allowMomentumBounce = false; // Grab Cursor
  
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
          swiper.setGrabCursor(true);
        }
  
        swiper.emit('sliderFirstMove', e);
      }
  
      swiper.emit('sliderMove', e);
      data.isMoved = true;
      var diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;
      diff *= params.touchRatio;
      if (rtl) diff = -diff;
      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
      data.currentTranslate = diff + data.startTranslate;
      var disableParentSwiper = true;
      var resistanceRatio = params.resistanceRatio;
  
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
  
      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
      }
  
      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      } // Directions locks
  
  
      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
  
      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
  
      if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
        data.currentTranslate = data.startTranslate;
      } // Threshold
  
  
      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }
  
      if (!params.followFinger || params.cssMode) return; // Update active index in free mode
  
      if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
  
      if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
          });
        }
  
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
          time: now()
        });
      } // Update progress
  
  
      swiper.updateProgress(data.currentTranslate); // Update translate
  
      swiper.setTranslate(data.currentTranslate);
    }
  
    function onTouchEnd(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params,
          touches = swiper.touches,
          rtl = swiper.rtlTranslate,
          $wrapperEl = swiper.$wrapperEl,
          slidesGrid = swiper.slidesGrid,
          snapGrid = swiper.snapGrid;
      var e = event;
      if (e.originalEvent) e = e.originalEvent;
  
      if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
      }
  
      data.allowTouchCallbacks = false;
  
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
  
        data.isMoved = false;
        data.startMoving = false;
        return;
      } // Return Grab Cursor
  
  
      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
      } // Time diff
  
  
      var touchEndTime = now();
      var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
  
      if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit('tap click', e);
  
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          swiper.emit('doubleTap doubleClick', e);
        }
      }
  
      data.lastClickTime = now();
      nextTick(function () {
        if (!swiper.destroyed) swiper.allowClick = true;
      });
  
      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
  
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      var currentPos;
  
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }
  
      if (params.cssMode) {
        return;
      }
  
      if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
  
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
  
          return;
        }
  
        if (params.freeModeMomentum) {
          if (data.velocities.length > 1) {
            var lastMoveEvent = data.velocities.pop();
            var velocityEvent = data.velocities.pop();
            var distance = lastMoveEvent.position - velocityEvent.position;
            var time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
  
            if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
              swiper.velocity = 0;
            } // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.
  
  
            if (time > 150 || now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
  
          swiper.velocity *= params.freeModeMomentumVelocityRatio;
          data.velocities.length = 0;
          var momentumDuration = 1000 * params.freeModeMomentumRatio;
          var momentumDistance = swiper.velocity * momentumDuration;
          var newPosition = swiper.translate + momentumDistance;
          if (rtl) newPosition = -newPosition;
          var doBounce = false;
          var afterBouncePosition;
          var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
          var needsLoopFix;
  
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
  
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
  
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
  
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
  
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (params.freeModeSticky) {
            var nextSlide;
  
            for (var j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }
  
            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
  
            newPosition = -newPosition;
          }
  
          if (needsLoopFix) {
            swiper.once('transitionEnd', function () {
              swiper.loopFix();
            });
          } // Fix duration
  
  
          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            }
  
            if (params.freeModeSticky) {
              // If freeModeSticky is active and the user ends a swipe with a slow-velocity
              // event, then durations can be 20+ seconds to slide one (or zero!) slides.
              // It's easy to see this when simulating touch with mouse events. To fix this,
              // limit single-slide swipes to the default slide duration. This also has the
              // nice side effect of matching slide speed if the user stopped moving before
              // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
              // For faster swipes, also apply limits (albeit higher ones).
              var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
              var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
  
              if (moveDistance < currentSlideSize) {
                momentumDuration = params.speed;
              } else if (moveDistance < 2 * currentSlideSize) {
                momentumDuration = params.speed * 1.5;
              } else {
                momentumDuration = params.speed * 2.5;
              }
            }
          } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
          }
  
          if (params.freeModeMomentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
              swiper.emit('momentumBounce');
              swiper.setTransition(params.speed);
              setTimeout(function () {
                swiper.setTranslate(afterBouncePosition);
                $wrapperEl.transitionEnd(function () {
                  if (!swiper || swiper.destroyed) return;
                  swiper.transitionEnd();
                });
              }, 0);
            });
          } else if (swiper.velocity) {
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
  
            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.emit('_freeModeNoMomentumRelease');
            swiper.updateProgress(newPosition);
          }
  
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        } else if (params.freeMode) {
          swiper.emit('_freeModeNoMomentumRelease');
        }
  
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
  
        return;
      } // Find current slide
  
  
      var stopIndex = 0;
      var groupSize = swiper.slidesSizesGrid[0];
  
      for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
        var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  
        if (typeof slidesGrid[i + _increment] !== 'undefined') {
          if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
            stopIndex = i;
            groupSize = slidesGrid[i + _increment] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
      } // Find current slide size
  
  
      var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  
      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
  
        if (swiper.swipeDirection === 'next') {
          if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
        }
  
        if (swiper.swipeDirection === 'prev') {
          if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
  
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
  
        if (!isNavButtonTarget) {
          if (swiper.swipeDirection === 'next') {
            swiper.slideTo(stopIndex + increment);
          }
  
          if (swiper.swipeDirection === 'prev') {
            swiper.slideTo(stopIndex);
          }
        } else if (e.target === swiper.navigation.nextEl) {
          swiper.slideTo(stopIndex + increment);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    }
  
    function onResize() {
      var swiper = this;
      var params = swiper.params,
          el = swiper.el;
      if (el && el.offsetWidth === 0) return; // Breakpoints
  
      if (params.breakpoints) {
        swiper.setBreakpoint();
      } // Save locks
  
  
      var allowSlideNext = swiper.allowSlideNext,
          allowSlidePrev = swiper.allowSlidePrev,
          snapGrid = swiper.snapGrid; // Disable locks on resize
  
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
  
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
  
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.run();
      } // Return locks after resize
  
  
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
  
      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }
  
    function onClick(e) {
      var swiper = this;
  
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
  
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }
  
    function onScroll() {
      var swiper = this;
      var wrapperEl = swiper.wrapperEl,
          rtlTranslate = swiper.rtlTranslate;
      swiper.previousTranslate = swiper.translate;
  
      if (swiper.isHorizontal()) {
        if (rtlTranslate) {
          swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
        } else {
          swiper.translate = -wrapperEl.scrollLeft;
        }
      } else {
        swiper.translate = -wrapperEl.scrollTop;
      } // eslint-disable-next-line
  
  
      if (swiper.translate === -0) swiper.translate = 0;
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      var newProgress;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
      }
  
      if (newProgress !== swiper.progress) {
        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
      }
  
      swiper.emit('setTranslate', swiper.translate, false);
    }
  
    var dummyEventAttached = false;
  
    function dummyEventListener() {}
  
    function attachEvents() {
      var swiper = this;
      var document = getDocument();
      var params = swiper.params,
          touchEvents = swiper.touchEvents,
          el = swiper.el,
          wrapperEl = swiper.wrapperEl,
          device = swiper.device,
          support = swiper.support;
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
  
      if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
      }
  
      swiper.onClick = onClick.bind(swiper);
      var capture = !!params.nested; // Touch Events
  
      if (!support.touch && support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
          } : false;
          el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
          } : capture);
          el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
  
          if (touchEvents.cancel) {
            el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
          }
  
          if (!dummyEventAttached) {
            document.addEventListener('touchstart', dummyEventListener);
            dummyEventAttached = true;
          }
        }
  
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
          el.addEventListener('mousedown', swiper.onTouchStart, false);
          document.addEventListener('mousemove', swiper.onTouchMove, capture);
          document.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      } // Prevent Links Clicks
  
  
      if (params.preventClicks || params.preventClicksPropagation) {
        el.addEventListener('click', swiper.onClick, true);
      }
  
      if (params.cssMode) {
        wrapperEl.addEventListener('scroll', swiper.onScroll);
      } // Resize handler
  
  
      if (params.updateOnWindowResize) {
        swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
      } else {
        swiper.on('observerUpdate', onResize, true);
      }
    }
  
    function detachEvents() {
      var swiper = this;
      var document = getDocument();
      var params = swiper.params,
          touchEvents = swiper.touchEvents,
          el = swiper.el,
          wrapperEl = swiper.wrapperEl,
          device = swiper.device,
          support = swiper.support;
      var capture = !!params.nested; // Touch Events
  
      if (!support.touch && support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
          } : false;
          el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
  
          if (touchEvents.cancel) {
            el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
          }
        }
  
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
          el.removeEventListener('mousedown', swiper.onTouchStart, false);
          document.removeEventListener('mousemove', swiper.onTouchMove, capture);
          document.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      } // Prevent Links Clicks
  
  
      if (params.preventClicks || params.preventClicksPropagation) {
        el.removeEventListener('click', swiper.onClick, true);
      }
  
      if (params.cssMode) {
        wrapperEl.removeEventListener('scroll', swiper.onScroll);
      } // Resize handler
  
  
      swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
    }
  
    var events = {
      attachEvents: attachEvents,
      detachEvents: detachEvents
    };
  
    function setBreakpoint() {
      var swiper = this;
      var activeIndex = swiper.activeIndex,
          initialized = swiper.initialized,
          _swiper$loopedSlides = swiper.loopedSlides,
          loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
          params = swiper.params,
          $el = swiper.$el;
      var breakpoints = params.breakpoints;
      if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
  
      var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  
      if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  
        if (breakpointOnlyParams) {
          ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
            var paramValue = breakpointOnlyParams[param];
            if (typeof paramValue === 'undefined') return;
  
            if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
              breakpointOnlyParams[param] = 'auto';
            } else if (param === 'slidesPerView') {
              breakpointOnlyParams[param] = parseFloat(paramValue);
            } else {
              breakpointOnlyParams[param] = parseInt(paramValue, 10);
            }
          });
        }
  
        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
        var wasMultiRow = params.slidesPerColumn > 1;
        var isMultiRow = breakpointParams.slidesPerColumn > 1;
  
        if (wasMultiRow && !isMultiRow) {
          $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
          swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
          $el.addClass(params.containerModifierClass + "multirow");
  
          if (breakpointParams.slidesPerColumnFill === 'column') {
            $el.addClass(params.containerModifierClass + "multirow-column");
          }
  
          swiper.emitContainerClasses();
        }
  
        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  
        if (directionChanged && initialized) {
          swiper.changeDirection();
        }
  
        extend$1(swiper.params, breakpointParams);
        extend$1(swiper, {
          allowTouchMove: swiper.params.allowTouchMove,
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev
        });
        swiper.currentBreakpoint = breakpoint;
        swiper.emit('_beforeBreakpoint', breakpointParams);
  
        if (needsReLoop && initialized) {
          swiper.loopDestroy();
          swiper.loopCreate();
          swiper.updateSlides();
          swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
        }
  
        swiper.emit('breakpoint', breakpointParams);
      }
    }
  
    function getBreakpoint(breakpoints, base, containerEl) {
      if (base === void 0) {
        base = 'window';
      }
  
      if (!breakpoints || base === 'container' && !containerEl) return undefined;
      var breakpoint = false;
      var window = getWindow();
      var currentWidth = base === 'window' ? window.innerWidth : containerEl.clientWidth;
      var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
      var points = Object.keys(breakpoints).map(function (point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
          var minRatio = parseFloat(point.substr(1));
          var value = currentHeight * minRatio;
          return {
            value: value,
            point: point
          };
        }
  
        return {
          value: point,
          point: point
        };
      });
      points.sort(function (a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
      });
  
      for (var i = 0; i < points.length; i += 1) {
        var _points$i = points[i],
            point = _points$i.point,
            value = _points$i.value;
  
        if (value <= currentWidth) {
          breakpoint = point;
        }
      }
  
      return breakpoint || 'max';
    }
  
    var breakpoints = {
      setBreakpoint: setBreakpoint,
      getBreakpoint: getBreakpoint
    };
  
    function prepareClasses(entries, prefix) {
      var resultClasses = [];
      entries.forEach(function (item) {
        if (typeof item === 'object') {
          Object.entries(item).forEach(function (_ref) {
            var classNames = _ref[0],
                condition = _ref[1];
  
            if (condition) {
              resultClasses.push(prefix + classNames);
            }
          });
        } else if (typeof item === 'string') {
          resultClasses.push(prefix + item);
        }
      });
      return resultClasses;
    }
  
    function addClasses() {
      var swiper = this;
      var classNames = swiper.classNames,
          params = swiper.params,
          rtl = swiper.rtl,
          $el = swiper.$el,
          device = swiper.device,
          support = swiper.support; // prettier-ignore
  
      var suffixes = prepareClasses(['initialized', params.direction, {
        'pointer-events': support.pointerEvents && !support.touch
      }, {
        'free-mode': params.freeMode
      }, {
        'autoheight': params.autoHeight
      }, {
        'rtl': rtl
      }, {
        'multirow': params.slidesPerColumn > 1
      }, {
        'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
      }, {
        'android': device.android
      }, {
        'ios': device.ios
      }, {
        'css-mode': params.cssMode
      }], params.containerModifierClass);
      classNames.push.apply(classNames, suffixes);
      $el.addClass([].concat(classNames).join(' '));
      swiper.emitContainerClasses();
    }
  
    function removeClasses() {
      var swiper = this;
      var $el = swiper.$el,
          classNames = swiper.classNames;
      $el.removeClass(classNames.join(' '));
      swiper.emitContainerClasses();
    }
  
    var classes = {
      addClasses: addClasses,
      removeClasses: removeClasses
    };
  
    function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
      var window = getWindow();
      var image;
  
      function onReady() {
        if (callback) callback();
      }
  
      var isPicture = $(imageEl).parent('picture')[0];
  
      if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
          image = new window.Image();
          image.onload = onReady;
          image.onerror = onReady;
  
          if (sizes) {
            image.sizes = sizes;
          }
  
          if (srcset) {
            image.srcset = srcset;
          }
  
          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        // image already loaded...
        onReady();
      }
    }
  
    function preloadImages() {
      var swiper = this;
      swiper.imagesToLoad = swiper.$el.find('img');
  
      function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
  
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) swiper.update();
          swiper.emit('imagesReady');
        }
      }
  
      for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
      }
    }
  
    var images = {
      loadImage: loadImage,
      preloadImages: preloadImages
    };
  
    function checkOverflow() {
      var swiper = this;
      var params = swiper.params;
      var wasLocked = swiper.isLocked;
      var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
  
      if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
        swiper.isLocked = lastSlidePosition <= swiper.size;
      } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
      }
  
      swiper.allowSlideNext = !swiper.isLocked;
      swiper.allowSlidePrev = !swiper.isLocked; // events
  
      if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  
      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
      }
    }
  
    var checkOverflow$1 = {
      checkOverflow: checkOverflow
    };
  
    var defaults = {
      init: true,
      direction: 'horizontal',
      touchEventsTarget: 'container',
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      resizeObserver: false,
      nested: false,
      // Overrides
      width: null,
      height: null,
      //
      preventInteractionOnTransition: false,
      // ssr
      userAgent: null,
      url: null,
      // To support iOS's swipe-to-go-back gesture (when being used in-app).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      // Free mode
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: false,
      freeModeMinimumVelocity: 0.02,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: 'slide',
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
      // Breakpoints
      breakpoints: undefined,
      breakpointsBase: 'window',
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: 'column',
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      // Disable swiper and hide navigation when container not overflow
      watchOverflow: false,
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Progress
      watchSlidesProgress: false,
      watchSlidesVisibility: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // Images
      preloadImages: true,
      updateOnImagesReady: true,
      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: false,
      loopPreventsSlide: true,
      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: null,
      // Passive Listeners
      passiveListeners: true,
      // NS
      containerModifierClass: 'swiper-container-',
      // NEW
      slideClass: 'swiper-slide',
      slideBlankClass: 'swiper-slide-invisible-blank',
      slideActiveClass: 'swiper-slide-active',
      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideDuplicateClass: 'swiper-slide-duplicate',
      slideNextClass: 'swiper-slide-next',
      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
      slidePrevClass: 'swiper-slide-prev',
      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
      wrapperClass: 'swiper-wrapper',
      // Callbacks
      runCallbacksOnInit: true,
      // Internals
      _emitClasses: false
    };
  
    var prototypes = {
      modular: modular,
      eventsEmitter: eventsEmitter,
      update: update,
      translate: translate,
      transition: transition$1,
      slide: slide,
      loop: loop,
      grabCursor: grabCursor,
      manipulation: manipulation,
      events: events,
      breakpoints: breakpoints,
      checkOverflow: checkOverflow$1,
      classes: classes,
      images: images
    };
    var extendedDefaults = {};
  
    var Swiper = /*#__PURE__*/function () {
      function Swiper() {
        var el;
        var params;
  
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
  
        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
          params = args[0];
        } else {
          el = args[0];
          params = args[1];
        }
  
        if (!params) params = {};
        params = extend$1({}, params);
        if (el && !params.el) params.el = el;
  
        if (params.el && $(params.el).length > 1) {
          var swipers = [];
          $(params.el).each(function (containerEl) {
            var newParams = extend$1({}, params, {
              el: containerEl
            });
            swipers.push(new Swiper(newParams));
          });
          return swipers;
        } // Swiper Instance
  
  
        var swiper = this;
        swiper.support = getSupport();
        swiper.device = getDevice({
          userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
  
        if (typeof swiper.modules === 'undefined') {
          swiper.modules = {};
        }
  
        Object.keys(swiper.modules).forEach(function (moduleName) {
          var module = swiper.modules[moduleName];
  
          if (module.params) {
            var moduleParamName = Object.keys(module.params)[0];
            var moduleParams = module.params[moduleParamName];
            if (typeof moduleParams !== 'object' || moduleParams === null) return;
            if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
  
            if (params[moduleParamName] === true) {
              params[moduleParamName] = {
                enabled: true
              };
            }
  
            if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
              params[moduleParamName].enabled = true;
            }
  
            if (!params[moduleParamName]) params[moduleParamName] = {
              enabled: false
            };
          }
        }); // Extend defaults with modules params
  
        var swiperParams = extend$1({}, defaults);
        swiper.useParams(swiperParams); // Extend defaults with passed params
  
        swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = extend$1({}, swiper.params);
        swiper.passedParams = extend$1({}, params); // add event listeners
  
        if (swiper.params && swiper.params.on) {
          Object.keys(swiper.params.on).forEach(function (eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
          });
        }
  
        if (swiper.params && swiper.params.onAny) {
          swiper.onAny(swiper.params.onAny);
        } // Save Dom lib
  
  
        swiper.$ = $; // Extend Swiper
  
        extend$1(swiper, {
          el: el,
          // Classes
          classNames: [],
          // Slides
          slides: $(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          // isDirection
          isHorizontal: function isHorizontal() {
            return swiper.params.direction === 'horizontal';
          },
          isVertical: function isVertical() {
            return swiper.params.direction === 'vertical';
          },
          // Indexes
          activeIndex: 0,
          realIndex: 0,
          //
          isBeginning: true,
          isEnd: false,
          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          // Touch Events
          touchEvents: function touchEvents() {
            var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
            var desktop = ['mousedown', 'mousemove', 'mouseup'];
  
            if (swiper.support.pointerEvents) {
              desktop = ['pointerdown', 'pointermove', 'pointerup'];
            }
  
            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2],
              cancel: touch[3]
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2]
            };
            return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
          }(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            formElements: 'input, select, option, textarea, button, video, label',
            // Last click time
            lastClickTime: now(),
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined
          },
          // Clicks
          allowClick: true,
          // Touches
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          // Images
          imagesToLoad: [],
          imagesLoaded: 0
        }); // Install Modules
  
        swiper.useModules();
        swiper.emit('_swiper'); // Init
  
        if (swiper.params.init) {
          swiper.init();
        } // Return app instance
  
  
        return swiper;
      }
  
      var _proto = Swiper.prototype;
  
      _proto.emitContainerClasses = function emitContainerClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var classes = swiper.el.className.split(' ').filter(function (className) {
          return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', classes.join(' '));
      };
  
      _proto.getSlideClasses = function getSlideClasses(slideEl) {
        var swiper = this;
        return slideEl.className.split(' ').filter(function (className) {
          return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
      };
  
      _proto.emitSlidesClasses = function emitSlidesClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var updates = [];
        swiper.slides.each(function (slideEl) {
          var classNames = swiper.getSlideClasses(slideEl);
          updates.push({
            slideEl: slideEl,
            classNames: classNames
          });
          swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
      };
  
      _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params,
            slides = swiper.slides,
            slidesGrid = swiper.slidesGrid,
            swiperSize = swiper.size,
            activeIndex = swiper.activeIndex;
        var spv = 1;
  
        if (params.centeredSlides) {
          var slideSize = slides[activeIndex].swiperSlideSize;
          var breakLoop;
  
          for (var i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
  
          for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
            if (slides[_i] && !breakLoop) {
              slideSize += slides[_i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
            if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
              spv += 1;
            }
          }
        }
  
        return spv;
      };
  
      _proto.update = function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var snapGrid = swiper.snapGrid,
            params = swiper.params; // Breakpoints
  
        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
  
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
  
        function setTranslate() {
          var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
  
        var translated;
  
        if (swiper.params.freeMode) {
          setTranslate();
  
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
  
          if (!translated) {
            setTranslate();
          }
        }
  
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
  
        swiper.emit('update');
      };
  
      _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) {
          needUpdate = true;
        }
  
        var swiper = this;
        var currentDirection = swiper.params.direction;
  
        if (!newDirection) {
          // eslint-disable-next-line
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }
  
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }
  
        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each(function (slideEl) {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
      };
  
      _proto.mount = function mount(el) {
        var swiper = this;
        if (swiper.mounted) return true; // Find el
  
        var $el = $(el || swiper.params.el);
        el = $el[0];
  
        if (!el) {
          return false;
        }
  
        el.swiper = swiper; // Find Wrapper
  
        var $wrapperEl;
  
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          $wrapperEl = $(el.shadowRoot.querySelector("." + swiper.params.wrapperClass)); // Children needs to return slot items
  
          $wrapperEl.children = function (options) {
            return $el.children(options);
          };
        } else {
          $wrapperEl = $el.children("." + swiper.params.wrapperClass);
        }
  
        extend$1(swiper, {
          $el: $el,
          el: el,
          $wrapperEl: $wrapperEl,
          wrapperEl: $wrapperEl[0],
          mounted: true,
          // RTL
          rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
          wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
      };
  
      _proto.init = function init(el) {
        var swiper = this;
        if (swiper.initialized) return swiper;
        var mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
  
        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        } // Add Classes
  
  
        swiper.addClasses(); // Create loop
  
        if (swiper.params.loop) {
          swiper.loopCreate();
        } // Update size
  
  
        swiper.updateSize(); // Update slides
  
        swiper.updateSlides();
  
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        } // Set Grab Cursor
  
  
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }
  
        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        } // Slide To Initial Slide
  
  
        if (swiper.params.loop) {
          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
        } // Attach events
  
  
        swiper.attachEvents(); // Init Flag
  
        swiper.initialized = true; // Emit
  
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
      };
  
      _proto.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) {
          deleteInstance = true;
        }
  
        if (cleanStyles === void 0) {
          cleanStyles = true;
        }
  
        var swiper = this;
        var params = swiper.params,
            $el = swiper.$el,
            $wrapperEl = swiper.$wrapperEl,
            slides = swiper.slides;
  
        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }
  
        swiper.emit('beforeDestroy'); // Init Flag
  
        swiper.initialized = false; // Detach events
  
        swiper.detachEvents(); // Destroy loop
  
        if (params.loop) {
          swiper.loopDestroy();
        } // Cleanup styles
  
  
        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr('style');
          $wrapperEl.removeAttr('style');
  
          if (slides && slides.length) {
            slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
          }
        }
  
        swiper.emit('destroy'); // Detach emitter events
  
        Object.keys(swiper.eventsListeners).forEach(function (eventName) {
          swiper.off(eventName);
        });
  
        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          deleteProps(swiper);
        }
  
        swiper.destroyed = true;
        return null;
      };
  
      Swiper.extendDefaults = function extendDefaults(newDefaults) {
        extend$1(extendedDefaults, newDefaults);
      };
  
      Swiper.installModule = function installModule(module) {
        if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
        var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
        Swiper.prototype.modules[name] = module;
      };
  
      Swiper.use = function use(module) {
        if (Array.isArray(module)) {
          module.forEach(function (m) {
            return Swiper.installModule(m);
          });
          return Swiper;
        }
  
        Swiper.installModule(module);
        return Swiper;
      };
  
      _createClass(Swiper, null, [{
        key: "extendedDefaults",
        get: function get() {
          return extendedDefaults;
        }
      }, {
        key: "defaults",
        get: function get() {
          return defaults;
        }
      }]);
  
      return Swiper;
    }();
  
    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
      });
    });
    Swiper.use([Resize, Observer$1]);
  
    var Virtual = {
      update: function update(force) {
        var swiper = this;
        var _swiper$params = swiper.params,
            slidesPerView = _swiper$params.slidesPerView,
            slidesPerGroup = _swiper$params.slidesPerGroup,
            centeredSlides = _swiper$params.centeredSlides;
        var _swiper$params$virtua = swiper.params.virtual,
            addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
            addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
        var _swiper$virtual = swiper.virtual,
            previousFrom = _swiper$virtual.from,
            previousTo = _swiper$virtual.to,
            slides = _swiper$virtual.slides,
            previousSlidesGrid = _swiper$virtual.slidesGrid,
            renderSlide = _swiper$virtual.renderSlide,
            previousOffset = _swiper$virtual.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesAfter;
        var slidesBefore;
  
        if (centeredSlides) {
          slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
          slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
          slidesBefore = slidesPerGroup + addSlidesBefore;
        }
  
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        extend$1(swiper.virtual, {
          from: from,
          to: to,
          offset: offset,
          slidesGrid: swiper.slidesGrid
        });
  
        function onRendered() {
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
  
          if (swiper.lazy && swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        }
  
        if (previousFrom === from && previousTo === to && !force) {
          if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
            swiper.slides.css(offsetProp, offset + "px");
          }
  
          swiper.updateProgress();
          return;
        }
  
        if (swiper.params.virtual.renderExternal) {
          swiper.params.virtual.renderExternal.call(swiper, {
            offset: offset,
            from: from,
            to: to,
            slides: function getSlides() {
              var slidesToRender = [];
  
              for (var i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
              }
  
              return slidesToRender;
            }()
          });
  
          if (swiper.params.virtual.renderExternalUpdate) {
            onRendered();
          }
  
          return;
        }
  
        var prependIndexes = [];
        var appendIndexes = [];
  
        if (force) {
          swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
        } else {
          for (var i = previousFrom; i <= previousTo; i += 1) {
            if (i < from || i > to) {
              swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
            }
          }
        }
  
        for (var _i = 0; _i < slides.length; _i += 1) {
          if (_i >= from && _i <= to) {
            if (typeof previousTo === 'undefined' || force) {
              appendIndexes.push(_i);
            } else {
              if (_i > previousTo) appendIndexes.push(_i);
              if (_i < previousFrom) prependIndexes.push(_i);
            }
          }
        }
  
        appendIndexes.forEach(function (index) {
          swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function (a, b) {
          return b - a;
        }).forEach(function (index) {
          swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
        onRendered();
      },
      renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
  
        if (params.cache && swiper.virtual.cache[index]) {
          return swiper.virtual.cache[index];
        }
  
        var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
      },
      appendSlide: function appendSlide(slides) {
        var swiper = this;
  
        if (typeof slides === 'object' && 'length' in slides) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.push(slides[i]);
          }
        } else {
          swiper.virtual.slides.push(slides);
        }
  
        swiper.virtual.update(true);
      },
      prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
  
        if (Array.isArray(slides)) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
          }
  
          newActiveIndex = activeIndex + slides.length;
          numberOfNewSlides = slides.length;
        } else {
          swiper.virtual.slides.unshift(slides);
        }
  
        if (swiper.params.virtual.cache) {
          var cache = swiper.virtual.cache;
          var newCache = {};
          Object.keys(cache).forEach(function (cachedIndex) {
            var $cachedEl = cache[cachedIndex];
            var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
  
            if (cachedElIndex) {
              $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
            }
  
            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
          });
          swiper.virtual.cache = newCache;
        }
  
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
      },
      removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
  
        if (Array.isArray(slidesIndexes)) {
          for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
  
            if (swiper.params.virtual.cache) {
              delete swiper.virtual.cache[slidesIndexes[i]];
            }
  
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
          }
        } else {
          swiper.virtual.slides.splice(slidesIndexes, 1);
  
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes];
          }
  
          if (slidesIndexes < activeIndex) activeIndex -= 1;
          activeIndex = Math.max(activeIndex, 0);
        }
  
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
      },
      removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];
  
        if (swiper.params.virtual.cache) {
          swiper.virtual.cache = {};
        }
  
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
      }
    };
    var Virtual$1 = {
      name: 'virtual',
      params: {
        virtual: {
          enabled: false,
          slides: [],
          cache: true,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: true,
          addSlidesBefore: 0,
          addSlidesAfter: 0
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          virtual: _extends({}, Virtual, {
            slides: swiper.params.virtual.slides,
            cache: {}
          })
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (!swiper.params.virtual.enabled) return;
          swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
          var overwriteParams = {
            watchSlidesProgress: true
          };
          extend$1(swiper.params, overwriteParams);
          extend$1(swiper.originalParams, overwriteParams);
  
          if (!swiper.params.initialSlide) {
            swiper.virtual.update();
          }
        },
        setTranslate: function setTranslate(swiper) {
          if (!swiper.params.virtual.enabled) return;
          swiper.virtual.update();
        }
      }
    };
  
    var Keyboard = {
      handle: function handle(event) {
        var swiper = this;
        var window = getWindow();
        var document = getDocument();
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
  
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40; // Directions locks
  
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
          return false;
        }
  
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
          return false;
        }
  
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
          return undefined;
        }
  
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
          return undefined;
        }
  
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
          var inView = false; // Check that swiper should be inside of visible area of window
  
          if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
            return undefined;
          }
  
          var windowWidth = window.innerWidth;
          var windowHeight = window.innerHeight;
          var swiperOffset = swiper.$el.offset();
          if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
          var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
  
          for (var i = 0; i < swiperCoord.length; i += 1) {
            var point = swiperCoord[i];
  
            if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
              if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
  
              inView = true;
            }
          }
  
          if (!inView) return undefined;
        }
  
        if (swiper.isHorizontal()) {
          if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
            if (e.preventDefault) e.preventDefault();else e.returnValue = false;
          }
  
          if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
          if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
          if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
            if (e.preventDefault) e.preventDefault();else e.returnValue = false;
          }
  
          if (isPageDown || isArrowDown) swiper.slideNext();
          if (isPageUp || isArrowUp) swiper.slidePrev();
        }
  
        swiper.emit('keyPress', kc);
        return undefined;
      },
      enable: function enable() {
        var swiper = this;
        var document = getDocument();
        if (swiper.keyboard.enabled) return;
        $(document).on('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
      },
      disable: function disable() {
        var swiper = this;
        var document = getDocument();
        if (!swiper.keyboard.enabled) return;
        $(document).off('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
      }
    };
    var Keyboard$1 = {
      name: 'keyboard',
      params: {
        keyboard: {
          enabled: false,
          onlyInViewport: true,
          pageUpDown: true
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          keyboard: _extends({
            enabled: false
          }, Keyboard)
        });
      },
      on: {
        init: function init(swiper) {
          if (swiper.params.keyboard.enabled) {
            swiper.keyboard.enable();
          }
        },
        destroy: function destroy(swiper) {
          if (swiper.keyboard.enabled) {
            swiper.keyboard.disable();
          }
        }
      }
    };
  
    function isEventSupported() {
      var document = getDocument();
      var eventName = 'onwheel';
      var isSupported = (eventName in document);
  
      if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
      }
  
      if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      document.implementation.hasFeature('', '') !== true) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
      }
  
      return isSupported;
    }
  
    var Mousewheel = {
      lastScrollTime: now(),
      lastEventBeforeSnap: undefined,
      recentWheelEvents: [],
      event: function event() {
        var window = getWindow();
        if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
        return isEventSupported() ? 'wheel' : 'mousewheel';
      },
      normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
  
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
  
        if ('detail' in e) {
          sY = e.detail;
        }
  
        if ('wheelDelta' in e) {
          sY = -e.wheelDelta / 120;
        }
  
        if ('wheelDeltaY' in e) {
          sY = -e.wheelDeltaY / 120;
        }
  
        if ('wheelDeltaX' in e) {
          sX = -e.wheelDeltaX / 120;
        } // side scrolling on FF with DOMMouseScroll
  
  
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }
  
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
  
        if ('deltaY' in e) {
          pY = e.deltaY;
        }
  
        if ('deltaX' in e) {
          pX = e.deltaX;
        }
  
        if (e.shiftKey && !pX) {
          // if user scrolls with shift he wants horizontal scroll
          pX = pY;
          pY = 0;
        }
  
        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            // delta in LINE units
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            // delta in PAGE units
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        } // Fall-back if spin cannot be determined
  
  
        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }
  
        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }
  
        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY
        };
      },
      handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        swiper.mouseEntered = true;
      },
      handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        swiper.mouseEntered = false;
      },
      handle: function handle(event) {
        var e = event;
        var disableParentSwiper = true;
        var swiper = this;
        var params = swiper.params.mousewheel;
  
        if (swiper.params.cssMode) {
          e.preventDefault();
        }
  
        var target = swiper.$el;
  
        if (swiper.params.mousewheel.eventsTarget !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
  
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
  
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = Mousewheel.normalize(e);
  
        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
        } else {
          delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        }
  
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
  
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
  
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
  
        if (!swiper.params.freeMode) {
          // Register the new event in a variable which stores the relevant data
          var newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
            raw: event
          }; // Keep the most recent events
  
          var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
  
          if (recentWheelEvents.length >= 2) {
            recentWheelEvents.shift(); // only store the last N events
          }
  
          var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
          //   If direction has changed or
          //   if the scroll is quicker than the previous one:
          //     Animate the slider.
          // Else (this is the first time the wheel is moved):
          //     Animate the slider.
  
          if (prevEvent) {
            if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
              swiper.mousewheel.animateSlider(newEvent);
            }
          } else {
            swiper.mousewheel.animateSlider(newEvent);
          } // If it's time to release the scroll:
          //   Return now so you don't hit the preventDefault.
  
  
          if (swiper.mousewheel.releaseScroll(newEvent)) {
            return true;
          }
        } else {
          // Freemode or scrollContainer:
          // If we recently snapped after a momentum scroll, then ignore wheel events
          // to give time for the deceleration to finish. Stop ignoring after 500 msecs
          // or if it's a new scroll (larger delta or inverse sign as last event before
          // an end-of-momentum snap).
          var _newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta)
          };
          var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
          var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
  
          if (!ignoreWheelEvents) {
            swiper.mousewheel.lastEventBeforeSnap = undefined;
  
            if (swiper.params.loop) {
              swiper.loopFix();
            }
  
            var position = swiper.getTranslate() + delta * params.sensitivity;
            var wasBeginning = swiper.isBeginning;
            var wasEnd = swiper.isEnd;
            if (position >= swiper.minTranslate()) position = swiper.minTranslate();
            if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
            swiper.setTransition(0);
            swiper.setTranslate(position);
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
  
            if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
              swiper.updateSlidesClasses();
            }
  
            if (swiper.params.freeModeSticky) {
              // When wheel scrolling starts with sticky (aka snap) enabled, then detect
              // the end of a momentum scroll by storing recent (N=15?) wheel events.
              // 1. do all N events have decreasing or same (absolute value) delta?
              // 2. did all N events arrive in the last M (M=500?) msecs?
              // 3. does the earliest event have an (absolute value) delta that's
              //    at least P (P=1?) larger than the most recent event's delta?
              // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
              // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
              // Snap immediately and ignore remaining wheel events in this scroll.
              // See comment above for "remaining wheel events in this scroll" determination.
              // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
              clearTimeout(swiper.mousewheel.timeout);
              swiper.mousewheel.timeout = undefined;
              var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
  
              if (_recentWheelEvents.length >= 15) {
                _recentWheelEvents.shift(); // only store the last N events
  
              }
  
              var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
  
              var firstEvent = _recentWheelEvents[0];
  
              _recentWheelEvents.push(_newEvent);
  
              if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
                // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                _recentWheelEvents.splice(0);
              } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
                // We're at the end of the deceleration of a momentum scroll, so there's no need
                // to wait for more events. Snap ASAP on the next tick.
                // Also, because there's some remaining momentum we'll bias the snap in the
                // direction of the ongoing scroll because it's better UX for the scroll to snap
                // in the same direction as the scroll instead of reversing to snap.  Therefore,
                // if it's already scrolled more than 20% in the current direction, keep going.
                var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                swiper.mousewheel.lastEventBeforeSnap = _newEvent;
  
                _recentWheelEvents.splice(0);
  
                swiper.mousewheel.timeout = nextTick(function () {
                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                }, 0); // no delay; move on next tick
              }
  
              if (!swiper.mousewheel.timeout) {
                // if we get here, then we haven't detected the end of a momentum scroll, so
                // we'll consider a scroll "complete" when there haven't been any wheel events
                // for 500ms.
                swiper.mousewheel.timeout = nextTick(function () {
                  var snapToThreshold = 0.5;
                  swiper.mousewheel.lastEventBeforeSnap = _newEvent;
  
                  _recentWheelEvents.splice(0);
  
                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                }, 500);
              }
            } // Emit event
  
  
            if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay
  
            if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
  
            if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
          }
        }
  
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        return false;
      },
      animateSlider: function animateSlider(newEvent) {
        var swiper = this;
        var window = getWindow();
  
        if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) {
          // Prevent if delta of wheel scroll delta is below configured threshold
          return false;
        }
  
        if (this.params.mousewheel.thresholdTime && now() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) {
          // Prevent if time between scrolls is below configured threshold
          return false;
        } // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
  
  
        if (newEvent.delta >= 6 && now() - swiper.mousewheel.lastScrollTime < 60) {
          // Return false as a default
          return true;
        } // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
  
  
        if (newEvent.direction < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit('scroll', newEvent.raw);
          }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          swiper.emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
  
  
        swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default
  
        return false;
      },
      releaseScroll: function releaseScroll(newEvent) {
        var swiper = this;
        var params = swiper.params.mousewheel;
  
        if (newEvent.direction < 0) {
          if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
            // Return true to animate scroll on edges
            return true;
          }
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
          // Return true to animate scroll on edges
          return true;
        }
  
        return false;
      },
      enable: function enable() {
        var swiper = this;
        var event = Mousewheel.event();
  
        if (swiper.params.cssMode) {
          swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
          return true;
        }
  
        if (!event) return false;
        if (swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
  
        if (swiper.params.mousewheel.eventsTarget !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
  
        target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
        target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
        target.on(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
      },
      disable: function disable() {
        var swiper = this;
        var event = Mousewheel.event();
  
        if (swiper.params.cssMode) {
          swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
          return true;
        }
  
        if (!event) return false;
        if (!swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
  
        if (swiper.params.mousewheel.eventsTarget !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
  
        target.off(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
      }
    };
    var Mousewheel$1 = {
      name: 'mousewheel',
      params: {
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarget: 'container',
          thresholdDelta: null,
          thresholdTime: null
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          mousewheel: {
            enabled: false,
            lastScrollTime: now(),
            lastEventBeforeSnap: undefined,
            recentWheelEvents: [],
            enable: Mousewheel.enable,
            disable: Mousewheel.disable,
            handle: Mousewheel.handle,
            handleMouseEnter: Mousewheel.handleMouseEnter,
            handleMouseLeave: Mousewheel.handleMouseLeave,
            animateSlider: Mousewheel.animateSlider,
            releaseScroll: Mousewheel.releaseScroll
          }
        });
      },
      on: {
        init: function init(swiper) {
          if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
            swiper.mousewheel.disable();
          }
  
          if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy: function destroy(swiper) {
          if (swiper.params.cssMode) {
            swiper.mousewheel.enable();
          }
  
          if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        }
      }
    };
  
    var Navigation = {
      update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        if (swiper.params.loop) return;
        var _swiper$navigation = swiper.navigation,
            $nextEl = _swiper$navigation.$nextEl,
            $prevEl = _swiper$navigation.$prevEl;
  
        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            $prevEl.addClass(params.disabledClass);
          } else {
            $prevEl.removeClass(params.disabledClass);
          }
  
          $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
  
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            $nextEl.addClass(params.disabledClass);
          } else {
            $nextEl.removeClass(params.disabledClass);
          }
  
          $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      },
      onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
      },
      onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
  
        if (params.nextEl) {
          $nextEl = $(params.nextEl);
  
          if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
            $nextEl = swiper.$el.find(params.nextEl);
          }
        }
  
        if (params.prevEl) {
          $prevEl = $(params.prevEl);
  
          if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
            $prevEl = swiper.$el.find(params.prevEl);
          }
        }
  
        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on('click', swiper.navigation.onNextClick);
        }
  
        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on('click', swiper.navigation.onPrevClick);
        }
  
        extend$1(swiper.navigation, {
          $nextEl: $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl: $prevEl,
          prevEl: $prevEl && $prevEl[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var _swiper$navigation2 = swiper.navigation,
            $nextEl = _swiper$navigation2.$nextEl,
            $prevEl = _swiper$navigation2.$prevEl;
  
        if ($nextEl && $nextEl.length) {
          $nextEl.off('click', swiper.navigation.onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
  
        if ($prevEl && $prevEl.length) {
          $prevEl.off('click', swiper.navigation.onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      }
    };
    var Navigation$1 = {
      name: 'navigation',
      params: {
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          navigation: _extends({}, Navigation)
        });
      },
      on: {
        init: function init(swiper) {
          swiper.navigation.init();
          swiper.navigation.update();
        },
        toEdge: function toEdge(swiper) {
          swiper.navigation.update();
        },
        fromEdge: function fromEdge(swiper) {
          swiper.navigation.update();
        },
        destroy: function destroy(swiper) {
          swiper.navigation.destroy();
        },
        click: function click(swiper, e) {
          var _swiper$navigation3 = swiper.navigation,
              $nextEl = _swiper$navigation3.$nextEl,
              $prevEl = _swiper$navigation3.$prevEl;
          var targetEl = e.target;
  
          if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
  
            if ($nextEl) {
              isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            } else if ($prevEl) {
              isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            }
  
            if (isHidden === true) {
              swiper.emit('navigationShow');
            } else {
              swiper.emit('navigationHide');
            }
  
            if ($nextEl) {
              $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
  
            if ($prevEl) {
              $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
          }
        }
      }
    };
  
    var Pagination = {
      update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
  
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
  
        if (swiper.params.loop) {
          current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
  
          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }
  
          if (current > total - 1) current -= total;
          if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        } // Types
  
  
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
          var bullets = swiper.pagination.bullets;
          var firstIndex;
          var lastIndex;
          var midIndex;
  
          if (params.dynamicBullets) {
            swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
            $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
  
            if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
              swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
  
              if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
                swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (swiper.pagination.dynamicBulletIndex < 0) {
                swiper.pagination.dynamicBulletIndex = 0;
              }
            }
  
            firstIndex = current - swiper.pagination.dynamicBulletIndex;
            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
  
          bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
  
          if ($el.length > 1) {
            bullets.each(function (bullet) {
              var $bullet = $(bullet);
              var bulletIndex = $bullet.index();
  
              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }
  
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(params.bulletActiveClass + "-main");
                }
  
                if (bulletIndex === firstIndex) {
                  $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                }
  
                if (bulletIndex === lastIndex) {
                  $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
              }
            });
          } else {
            var $bullet = bullets.eq(current);
            var bulletIndex = $bullet.index();
            $bullet.addClass(params.bulletActiveClass);
  
            if (params.dynamicBullets) {
              var $firstDisplayedBullet = bullets.eq(firstIndex);
              var $lastDisplayedBullet = bullets.eq(lastIndex);
  
              for (var i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(params.bulletActiveClass + "-main");
              }
  
              if (swiper.params.loop) {
                if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                  for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                    bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                  }
  
                  bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
                } else {
                  $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                  $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
              } else {
                $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            }
          }
  
          if (params.dynamicBullets) {
            var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
            var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
            var offsetProp = rtl ? 'right' : 'left';
            bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
          }
        }
  
        if (params.type === 'fraction') {
          $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
          $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
        }
  
        if (params.type === 'progressbar') {
          var progressbarDirection;
  
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
          } else {
            progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
          }
  
          var scale = (current + 1) / total;
          var scaleX = 1;
          var scaleY = 1;
  
          if (progressbarDirection === 'horizontal') {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
  
          $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }
  
        if (params.type === 'custom' && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          swiper.emit('paginationRender', $el[0]);
        } else {
          swiper.emit('paginationUpdate', $el[0]);
        }
  
        $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      },
      render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';
  
        if (params.type === 'bullets') {
          var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
  
          if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
            numberOfBullets = slidesLength;
          }
  
          for (var i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            } else {
              paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
            }
          }
  
          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find("." + params.bulletClass.replace(/ /g, '.'));
        }
  
        if (params.type === 'fraction') {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
          } else {
            paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
          }
  
          $el.html(paginationHTML);
        }
  
        if (params.type === 'progressbar') {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
          } else {
            paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
          }
  
          $el.html(paginationHTML);
        }
  
        if (params.type !== 'custom') {
          swiper.emit('paginationRender', swiper.pagination.$el[0]);
        }
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = $(params.el);
        if ($el.length === 0) return;
  
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
          $el = swiper.$el.find(params.el);
        }
  
        if (params.type === 'bullets' && params.clickable) {
          $el.addClass(params.clickableClass);
        }
  
        $el.addClass(params.modifierClass + params.type);
  
        if (params.type === 'bullets' && params.dynamicBullets) {
          $el.addClass("" + params.modifierClass + params.type + "-dynamic");
          swiper.pagination.dynamicBulletIndex = 0;
  
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
  
        if (params.type === 'progressbar' && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }
  
        if (params.clickable) {
          $el.on('click', "." + params.bulletClass.replace(/ /g, '.'), function onClick(e) {
            e.preventDefault();
            var index = $(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
          });
        }
  
        extend$1(swiper.pagination, {
          $el: $el,
          el: $el[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
  
        if (params.clickable) {
          $el.off('click', "." + params.bulletClass.replace(/ /g, '.'));
        }
      }
    };
    var Pagination$1 = {
      name: 'pagination',
      params: {
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: 'bullets',
          // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: function formatFractionCurrent(number) {
            return number;
          },
          formatFractionTotal: function formatFractionTotal(number) {
            return number;
          },
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          modifierClass: 'swiper-pagination-',
          // NEW
          currentClass: 'swiper-pagination-current',
          totalClass: 'swiper-pagination-total',
          hiddenClass: 'swiper-pagination-hidden',
          progressbarFillClass: 'swiper-pagination-progressbar-fill',
          progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
          clickableClass: 'swiper-pagination-clickable',
          // NEW
          lockClass: 'swiper-pagination-lock'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          pagination: _extends({
            dynamicBulletIndex: 0
          }, Pagination)
        });
      },
      on: {
        init: function init(swiper) {
          swiper.pagination.init();
          swiper.pagination.render();
          swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange(swiper) {
          if (swiper.params.loop) {
            swiper.pagination.update();
          } else if (typeof swiper.snapIndex === 'undefined') {
            swiper.pagination.update();
          }
        },
        snapIndexChange: function snapIndexChange(swiper) {
          if (!swiper.params.loop) {
            swiper.pagination.update();
          }
        },
        slidesLengthChange: function slidesLengthChange(swiper) {
          if (swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        snapGridLengthChange: function snapGridLengthChange(swiper) {
          if (!swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        destroy: function destroy(swiper) {
          swiper.pagination.destroy();
        },
        click: function click(swiper, e) {
          var targetEl = e.target;
  
          if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
  
            if (isHidden === true) {
              swiper.emit('paginationShow');
            } else {
              swiper.emit('paginationHide');
            }
  
            swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
          }
        }
      }
    };
  
    var Scrollbar = {
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar,
            rtl = swiper.rtlTranslate,
            progress = swiper.progress;
        var dragSize = scrollbar.dragSize,
            trackSize = scrollbar.trackSize,
            $dragEl = scrollbar.$dragEl,
            $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
  
        if (rtl) {
          newPos = -newPos;
  
          if (newPos > 0) {
            newSize = dragSize - newPos;
            newPos = 0;
          } else if (-newPos + dragSize > trackSize) {
            newSize = trackSize + newPos;
          }
        } else if (newPos < 0) {
          newSize = dragSize + newPos;
          newPos = 0;
        } else if (newPos + dragSize > trackSize) {
          newSize = trackSize - newPos;
        }
  
        if (swiper.isHorizontal()) {
          $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
          $dragEl[0].style.width = newSize + "px";
        } else {
          $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
          $dragEl[0].style.height = newSize + "px";
        }
  
        if (params.hide) {
          clearTimeout(swiper.scrollbar.timeout);
          $el[0].style.opacity = 1;
          swiper.scrollbar.timeout = setTimeout(function () {
            $el[0].style.opacity = 0;
            $el.transition(400);
          }, 1000);
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
      },
      updateSize: function updateSize() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl,
            $el = scrollbar.$el;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
  
        if (swiper.params.scrollbar.dragSize === 'auto') {
          dragSize = trackSize * divider;
        } else {
          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }
  
        if (swiper.isHorizontal()) {
          $dragEl[0].style.width = dragSize + "px";
        } else {
          $dragEl[0].style.height = dragSize + "px";
        }
  
        if (divider >= 1) {
          $el[0].style.display = 'none';
        } else {
          $el[0].style.display = '';
        }
  
        if (swiper.params.scrollbar.hide) {
          $el[0].style.opacity = 0;
        }
  
        extend$1(scrollbar, {
          trackSize: trackSize,
          divider: divider,
          moveDivider: moveDivider,
          dragSize: dragSize
        });
        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
      },
      getPointerPosition: function getPointerPosition(e) {
        var swiper = this;
  
        if (swiper.isHorizontal()) {
          return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        }
  
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
      },
      setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar,
            rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el,
            dragSize = scrollbar.dragSize,
            trackSize = scrollbar.trackSize,
            dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
  
        if (rtl) {
          positionRatio = 1 - positionRatio;
        }
  
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      },
      onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar,
            $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el,
            $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);
  
        if (params.hide) {
          $el.css('opacity', 1);
        }
  
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css('scroll-snap-type', 'none');
        }
  
        swiper.emit('scrollbarDragStart', e);
      },
      onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar,
            $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el,
            $dragEl = scrollbar.$dragEl;
        if (!swiper.scrollbar.isTouched) return;
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit('scrollbarDragMove', e);
      },
      onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar,
            $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!swiper.scrollbar.isTouched) return;
        swiper.scrollbar.isTouched = false;
  
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css('scroll-snap-type', '');
          $wrapperEl.transition('');
        }
  
        if (params.hide) {
          clearTimeout(swiper.scrollbar.dragTimeout);
          swiper.scrollbar.dragTimeout = nextTick(function () {
            $el.css('opacity', 0);
            $el.transition(400);
          }, 1000);
        }
  
        swiper.emit('scrollbarDragEnd', e);
  
        if (params.snapOnRelease) {
          swiper.slideToClosest();
        }
      },
      enableDraggable: function enableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = getDocument();
        var scrollbar = swiper.scrollbar,
            touchEventsTouch = swiper.touchEventsTouch,
            touchEventsDesktop = swiper.touchEventsDesktop,
            params = swiper.params,
            support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        if (!target) return;
  
        if (!support.touch) {
          target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      disableDraggable: function disableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = getDocument();
        var scrollbar = swiper.scrollbar,
            touchEventsTouch = swiper.touchEventsTouch,
            touchEventsDesktop = swiper.touchEventsDesktop,
            params = swiper.params,
            support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        if (!target) return;
  
        if (!support.touch) {
          target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var scrollbar = swiper.scrollbar,
            $swiperEl = swiper.$el;
        var params = swiper.params.scrollbar;
        var $el = $(params.el);
  
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
          $el = $swiperEl.find(params.el);
        }
  
        var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
  
        if ($dragEl.length === 0) {
          $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
          $el.append($dragEl);
        }
  
        extend$1(scrollbar, {
          $el: $el,
          el: $el[0],
          $dragEl: $dragEl,
          dragEl: $dragEl[0]
        });
  
        if (params.draggable) {
          scrollbar.enableDraggable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
      }
    };
    var Scrollbar$1 = {
      name: 'scrollbar',
      params: {
        scrollbar: {
          el: null,
          dragSize: 'auto',
          hide: false,
          draggable: false,
          snapOnRelease: true,
          lockClass: 'swiper-scrollbar-lock',
          dragClass: 'swiper-scrollbar-drag'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          scrollbar: _extends({
            isTouched: false,
            timeout: null,
            dragTimeout: null
          }, Scrollbar)
        });
      },
      on: {
        init: function init(swiper) {
          swiper.scrollbar.init();
          swiper.scrollbar.updateSize();
          swiper.scrollbar.setTranslate();
        },
        update: function update(swiper) {
          swiper.scrollbar.updateSize();
        },
        resize: function resize(swiper) {
          swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate(swiper) {
          swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate(swiper) {
          swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          swiper.scrollbar.setTransition(duration);
        },
        destroy: function destroy(swiper) {
          swiper.scrollbar.destroy();
        }
      }
    };
  
    var Parallax = {
      setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = $(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr('data-swiper-parallax') || '0';
        var x = $el.attr('data-swiper-parallax-x');
        var y = $el.attr('data-swiper-parallax-y');
        var scale = $el.attr('data-swiper-parallax-scale');
        var opacity = $el.attr('data-swiper-parallax-opacity');
  
        if (x || y) {
          x = x || '0';
          y = y || '0';
        } else if (swiper.isHorizontal()) {
          x = p;
          y = '0';
        } else {
          y = p;
          x = '0';
        }
  
        if (x.indexOf('%') >= 0) {
          x = parseInt(x, 10) * progress * rtlFactor + "%";
        } else {
          x = x * progress * rtlFactor + "px";
        }
  
        if (y.indexOf('%') >= 0) {
          y = parseInt(y, 10) * progress + "%";
        } else {
          y = y * progress + "px";
        }
  
        if (typeof opacity !== 'undefined' && opacity !== null) {
          var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
          $el[0].style.opacity = currentOpacity;
        }
  
        if (typeof scale === 'undefined' || scale === null) {
          $el.transform("translate3d(" + x + ", " + y + ", 0px)");
        } else {
          var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
          $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el,
            slides = swiper.slides,
            progress = swiper.progress,
            snapGrid = swiper.snapGrid;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
          swiper.parallax.setTransform(el, progress);
        });
        slides.each(function (slideEl, slideIndex) {
          var slideProgress = slideEl.progress;
  
          if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
            slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
          }
  
          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
          $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
        });
      },
      setTransition: function setTransition(duration) {
        if (duration === void 0) {
          duration = this.params.speed;
        }
  
        var swiper = this;
        var $el = swiper.$el;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) parallaxDuration = 0;
          $parallaxEl.transition(parallaxDuration);
        });
      }
    };
    var Parallax$1 = {
      name: 'parallax',
      params: {
        parallax: {
          enabled: false
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          parallax: _extends({}, Parallax)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (!swiper.params.parallax.enabled) return;
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init(swiper) {
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate(swiper) {
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTransition(duration);
        }
      }
    };
  
    var Zoom = {
      // Calc Scale From Multi-touches
      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
      },
      // Events
      onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
  
        if (!support.gestures) {
          if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
            return;
          }
  
          zoom.fakeGestureTouched = true;
          gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
        }
  
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
          gesture.$slideEl = $(e.target).closest("." + swiper.params.slideClass);
          if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
          gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
  
          if (gesture.$imageWrapEl.length === 0) {
            gesture.$imageEl = undefined;
            return;
          }
        }
  
        if (gesture.$imageEl) {
          gesture.$imageEl.transition(0);
        }
  
        swiper.zoom.isScaling = true;
      },
      onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
  
        if (!support.gestures) {
          if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
            return;
          }
  
          zoom.fakeGestureMoved = true;
          gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
        }
  
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          if (e.type === 'gesturechange') zoom.onGestureStart(e);
          return;
        }
  
        if (support.gestures) {
          zoom.scale = e.scale * zoom.currentScale;
        } else {
          zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        }
  
        if (zoom.scale > gesture.maxRatio) {
          zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        }
  
        if (zoom.scale < params.minRatio) {
          zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        }
  
        gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var device = swiper.device;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
  
        if (!support.gestures) {
          if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
            return;
          }
  
          if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
            return;
          }
  
          zoom.fakeGestureTouched = false;
          zoom.fakeGestureMoved = false;
        }
  
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
      },
      onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var device = swiper.device;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture,
            image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      },
      onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture,
            image = zoom.image,
            velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
  
        if (!image.isMoved) {
          image.width = gesture.$imageEl[0].offsetWidth;
          image.height = gesture.$imageEl[0].offsetHeight;
          image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
          image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
          gesture.$imageWrapEl.transition(0);
  
          if (swiper.rtl) {
            image.startX = -image.startX;
            image.startY = -image.startY;
          }
        } // Define if we need image drag
  
  
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  
        if (!image.isMoved && !zoom.isScaling) {
          if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
            image.isTouched = false;
            return;
          }
  
          if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
            image.isTouched = false;
            return;
          }
        }
  
        if (e.cancelable) {
          e.preventDefault();
        }
  
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
  
        if (image.currentX < image.minX) {
          image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        }
  
        if (image.currentX > image.maxX) {
          image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        }
  
        if (image.currentY < image.minY) {
          image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        }
  
        if (image.currentY > image.maxY) {
          image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        } // Velocity
  
  
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture,
            image = zoom.image,
            velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
  
        if (!image.isTouched || !image.isMoved) {
          image.isTouched = false;
          image.isMoved = false;
          return;
        }
  
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration
  
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
  
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
  
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
          if (gesture.$imageEl) {
            gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
          }
  
          if (gesture.$imageWrapEl) {
            gesture.$imageWrapEl.transform('translate3d(0,0,0)');
          }
  
          zoom.scale = 1;
          zoom.currentScale = 1;
          gesture.$slideEl = undefined;
          gesture.$imageEl = undefined;
          gesture.$imageWrapEl = undefined;
        }
      },
      // Toggle Zoom
      toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;
  
        if (zoom.scale && zoom.scale !== 1) {
          // Zoom Out
          zoom.out();
        } else {
          // Zoom In
          zoom.in(e);
        }
      },
      in: function _in(e) {
        var swiper = this;
        var window = getWindow();
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture,
            image = zoom.image;
  
        if (!gesture.$slideEl) {
          if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
            gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
          } else {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
  
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
  
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        gesture.$slideEl.addClass("" + params.zoomedSlideClass);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
  
        if (typeof image.touchesStart.x === 'undefined' && e) {
          touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = image.touchesStart.x;
          touchY = image.touchesStart.y;
        }
  
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
  
        if (e) {
          slideWidth = gesture.$slideEl[0].offsetWidth;
          slideHeight = gesture.$slideEl[0].offsetHeight;
          offsetX = gesture.$slideEl.offset().left + window.scrollX;
          offsetY = gesture.$slideEl.offset().top + window.scrollY;
          diffX = offsetX + slideWidth / 2 - touchX;
          diffY = offsetY + slideHeight / 2 - touchY;
          imageWidth = gesture.$imageEl[0].offsetWidth;
          imageHeight = gesture.$imageEl[0].offsetHeight;
          scaledWidth = imageWidth * zoom.scale;
          scaledHeight = imageHeight * zoom.scale;
          translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
          translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
          translateMaxX = -translateMinX;
          translateMaxY = -translateMinY;
          translateX = diffX * zoom.scale;
          translateY = diffY * zoom.scale;
  
          if (translateX < translateMinX) {
            translateX = translateMinX;
          }
  
          if (translateX > translateMaxX) {
            translateX = translateMaxX;
          }
  
          if (translateY < translateMinY) {
            translateY = translateMinY;
          }
  
          if (translateY > translateMaxY) {
            translateY = translateMaxY;
          }
        } else {
          translateX = 0;
          translateY = 0;
        }
  
        gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
  
        if (!gesture.$slideEl) {
          if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
            gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
          } else {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
  
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
  
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
        gesture.$slideEl = undefined;
      },
      toggleGestures: function toggleGestures(method) {
        var swiper = this;
        var zoom = swiper.zoom;
        var selector = zoom.slideSelector,
            passive = zoom.passiveListener;
        swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
        swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
        swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
      },
      enableGestures: function enableGestures() {
        if (this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = true;
        this.zoom.toggleGestures('on');
      },
      disableGestures: function disableGestures() {
        if (!this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = false;
        this.zoom.toggleGestures('off');
      },
      // Attach/Detach Events
      enable: function enable() {
        var swiper = this;
        var support = swiper.support;
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
          passive: false,
          capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass;
        swiper.zoom.passiveListener = passiveListener;
        swiper.zoom.slideSelector = slideSelector; // Scale image
  
        if (support.gestures) {
          swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
          swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
  
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
          }
        } // Move image
  
  
        swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
      },
      disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        var support = swiper.support;
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
          passive: false,
          capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass; // Scale image
  
        if (support.gestures) {
          swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
          swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
  
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
          }
        } // Move image
  
  
        swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
      }
    };
    var Zoom$1 = {
      name: 'zoom',
      params: {
        zoom: {
          enabled: false,
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: 'swiper-zoom-container',
          zoomedSlideClass: 'swiper-slide-zoomed'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          zoom: _extends({
            enabled: false,
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
              $slideEl: undefined,
              slideWidth: undefined,
              slideHeight: undefined,
              $imageEl: undefined,
              $imageWrapEl: undefined,
              maxRatio: 3
            },
            image: {
              isTouched: undefined,
              isMoved: undefined,
              currentX: undefined,
              currentY: undefined,
              minX: undefined,
              minY: undefined,
              maxX: undefined,
              maxY: undefined,
              width: undefined,
              height: undefined,
              startX: undefined,
              startY: undefined,
              touchesStart: {},
              touchesCurrent: {}
            },
            velocity: {
              x: undefined,
              y: undefined,
              prevPositionX: undefined,
              prevPositionY: undefined,
              prevTime: undefined
            }
          }, Zoom)
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, 'scale', {
          get: function get() {
            return scale;
          },
          set: function set(value) {
            if (scale !== value) {
              var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
              var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
              swiper.emit('zoomChange', value, imageEl, slideEl);
            }
  
            scale = value;
          }
        });
      },
      on: {
        init: function init(swiper) {
          if (swiper.params.zoom.enabled) {
            swiper.zoom.enable();
          }
        },
        destroy: function destroy(swiper) {
          swiper.zoom.disable();
        },
        touchStart: function touchStart(swiper, e) {
          if (!swiper.zoom.enabled) return;
          swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(swiper, e) {
          if (!swiper.zoom.enabled) return;
          swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(swiper, e) {
          if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
            swiper.zoom.toggle(e);
          }
        },
        transitionEnd: function transitionEnd(swiper) {
          if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
            swiper.zoom.onTransitionEnd();
          }
        },
        slideChange: function slideChange(swiper) {
          if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
            swiper.zoom.onTransitionEnd();
          }
        }
      }
    };
  
    var Lazy = {
      loadInSlide: function loadInSlide(index, loadInDuplicate) {
        if (loadInDuplicate === void 0) {
          loadInDuplicate = true;
        }
  
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
        var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
  
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
          $images.push($slideEl[0]);
        }
  
        if ($images.length === 0) return;
        $images.each(function (imageEl) {
          var $imageEl = $(imageEl);
          $imageEl.addClass(params.loadingClass);
          var background = $imageEl.attr('data-background');
          var src = $imageEl.attr('data-src');
          var srcset = $imageEl.attr('data-srcset');
          var sizes = $imageEl.attr('data-sizes');
          var $pictureEl = $imageEl.parent('picture');
          swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
            if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
  
            if (background) {
              $imageEl.css('background-image', "url(\"" + background + "\")");
              $imageEl.removeAttr('data-background');
            } else {
              if (srcset) {
                $imageEl.attr('srcset', srcset);
                $imageEl.removeAttr('data-srcset');
              }
  
              if (sizes) {
                $imageEl.attr('sizes', sizes);
                $imageEl.removeAttr('data-sizes');
              }
  
              if ($pictureEl.length) {
                $pictureEl.children('source').each(function (sourceEl) {
                  var $source = $(sourceEl);
  
                  if ($source.attr('data-srcset')) {
                    $source.attr('srcset', $source.attr('data-srcset'));
                    $source.removeAttr('data-srcset');
                  }
                });
              }
  
              if (src) {
                $imageEl.attr('src', src);
                $imageEl.removeAttr('data-src');
              }
            }
  
            $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
            $slideEl.find("." + params.preloaderClass).remove();
  
            if (swiper.params.loop && loadInDuplicate) {
              var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
  
              if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
                swiper.lazy.loadInSlide(originalSlide.index(), false);
              } else {
                var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
                swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
              }
            }
  
            swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
  
            if (swiper.params.autoHeight) {
              swiper.updateAutoHeight();
            }
          });
          swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
      },
      load: function load() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl,
            swiperParams = swiper.params,
            slides = swiper.slides,
            activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
  
        if (slidesPerView === 'auto') {
          slidesPerView = 0;
        }
  
        function slideExist(index) {
          if (isVirtual) {
            if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
              return true;
            }
          } else if (slides[index]) return true;
  
          return false;
        }
  
        function slideIndex(slideEl) {
          if (isVirtual) {
            return $(slideEl).attr('data-swiper-slide-index');
          }
  
          return $(slideEl).index();
        }
  
        if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
  
        if (swiper.params.watchSlidesVisibility) {
          $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (slideEl) {
            var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
            swiper.lazy.loadInSlide(index);
          });
        } else if (slidesPerView > 1) {
          for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
            if (slideExist(i)) swiper.lazy.loadInSlide(i);
          }
        } else {
          swiper.lazy.loadInSlide(activeIndex);
        }
  
        if (params.loadPrevNext) {
          if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
            var amount = params.loadPrevNextAmount;
            var spv = slidesPerView;
            var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
            var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
  
            for (var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1) {
              if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
            } // Prev Slides
  
  
            for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
              if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
            }
          } else {
            var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
            if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
            var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
            if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
          }
        }
      },
      checkInViewOnLoad: function checkInViewOnLoad() {
        var window = getWindow();
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
        var isWindow = $scrollElement[0] === window;
        var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        var swiperOffset = swiper.$el.offset();
        var rtl = swiper.rtlTranslate;
        var inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
  
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
  
          if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
            if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
  
            inView = true;
          }
        }
  
        if (inView) {
          swiper.lazy.load();
          $scrollElement.off('scroll', swiper.lazy.checkInViewOnLoad);
        } else if (!swiper.lazy.scrollHandlerAttached) {
          swiper.lazy.scrollHandlerAttached = true;
          $scrollElement.on('scroll', swiper.lazy.checkInViewOnLoad);
        }
      }
    };
    var Lazy$1 = {
      name: 'lazy',
      params: {
        lazy: {
          checkInView: false,
          enabled: false,
          loadPrevNext: false,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false,
          scrollingElement: '',
          elementClass: 'swiper-lazy',
          loadingClass: 'swiper-lazy-loading',
          loadedClass: 'swiper-lazy-loaded',
          preloaderClass: 'swiper-lazy-preloader'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          lazy: _extends({
            initialImageLoaded: false
          }, Lazy)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
            swiper.params.preloadImages = false;
          }
        },
        init: function init(swiper) {
          if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
            if (swiper.params.lazy.checkInView) {
              swiper.lazy.checkInViewOnLoad();
            } else {
              swiper.lazy.load();
            }
          }
        },
        scroll: function scroll(swiper) {
          if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
            swiper.lazy.load();
          }
        },
        'scrollbarDragMove resize _freeModeNoMomentumRelease': function lazyLoad(swiper) {
          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        transitionStart: function transitionStart(swiper) {
          if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
              swiper.lazy.load();
            }
          }
        },
        transitionEnd: function transitionEnd(swiper) {
          if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            swiper.lazy.load();
          }
        },
        slideChange: function slideChange(swiper) {
          if (swiper.params.lazy.enabled && swiper.params.cssMode) {
            swiper.lazy.load();
          }
        }
      }
    };
  
    var Controller = {
      LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
          var maxIndex;
          var minIndex;
          var guess;
          return function (array, val) {
            minIndex = -1;
            maxIndex = array.length;
  
            while (maxIndex - minIndex > 1) {
              guess = maxIndex + minIndex >> 1;
  
              if (array[guess] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }
  
            return maxIndex;
          };
        }();
  
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
  
        var i1;
        var i3;
  
        this.interpolate = function interpolate(x2) {
          if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
  
          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
  
          return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
  
        return this;
      },
      // xxx: for now i will just save one spline function to to
      getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;
  
        if (!swiper.controller.spline) {
          swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
        }
      },
      setTranslate: function setTranslate(_setTranslate, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
  
        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
  
          if (swiper.params.controller.by === 'slide') {
            swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out
  
            controlledTranslate = -swiper.controller.spline.interpolate(-translate);
          }
  
          if (!controlledTranslate || swiper.params.controller.by === 'container') {
            multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
            controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
          }
  
          if (swiper.params.controller.inverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }
  
          c.updateProgress(controlledTranslate);
          c.setTranslate(controlledTranslate, swiper);
          c.updateActiveIndex();
          c.updateSlidesClasses();
        }
  
        if (Array.isArray(controlled)) {
          for (var i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTranslate(controlled);
        }
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
  
        function setControlledTransition(c) {
          c.setTransition(duration, swiper);
  
          if (duration !== 0) {
            c.transitionStart();
  
            if (c.params.autoHeight) {
              nextTick(function () {
                c.updateAutoHeight();
              });
            }
  
            c.$wrapperEl.transitionEnd(function () {
              if (!controlled) return;
  
              if (c.params.loop && swiper.params.controller.by === 'slide') {
                c.loopFix();
              }
  
              c.transitionEnd();
            });
          }
        }
  
        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTransition(controlled);
        }
      }
    };
    var Controller$1 = {
      name: 'controller',
      params: {
        controller: {
          control: undefined,
          inverse: false,
          by: 'slide' // or 'container'
  
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          controller: _extends({
            control: swiper.params.controller.control
          }, Controller)
        });
      },
      on: {
        update: function update(swiper) {
          if (!swiper.controller.control) return;
  
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        resize: function resize(swiper) {
          if (!swiper.controller.control) return;
  
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        observerUpdate: function observerUpdate(swiper) {
          if (!swiper.controller.control) return;
  
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        setTranslate: function setTranslate(swiper, translate, byController) {
          if (!swiper.controller.control) return;
          swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(swiper, duration, byController) {
          if (!swiper.controller.control) return;
          swiper.controller.setTransition(duration, byController);
        }
      }
    };
  
    var A11y = {
      getRandomNumber: function getRandomNumber(size) {
        if (size === void 0) {
          size = 16;
        }
  
        var randomChar = function randomChar() {
          return Math.round(16 * Math.random()).toString(16);
        };
  
        return 'x'.repeat(size).replace(/x/g, randomChar);
      },
      makeElFocusable: function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
        return $el;
      },
      makeElNotFocusable: function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
        return $el;
      },
      addElRole: function addElRole($el, role) {
        $el.attr('role', role);
        return $el;
      },
      addElRoleDescription: function addElRoleDescription($el, description) {
        $el.attr('aria-role-description', description);
        return $el;
      },
      addElControls: function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
        return $el;
      },
      addElLabel: function addElLabel($el, label) {
        $el.attr('aria-label', label);
        return $el;
      },
      addElId: function addElId($el, id) {
        $el.attr('id', id);
        return $el;
      },
      addElLive: function addElLive($el, live) {
        $el.attr('aria-live', live);
        return $el;
      },
      disableEl: function disableEl($el) {
        $el.attr('aria-disabled', true);
        return $el;
      },
      enableEl: function enableEl($el) {
        $el.attr('aria-disabled', false);
        return $el;
      },
      onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var swiper = this;
        var params = swiper.params.a11y;
        var $targetEl = $(e.target);
  
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
          if (!(swiper.isEnd && !swiper.params.loop)) {
            swiper.slideNext();
          }
  
          if (swiper.isEnd) {
            swiper.a11y.notify(params.lastSlideMessage);
          } else {
            swiper.a11y.notify(params.nextSlideMessage);
          }
        }
  
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
          if (!(swiper.isBeginning && !swiper.params.loop)) {
            swiper.slidePrev();
          }
  
          if (swiper.isBeginning) {
            swiper.a11y.notify(params.firstSlideMessage);
          } else {
            swiper.a11y.notify(params.prevSlideMessage);
          }
        }
  
        if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass.replace(/ /g, '.'))) {
          $targetEl[0].click();
        }
      },
      notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
      },
      updateNavigation: function updateNavigation() {
        var swiper = this;
        if (swiper.params.loop || !swiper.navigation) return;
        var _swiper$navigation = swiper.navigation,
            $nextEl = _swiper$navigation.$nextEl,
            $prevEl = _swiper$navigation.$prevEl;
  
        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            swiper.a11y.disableEl($prevEl);
            swiper.a11y.makeElNotFocusable($prevEl);
          } else {
            swiper.a11y.enableEl($prevEl);
            swiper.a11y.makeElFocusable($prevEl);
          }
        }
  
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            swiper.a11y.disableEl($nextEl);
            swiper.a11y.makeElNotFocusable($nextEl);
          } else {
            swiper.a11y.enableEl($nextEl);
            swiper.a11y.makeElFocusable($nextEl);
          }
        }
      },
      updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;
  
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.bullets.each(function (bulletEl) {
            var $bulletEl = $(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
  
            if (!swiper.params.pagination.renderBullet) {
              swiper.a11y.addElRole($bulletEl, 'button');
              swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
            }
          });
        }
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.a11y;
        swiper.$el.append(swiper.a11y.liveRegion); // Container
  
        var $containerEl = swiper.$el;
  
        if (params.containerRoleDescriptionMessage) {
          swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        }
  
        if (params.containerMessage) {
          swiper.a11y.addElLabel($containerEl, params.containerMessage);
        } // Wrapper
  
  
        var $wrapperEl = swiper.$wrapperEl;
        var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
        var live;
        swiper.a11y.addElId($wrapperEl, wrapperId);
  
        if (swiper.params.autoplay && swiper.params.autoplay.enabled) {
          live = 'off';
        } else {
          live = 'polite';
        }
  
        swiper.a11y.addElLive($wrapperEl, live); // Slide
  
        if (params.itemRoleDescriptionMessage) {
          swiper.a11y.addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
        }
  
        swiper.a11y.addElRole($(swiper.slides), 'group');
        swiper.slides.each(function (slideEl) {
          var $slideEl = $(slideEl);
          swiper.a11y.addElLabel($slideEl, $slideEl.index() + 1 + " / " + swiper.slides.length);
        }); // Navigation
  
        var $nextEl;
        var $prevEl;
  
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
  
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
  
        if ($nextEl && $nextEl.length) {
          swiper.a11y.makeElFocusable($nextEl);
  
          if ($nextEl[0].tagName !== 'BUTTON') {
            swiper.a11y.addElRole($nextEl, 'button');
            $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
          }
  
          swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
          swiper.a11y.addElControls($nextEl, wrapperId);
        }
  
        if ($prevEl && $prevEl.length) {
          swiper.a11y.makeElFocusable($prevEl);
  
          if ($prevEl[0].tagName !== 'BUTTON') {
            swiper.a11y.addElRole($prevEl, 'button');
            $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
          }
  
          swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
          swiper.a11y.addElControls($prevEl, wrapperId);
        } // Pagination
  
  
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass.replace(/ /g, '.'), swiper.a11y.onEnterOrSpaceKey);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
        var $nextEl;
        var $prevEl;
  
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
  
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
  
        if ($nextEl) {
          $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
        }
  
        if ($prevEl) {
          $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
        } // Pagination
  
  
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass.replace(/ /g, '.'), swiper.a11y.onEnterOrSpaceKey);
        }
      }
    };
    var A11y$1 = {
      name: 'a11y',
      params: {
        a11y: {
          enabled: true,
          notificationClass: 'swiper-notification',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          itemRoleDescriptionMessage: null
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          a11y: _extends({}, A11y, {
            liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
          })
        });
      },
      on: {
        afterInit: function afterInit(swiper) {
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.init();
          swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge(swiper) {
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge(swiper) {
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate(swiper) {
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updatePagination();
        },
        destroy: function destroy(swiper) {
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.destroy();
        }
      }
    };
  
    var History = {
      init: function init() {
        var swiper = this;
        var window = getWindow();
        if (!swiper.params.history) return;
  
        if (!window.history || !window.history.pushState) {
          swiper.params.history.enabled = false;
          swiper.params.hashNavigation.enabled = true;
          return;
        }
  
        var history = swiper.history;
        history.initialized = true;
        history.paths = History.getPathValues(swiper.params.url);
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
  
        if (!swiper.params.history.replaceState) {
          window.addEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        var window = getWindow();
  
        if (!swiper.params.history.replaceState) {
          window.removeEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = History.getPathValues(swiper.params.url);
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
      },
      getPathValues: function getPathValues(urlOverride) {
        var window = getWindow();
        var location;
  
        if (urlOverride) {
          location = new URL(urlOverride);
        } else {
          location = window.location;
        }
  
        var pathArray = location.pathname.slice(1).split('/').filter(function (part) {
          return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
          key: key,
          value: value
        };
      },
      setHistory: function setHistory(key, index) {
        var swiper = this;
        var window = getWindow();
        if (!swiper.history.initialized || !swiper.params.history.enabled) return;
        var location;
  
        if (swiper.params.url) {
          location = new URL(swiper.params.url);
        } else {
          location = window.location;
        }
  
        var slide = swiper.slides.eq(index);
        var value = History.slugify(slide.attr('data-history'));
  
        if (!location.pathname.includes(key)) {
          value = key + "/" + value;
        }
  
        var currentState = window.history.state;
  
        if (currentState && currentState.value === value) {
          return;
        }
  
        if (swiper.params.history.replaceState) {
          window.history.replaceState({
            value: value
          }, null, value);
        } else {
          window.history.pushState({
            value: value
          }, null, value);
        }
      },
      slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
      },
      scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;
  
        if (value) {
          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHistory = History.slugify(slide.attr('data-history'));
  
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          swiper.slideTo(0, speed, runCallbacks);
        }
      }
    };
    var History$1 = {
      name: 'history',
      params: {
        history: {
          enabled: false,
          replaceState: false,
          key: 'slides'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          history: _extends({}, History)
        });
      },
      on: {
        init: function init(swiper) {
          if (swiper.params.history.enabled) {
            swiper.history.init();
          }
        },
        destroy: function destroy(swiper) {
          if (swiper.params.history.enabled) {
            swiper.history.destroy();
          }
        },
        transitionEnd: function transitionEnd(swiper) {
          if (swiper.history.initialized) {
            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
          }
        },
        slideChange: function slideChange(swiper) {
          if (swiper.history.initialized && swiper.params.cssMode) {
            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
          }
        }
      }
    };
  
    var HashNavigation = {
      onHashCange: function onHashCange() {
        var swiper = this;
        var document = getDocument();
        swiper.emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
  
        if (newHash !== activeSlideHash) {
          var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
          if (typeof newIndex === 'undefined') return;
          swiper.slideTo(newIndex);
        }
      },
      setHash: function setHash() {
        var swiper = this;
        var window = getWindow();
        var document = getDocument();
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
  
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
          window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
          swiper.emit('hashSet');
        } else {
          var slide = swiper.slides.eq(swiper.activeIndex);
          var hash = slide.attr('data-hash') || slide.attr('data-history');
          document.location.hash = hash || '';
          swiper.emit('hashSet');
        }
      },
      init: function init() {
        var swiper = this;
        var document = getDocument();
        var window = getWindow();
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        swiper.hashNavigation.initialized = true;
        var hash = document.location.hash.replace('#', '');
  
        if (hash) {
          var speed = 0;
  
          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHash = slide.attr('data-hash') || slide.attr('data-history');
  
            if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
            }
          }
        }
  
        if (swiper.params.hashNavigation.watchState) {
          $(window).on('hashchange', swiper.hashNavigation.onHashCange);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        var window = getWindow();
  
        if (swiper.params.hashNavigation.watchState) {
          $(window).off('hashchange', swiper.hashNavigation.onHashCange);
        }
      }
    };
    var HashNavigation$1 = {
      name: 'hash-navigation',
      params: {
        hashNavigation: {
          enabled: false,
          replaceState: false,
          watchState: false
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          hashNavigation: _extends({
            initialized: false
          }, HashNavigation)
        });
      },
      on: {
        init: function init(swiper) {
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.init();
          }
        },
        destroy: function destroy(swiper) {
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.destroy();
          }
        },
        transitionEnd: function transitionEnd(swiper) {
          if (swiper.hashNavigation.initialized) {
            swiper.hashNavigation.setHash();
          }
        },
        slideChange: function slideChange(swiper) {
          if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
            swiper.hashNavigation.setHash();
          }
        }
      }
    };
  
    var Autoplay = {
      run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
  
        if ($activeSlideEl.attr('data-swiper-autoplay')) {
          delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        }
  
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = nextTick(function () {
          var autoplayResult;
  
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.isBeginning) {
              autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else {
              swiper.autoplay.stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isEnd) {
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
  
          if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
            swiper.autoplay.run();
          }
        }, delay);
      },
      start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit('autoplayStart');
        swiper.autoplay.run();
        return true;
      },
      stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === 'undefined') return false;
  
        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
          swiper.autoplay.timeout = undefined;
        }
  
        swiper.autoplay.running = false;
        swiper.emit('autoplayStop');
        return true;
      },
      pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
  
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          swiper.autoplay.run();
        } else {
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
        }
      },
      onVisibilityChange: function onVisibilityChange() {
        var swiper = this;
        var document = getDocument();
  
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
          swiper.autoplay.pause();
        }
  
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
          swiper.autoplay.run();
          swiper.autoplay.paused = false;
        }
      },
      onTransitionEnd: function onTransitionEnd(e) {
        var swiper = this;
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
        swiper.autoplay.paused = false;
  
        if (!swiper.autoplay.running) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.run();
        }
      }
    };
    var Autoplay$1 = {
      name: 'autoplay',
      params: {
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          autoplay: _extends({}, Autoplay, {
            running: false,
            paused: false
          })
        });
      },
      on: {
        init: function init(swiper) {
          if (swiper.params.autoplay.enabled) {
            swiper.autoplay.start();
            var document = getDocument();
            document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
          }
        },
        beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
          if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.pause(speed);
            } else {
              swiper.autoplay.stop();
            }
          }
        },
        sliderFirstMove: function sliderFirstMove(swiper) {
          if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.pause();
            }
          }
        },
        touchEnd: function touchEnd(swiper) {
          if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.run();
          }
        },
        destroy: function destroy(swiper) {
          if (swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
  
          var document = getDocument();
          document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
      }
    };
  
    var Fade = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
  
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = swiper.slides.eq(i);
          var offset = $slideEl[0].swiperSlideOffset;
          var tx = -offset;
          if (!swiper.params.virtualTranslate) tx -= swiper.translate;
          var ty = 0;
  
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }
  
          var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
          $slideEl.css({
            opacity: slideOpacity
          }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides,
            $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
  
        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false;
          slides.transitionEnd(function () {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
  
            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFade = {
      name: 'effect-fade',
      params: {
        fadeEffect: {
          crossFade: false
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          fadeEffect: _extends({}, Fade)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (swiper.params.effect !== 'fade') return;
          swiper.classNames.push(swiper.params.containerModifierClass + "fade");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          extend$1(swiper.params, overwriteParams);
          extend$1(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
          if (swiper.params.effect !== 'fade') return;
          swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          if (swiper.params.effect !== 'fade') return;
          swiper.fadeEffect.setTransition(duration);
        }
      }
    };
  
    var Cube = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el,
            $wrapperEl = swiper.$wrapperEl,
            slides = swiper.slides,
            swiperWidth = swiper.width,
            swiperHeight = swiper.height,
            rtl = swiper.rtlTranslate,
            swiperSize = swiper.size,
            browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
  
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
  
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $wrapperEl.append($cubeShadowEl);
            }
  
            $cubeShadowEl.css({
              height: swiperWidth + "px"
            });
          } else {
            $cubeShadowEl = $el.find('.swiper-cube-shadow');
  
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $el.append($cubeShadowEl);
            }
          }
        }
  
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideIndex = i;
  
          if (isVirtual) {
            slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
          }
  
          var slideAngle = slideIndex * 90;
          var round = Math.floor(slideAngle / 360);
  
          if (rtl) {
            slideAngle = -slideAngle;
            round = Math.floor(-slideAngle / 360);
          }
  
          var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          var tx = 0;
          var ty = 0;
          var tz = 0;
  
          if (slideIndex % 4 === 0) {
            tx = -round * 4 * swiperSize;
            tz = 0;
          } else if ((slideIndex - 1) % 4 === 0) {
            tx = 0;
            tz = -round * 4 * swiperSize;
          } else if ((slideIndex - 2) % 4 === 0) {
            tx = swiperSize + round * 4 * swiperSize;
            tz = swiperSize;
          } else if ((slideIndex - 3) % 4 === 0) {
            tx = -swiperSize;
            tz = 3 * swiperSize + swiperSize * 4 * round;
          }
  
          if (rtl) {
            tx = -tx;
          }
  
          if (!isHorizontal) {
            ty = tx;
            tx = 0;
          }
  
          var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
  
          if (progress <= 1 && progress > -1) {
            wrapperRotate = slideIndex * 90 + progress * 90;
            if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
          }
  
          $slideEl.transform(transform);
  
          if (params.slideShadows) {
            // Set shadows
            var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  
            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }
  
            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }
  
            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
        }
  
        $wrapperEl.css({
          '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
        });
  
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
          } else {
            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
            var scale1 = params.shadowScale;
            var scale2 = params.shadowScale / multiplier;
            var offset = params.shadowOffset;
            $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
          }
        }
  
        var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el,
            slides = swiper.slides;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
          $el.find('.swiper-cube-shadow').transition(duration);
        }
      }
    };
    var EffectCube = {
      name: 'effect-cube',
      params: {
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          cubeEffect: _extends({}, Cube)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (swiper.params.effect !== 'cube') return;
          swiper.classNames.push(swiper.params.containerModifierClass + "cube");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true
          };
          extend$1(swiper.params, overwriteParams);
          extend$1(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
          if (swiper.params.effect !== 'cube') return;
          swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          if (swiper.params.effect !== 'cube') return;
          swiper.cubeEffect.setTransition(duration);
        }
      }
    };
  
    var Flip = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides,
            rtl = swiper.rtlTranslate;
  
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var progress = $slideEl[0].progress;
  
          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          }
  
          var offset = $slideEl[0].swiperSlideOffset;
          var rotate = -180 * progress;
          var rotateY = rotate;
          var rotateX = 0;
          var tx = -offset;
          var ty = 0;
  
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
            rotateX = -rotateY;
            rotateY = 0;
          } else if (rtl) {
            rotateY = -rotateY;
          }
  
          $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
  
          if (swiper.params.flipEffect.slideShadows) {
            // Set shadows
            var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  
            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }
  
            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }
  
            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
  
          $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides,
            activeIndex = swiper.activeIndex,
            $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  
        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false; // eslint-disable-next-line
  
          slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
  
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
  
            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFlip = {
      name: 'effect-flip',
      params: {
        flipEffect: {
          slideShadows: true,
          limitRotation: true
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          flipEffect: _extends({}, Flip)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (swiper.params.effect !== 'flip') return;
          swiper.classNames.push(swiper.params.containerModifierClass + "flip");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          extend$1(swiper.params, overwriteParams);
          extend$1(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
          if (swiper.params.effect !== 'flip') return;
          swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          if (swiper.params.effect !== 'flip') return;
          swiper.flipEffect.setTransition(duration);
        }
      }
    };
  
    var Coverflow = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width,
            swiperHeight = swiper.height,
            slides = swiper.slides,
            slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center
  
        for (var i = 0, length = slides.length; i < length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideSize = slidesSizesGrid[i];
          var slideOffset = $slideEl[0].swiperSlideOffset;
          var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
          var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
          var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
  
          var translateZ = -translate * Math.abs(offsetMultiplier);
          var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
  
          if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
            stretch = parseFloat(params.stretch) / 100 * slideSize;
          }
  
          var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
          var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
          var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
  
          if (Math.abs(translateX) < 0.001) translateX = 0;
          if (Math.abs(translateY) < 0.001) translateY = 0;
          if (Math.abs(translateZ) < 0.001) translateZ = 0;
          if (Math.abs(rotateY) < 0.001) rotateY = 0;
          if (Math.abs(rotateX) < 0.001) rotateX = 0;
          if (Math.abs(scale) < 0.001) scale = 0;
          var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
          $slideEl.transform(slideTransform);
          $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
  
          if (params.slideShadows) {
            // Set shadows
            var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
  
            if ($shadowBeforeEl.length === 0) {
              $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append($shadowBeforeEl);
            }
  
            if ($shadowAfterEl.length === 0) {
              $shadowAfterEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append($shadowAfterEl);
            }
  
            if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
            if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
          }
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      }
    };
    var EffectCoverflow = {
      name: 'effect-coverflow',
      params: {
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: true
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          coverflowEffect: _extends({}, Coverflow)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          if (swiper.params.effect !== 'coverflow') return;
          swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate(swiper) {
          if (swiper.params.effect !== 'coverflow') return;
          swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
          if (swiper.params.effect !== 'coverflow') return;
          swiper.coverflowEffect.setTransition(duration);
        }
      }
    };
  
    var Thumbs = {
      init: function init() {
        var swiper = this;
        var thumbsParams = swiper.params.thumbs;
        if (swiper.thumbs.initialized) return false;
        swiper.thumbs.initialized = true;
        var SwiperClass = swiper.constructor;
  
        if (thumbsParams.swiper instanceof SwiperClass) {
          swiper.thumbs.swiper = thumbsParams.swiper;
          extend$1(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          extend$1(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
        } else if (isObject$1(thumbsParams.swiper)) {
          swiper.thumbs.swiper = new SwiperClass(extend$1({}, thumbsParams.swiper, {
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: false
          }));
          swiper.thumbs.swiperCreated = true;
        }
  
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
        return true;
      },
      onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
  
        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        } else {
          slideToIndex = clickedIndex;
        }
  
        if (swiper.params.loop) {
          var currentIndex = swiper.activeIndex;
  
          if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
            swiper.loopFix(); // eslint-disable-next-line
  
            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            currentIndex = swiper.activeIndex;
          }
  
          var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
          var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
          if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
        }
  
        swiper.slideTo(slideToIndex);
      },
      update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
  
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
          var currentThumbsIndex = thumbsSwiper.activeIndex;
          var newThumbsIndex;
          var direction;
  
          if (thumbsSwiper.params.loop) {
            if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
              thumbsSwiper.loopFix(); // eslint-disable-next-line
  
              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
              currentThumbsIndex = thumbsSwiper.activeIndex;
            } // Find actual thumbs index to slide to
  
  
            var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
            var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
            if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
            direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
          } else {
            newThumbsIndex = swiper.realIndex;
            direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
          }
  
          if (useOffset) {
            newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
          }
  
          if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - slidesPerView + 1;
            }
  
            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
          }
        } // Activate thumbs
  
  
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
  
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }
  
        if (!swiper.params.thumbs.multipleActiveThumbs) {
          thumbsToActivate = 1;
        }
  
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
  
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
          for (var i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
          }
        } else {
          for (var _i = 0; _i < thumbsToActivate; _i += 1) {
            thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
          }
        }
      }
    };
    var Thumbs$1 = {
      name: 'thumbs',
      params: {
        thumbs: {
          swiper: null,
          multipleActiveThumbs: true,
          autoScrollOffset: 0,
          slideThumbActiveClass: 'swiper-slide-thumb-active',
          thumbsContainerClass: 'swiper-container-thumbs'
        }
      },
      create: function create() {
        var swiper = this;
        bindModuleMethods(swiper, {
          thumbs: _extends({
            swiper: null,
            initialized: false
          }, Thumbs)
        });
      },
      on: {
        beforeInit: function beforeInit(swiper) {
          var thumbs = swiper.params.thumbs;
          if (!thumbs || !thumbs.swiper) return;
          swiper.thumbs.init();
          swiper.thumbs.update(true);
        },
        slideChange: function slideChange(swiper) {
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        update: function update(swiper) {
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        resize: function resize(swiper) {
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate(swiper) {
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        setTransition: function setTransition(swiper, duration) {
          var thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) return;
          thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy(swiper) {
          var thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) return;
  
          if (swiper.thumbs.swiperCreated && thumbsSwiper) {
            thumbsSwiper.destroy();
          }
        }
      }
    };
  
    // Swiper Class
    var components = [Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y$1, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];
    Swiper.use(components);
  
    return Swiper;
  
  })));
  //# sourceMappingURL=swiper-bundle.js.map
/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.10
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
 !function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("whatInput",[],t):"object"==typeof exports?exports.whatInput=t():e.whatInput=t()}(this,function(){return i={},n.m=o=[function(e,t){"use strict";e.exports=function(){if("undefined"==typeof document||"undefined"==typeof window)return{ask:function(){return"initial"},element:function(){return null},ignoreKeys:function(){},specificKeys:function(){},registerOnChange:function(){},unRegisterOnChange:function(){}};var t=document.documentElement,n=null,s="initial",u=s,o=Date.now(),i="false",d=["button","input","select","textarea"],r=[],c=[16,17,18,91,93],w=[],p={keydown:"keyboard",keyup:"keyboard",mousedown:"mouse",mousemove:"mouse",MSPointerDown:"pointer",MSPointerMove:"pointer",pointerdown:"pointer",pointermove:"pointer",touchstart:"touch",touchend:"touch"},a=!1,f={x:null,y:null},l={2:"touch",3:"touch",4:"mouse"},m=!1;try{var e=Object.defineProperty({},"passive",{get:function(){m=!0}});window.addEventListener("test",null,e)}catch(e){}var h=function(){var e=!!m&&{passive:!0};document.addEventListener("DOMContentLoaded",v),window.PointerEvent?(window.addEventListener("pointerdown",y),window.addEventListener("pointermove",E)):window.MSPointerEvent?(window.addEventListener("MSPointerDown",y),window.addEventListener("MSPointerMove",E)):(window.addEventListener("mousedown",y),window.addEventListener("mousemove",E),"ontouchstart"in window&&(window.addEventListener("touchstart",y,e),window.addEventListener("touchend",y))),window.addEventListener(O(),E,e),window.addEventListener("keydown",y),window.addEventListener("keyup",y),window.addEventListener("focusin",L),window.addEventListener("focusout",b)},v=function(){if(i=!(t.getAttribute("data-whatpersist")||"false"===document.body.getAttribute("data-whatpersist")))try{window.sessionStorage.getItem("what-input")&&(s=window.sessionStorage.getItem("what-input")),window.sessionStorage.getItem("what-intent")&&(u=window.sessionStorage.getItem("what-intent"))}catch(e){}g("input"),g("intent")},y=function(e){var t=e.which,n=p[e.type];"pointer"===n&&(n=S(e));var o=!w.length&&-1===c.indexOf(t),i=w.length&&-1!==w.indexOf(t),r="keyboard"===n&&t&&(o||i)||"mouse"===n||"touch"===n;if(M(n)&&(r=!1),r&&s!==n&&(x("input",s=n),g("input")),r&&u!==n){var a=document.activeElement;a&&a.nodeName&&(-1===d.indexOf(a.nodeName.toLowerCase())||"button"===a.nodeName.toLowerCase()&&!C(a,"form"))&&(x("intent",u=n),g("intent"))}},g=function(e){t.setAttribute("data-what"+e,"input"===e?s:u),k(e)},E=function(e){var t=p[e.type];"pointer"===t&&(t=S(e)),A(e),(!a&&!M(t)||a&&"wheel"===e.type||"mousewheel"===e.type||"DOMMouseScroll"===e.type)&&u!==t&&(x("intent",u=t),g("intent"))},L=function(e){e.target.nodeName?(n=e.target.nodeName.toLowerCase(),t.setAttribute("data-whatelement",n),e.target.classList&&e.target.classList.length&&t.setAttribute("data-whatclasses",e.target.classList.toString().replace(" ",","))):b()},b=function(){n=null,t.removeAttribute("data-whatelement"),t.removeAttribute("data-whatclasses")},x=function(e,t){if(i)try{window.sessionStorage.setItem("what-"+e,t)}catch(e){}},S=function(e){return"number"==typeof e.pointerType?l[e.pointerType]:"pen"===e.pointerType?"touch":e.pointerType},M=function(e){var t=Date.now(),n="mouse"===e&&"touch"===s&&t-o<200;return o=t,n},O=function(){return"onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll"},k=function(e){for(var t=0,n=r.length;t<n;t++)r[t].type===e&&r[t].fn.call(void 0,"input"===e?s:u)},A=function(e){f.x!==e.screenX||f.y!==e.screenY?(a=!1,f.x=e.screenX,f.y=e.screenY):a=!0},C=function(e,t){var n=window.Element.prototype;if(n.matches||(n.matches=n.msMatchesSelector||n.webkitMatchesSelector),n.closest)return e.closest(t);do{if(e.matches(t))return e;e=e.parentElement||e.parentNode}while(null!==e&&1===e.nodeType);return null};return"addEventListener"in window&&Array.prototype.indexOf&&(p[O()]="mouse",h()),{ask:function(e){return"intent"===e?u:s},element:function(){return n},ignoreKeys:function(e){c=e},specificKeys:function(e){w=e},registerOnChange:function(e,t){r.push({fn:e,type:t||"input"})},unRegisterOnChange:function(e){var t=function(e){for(var t=0,n=r.length;t<n;t++)if(r[t].fn===e)return t}(e);!t&&0!==t||r.splice(t,1)},clearStorage:function(){window.sessionStorage.clear()}}}()}],n.c=i,n.p="",n(0);function n(e){if(i[e])return i[e].exports;var t=i[e]={exports:{},id:e,loaded:!1};return o[e].call(t.exports,t,t.exports,n),t.loaded=!0,t.exports}var o,i});
 //# sourceMappingURL=what-input.min.js.map
 